import { Day } from '../helpers/day';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: Day;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

export enum ActionStatus {
  Booked = 'Booked',
  Called = 'Called',
  CalledSecondTime = 'CalledSecondTime',
  New = 'New',
  NonResponsive = 'NonResponsive',
  Rejected = 'Rejected'
}

export type ActivePatient = {
  __typename?: 'ActivePatient';
  adherenceLetterSent: Scalars['Boolean'];
  clinicalStatus: Scalars['String'];
  daysSinceLastVisit?: Maybe<Scalars['Int']>;
  dob: Scalars['DateTime'];
  dutyOfCareCountdown?: Maybe<Scalars['Int']>;
  ecwChartStatus: EcwChartStatus;
  email?: Maybe<Scalars['String']>;
  externalMrn?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  isAdherenceLetterSentWithinTwoDays?: Maybe<Scalars['Boolean']>;
  isDischargeLetterSentWithinTwoDays?: Maybe<Scalars['Boolean']>;
  itxRequests: Array<ItxRequest>;
  lastCompletedAppointment?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  lastProviderEmail: Scalars['String'];
  lastProviderName: Scalars['String'];
  lastProviderNpi: Scalars['ID'];
  mrn: Scalars['String'];
  nextAppointment?: Maybe<Scalars['DateTime']>;
  primaryDiagnoses: Array<Scalars['String']>;
  recommendedAction: Scalars['String'];
  secondaryDiagnoses: Array<Scalars['String']>;
  transferStatus: Scalars['String'];
};

export type AgeGroup = {
  __typename?: 'AgeGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
  rangeEnd?: Maybe<Scalars['Int']>;
  rangeStart: Scalars['Int'];
};

export type AgeGroupInput = {
  id: Scalars['ID'];
};

export type Appointment = {
  __typename?: 'Appointment';
  duration: Scalars['Int'];
  ehrProviderNpi: Scalars['String'];
  id: Scalars['ID'];
  patient: Patient;
  provider?: Maybe<AppointmentProvider>;
  startTime: Scalars['DateTime'];
  visitType?: Maybe<Scalars['String']>;
};

export type AppointmentProvider = {
  __typename?: 'AppointmentProvider';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  npi?: Maybe<Scalars['String']>;
  primaryCredential?: Maybe<Scalars['String']>;
};

export enum AppointmentStatus {
  Pending = 'Pending',
  PendingScreen = 'PendingScreen',
  PendingVerification = 'PendingVerification'
}

export type Assessment = {
  __typename?: 'Assessment';
  answerValue?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  questionCode?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AssessmentAnswerInput = {
  answerValue: Scalars['String'];
  questionCode: Scalars['String'];
};

export type AssessmentCreateInput = {
  answerValue: Scalars['String'];
  questionCode: Scalars['String'];
  section: SectionName;
  sessionPatientId: Scalars['String'];
};

export type AuthenticatedAssessment = {
  __typename?: 'AuthenticatedAssessment';
  documentId?: Maybe<Scalars['String']>;
  questionCode?: Maybe<Scalars['String']>;
  sessionPatientId: Scalars['ID'];
  shortCode?: Maybe<Scalars['String']>;
};

export type BookAppointmentInput = {
  endTime: Scalars['DateTime'];
  providerId: Scalars['String'];
  providerNpi: Scalars['String'];
  startTime: Scalars['DateTime'];
  wasProviderAdditionalMatch?: InputMaybe<Scalars['Boolean']>;
};

export type BookingResult = {
  __typename?: 'BookingResult';
  ehrEncounterId?: Maybe<Scalars['String']>;
};

export type Carrier = {
  __typename?: 'Carrier';
  id: Scalars['ID'];
  isInNetwork: Scalars['Boolean'];
  medallionName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentCarrierId?: Maybe<Scalars['ID']>;
};

export type CarrierInput = {
  id: Scalars['ID'];
  isInNetwork?: InputMaybe<Scalars['Boolean']>;
  medallionName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parentCarrierId?: InputMaybe<Scalars['Int']>;
};

export type CheckProviderMatch = {
  __typename?: 'CheckProviderMatch';
  isZDProviderAMatch: Scalars['Boolean'];
  matchedProviders?: Maybe<Array<MatchResult>>;
  patientMatchFailureReasons?: Maybe<Array<PatientShouldNotBeMatchedReason>>;
  zdProviderDealbreakersForPatientReasons?: Maybe<Array<Scalars['String']>>;
  zdProviderMatchFailureReasons?: Maybe<Array<ProviderNotMatchReason>>;
  zocdocAppointment: ZocdocAppointment;
  zocdocProvider: Provider;
};

export type CityStateAutofill = {
  __typename?: 'CityStateAutofill';
  city?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type ClearAssessmentResponseInput = {
  questionCode: Scalars['String'];
  section?: InputMaybe<SectionName>;
};

export type CreateReferralInput = {
  addressState: Scalars['String'];
  birthDate: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  guardianFirstName?: InputMaybe<Scalars['String']>;
  guardianLastName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  patientIsMinor?: InputMaybe<Scalars['Boolean']>;
  patientPhone: Scalars['String'];
  practiceName: Scalars['String'];
  practiceType: Scalars['String'];
  providerEmail: Scalars['String'];
  providerFirstName: Scalars['String'];
  providerLastName: Scalars['String'];
  reasonForReferral: Scalars['String'];
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  diagnosisCodeRegex: Scalars['String'];
  name: Scalars['String'];
};

export enum DischargeLetterTemplate {
  Adherence = 'ADHERENCE',
  AlternateLocInPerson = 'ALTERNATE_LOC_IN_PERSON',
  AlternateLocOther = 'ALTERNATE_LOC_OTHER',
  CompletedTreatment = 'COMPLETED_TREATMENT',
  ConductSexual = 'CONDUCT_SEXUAL',
  ConductVerbal = 'CONDUCT_VERBAL',
  ItxNoMatch = 'ITX_NO_MATCH',
  LostFollowUp = 'LOST_FOLLOW_UP',
  MissedAppointments = 'MISSED_APPOINTMENTS',
  NotLicensed = 'NOT_LICENSED',
  PatientDecisionClinical = 'PATIENT_DECISION_CLINICAL',
  PatientDecisionOther = 'PATIENT_DECISION_OTHER',
  ProviderNonAdherence = 'PROVIDER_NON_ADHERENCE',
  ProviderPatientDecision = 'PROVIDER_PATIENT_DECISION',
  RefusingTreatment = 'REFUSING_TREATMENT',
  TerminationNoTransferMatch = 'TERMINATION_NO_TRANSFER_MATCH'
}

export type Document = {
  __typename?: 'Document';
  actionStatus?: Maybe<ActionStatus>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<DocumentDetails>;
  events?: Maybe<Array<Event>>;
  files: Array<File>;
  id: Scalars['ID'];
  patient: Patient;
  sessionPatientId: Scalars['ID'];
  status?: Maybe<DocumentStatus>;
  terminationReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentDetails = {
  __typename?: 'DocumentDetails';
  id?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  status?: InputMaybe<DocumentStatus>;
  terminationReason?: InputMaybe<TerminationReason>;
};

export enum DocumentStatus {
  ActionNeeded = 'ActionNeeded',
  Archived = 'Archived',
  Completed = 'Completed',
  Incomplete = 'Incomplete',
  Matched = 'Matched'
}

export type DocumentUploadInput = {
  completed?: InputMaybe<Scalars['Boolean']>;
  files?: InputMaybe<Array<FileInput>>;
  id?: InputMaybe<Scalars['ID']>;
  patient?: InputMaybe<PatientInput>;
};

export type DocumentUploadInternalInput = {
  files?: InputMaybe<Array<FileInput>>;
  id?: InputMaybe<Scalars['ID']>;
};

export enum EcwChartStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type EditPatientGuardiansInput = {
  primary: PatientGuardianInput;
  secondary?: InputMaybe<PatientGuardianInput>;
};

export type EditPatientInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  mrn: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type EmptyResponse = {
  __typename?: 'EmptyResponse';
  ok: Scalars['Boolean'];
};

export type Event = {
  __typename?: 'Event';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByEmail?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  details?: Maybe<EventDetails>;
  documentId?: Maybe<Scalars['String']>;
  eventDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type EventDetails = {
  __typename?: 'EventDetails';
  notes?: Maybe<Scalars['String']>;
};

export enum EventType {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export type File = {
  __typename?: 'File';
  directUrl?: Maybe<Scalars['String']>;
  ecwSyncStatus?: Maybe<Scalars['String']>;
  ecwUploadedAt?: Maybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  id: Scalars['ID'];
  lastEcwSyncAttempt?: Maybe<Scalars['DateTime']>;
  type: FileType;
};

export type FileInput = {
  fileName: Scalars['String'];
  id: Scalars['ID'];
  type?: InputMaybe<FileType>;
};

export enum FileType {
  HipaaForm = 'HIPAAForm',
  InsuranceCard = 'InsuranceCard',
  Intake = 'Intake',
  MedicalRecord = 'MedicalRecord',
  PhotoId = 'PhotoID'
}

export type FindAppointmentsInput = {
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<AppointmentStatus>;
};

export type FindPatientsInput = {
  query?: InputMaybe<Scalars['String']>;
};

export type GetPatientInput = {
  id?: InputMaybe<Scalars['String']>;
  mrn?: InputMaybe<Scalars['String']>;
};

export type InsuranceCarrier = {
  __typename?: 'InsuranceCarrier';
  insuranceCarrierParentId?: Maybe<Scalars['Int']>;
  isInNetwork: Scalars['Boolean'];
  medallionName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InsurancePayer = {
  __typename?: 'InsurancePayer';
  id: Scalars['Int'];
  isPriority?: Maybe<Scalars['Boolean']>;
  networkStatus?: Maybe<Scalars['String']>;
  payerName?: Maybe<Scalars['String']>;
};

export type InsurancePayerPlanMap = {
  __typename?: 'InsurancePayerPlanMap';
  changeHealthcarePayerId?: Maybe<Scalars['String']>;
  changeHealthcarePayerName?: Maybe<Scalars['String']>;
  contractedInsuranceName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  insuranceTier?: Maybe<Scalars['String']>;
  isPriority?: Maybe<Scalars['Boolean']>;
  networkStatus?: Maybe<Scalars['String']>;
  payerName?: Maybe<Scalars['String']>;
  payerPlans?: Maybe<Scalars['String']>;
  processingPlanName?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  subscriberIdPrefix?: Maybe<Scalars['String']>;
};

export type InsurancePayerPlanMapFilterOptions = {
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type InsurancePayerPlanMapPage = {
  __typename?: 'InsurancePayerPlanMapPage';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  items: Array<InsurancePayerPlanMap>;
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type InsurancePayerPlanMapPageOptions = {
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
};

export enum InsurancePlanStatus {
  In = 'IN',
  Oon = 'OON',
  Unknown = 'UNKNOWN'
}

export type Intake = {
  __typename?: 'Intake';
  actionStatus?: Maybe<ActionStatus>;
  addressCity?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  assigneeName?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ecwManualSyncedFileCount?: Maybe<Scalars['Int']>;
  ecwPendingFileCount?: Maybe<Scalars['Int']>;
  ecwSyncedFileCount?: Maybe<Scalars['Int']>;
  ecwTimeoutFileCount?: Maybe<Scalars['Int']>;
  ehrEncounterId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fileCount?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  hasAppt?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mainReasons?: Maybe<Scalars['String']>;
  mentalHealthCoverage?: Maybe<NirvanaPlanStatus>;
  middleName?: Maybe<Scalars['String']>;
  mrn?: Maybe<Scalars['Int']>;
  msBookingCount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  planNetworkStatus?: Maybe<InsurancePlanStatus>;
  planStatus?: Maybe<NirvanaPlanStatus>;
  providerId?: Maybe<Scalars['ID']>;
  referralSource?: Maybe<Scalars['String']>;
  secondaryReasons?: Maybe<Scalars['String']>;
  sessionPatientId: Scalars['ID'];
  shortCode?: Maybe<Scalars['String']>;
  specialtyCare?: Maybe<Scalars['String']>;
  status?: Maybe<DocumentStatus>;
  terminationReason?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadedDocumentId?: Maybe<Scalars['ID']>;
  wasReferredByZocdoc?: Maybe<Scalars['Boolean']>;
};

export type IntakeBadgesInput = {
  bookedThroughHealowOrZocdoc?: InputMaybe<Scalars['Boolean']>;
  bookedThroughScheduling?: InputMaybe<Scalars['Boolean']>;
  bookedThroughZocdoc?: InputMaybe<Scalars['Boolean']>;
  msBooking?: InputMaybe<Scalars['Boolean']>;
};

export type IntakeClaim = {
  __typename?: 'IntakeClaim';
  assigneeEmail: Scalars['String'];
  assigneeName: Scalars['String'];
  id: Scalars['ID'];
  uploadedDocumentId: Scalars['ID'];
};

export enum IntakeDocumentsStatus {
  HasDocuments = 'HasDocuments',
  NoDocuments = 'NoDocuments',
  Pending = 'Pending',
  Synced = 'Synced',
  Timeout = 'Timeout'
}

export type IntakeFilterOptions = {
  actionStatuses?: InputMaybe<Array<ActionStatus>>;
  ageRangeEnd?: InputMaybe<Scalars['Int']>;
  ageRangeStart?: InputMaybe<Scalars['Int']>;
  assigneeName?: InputMaybe<Scalars['String']>;
  badges?: InputMaybe<IntakeBadgesInput>;
  birthDate?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<Scalars['String']>>;
  documentsStatus?: InputMaybe<IntakeDocumentsStatus>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mrn?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  secondaryConditions?: InputMaybe<Array<Scalars['String']>>;
  shortCode?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  specialties?: InputMaybe<Array<Scalars['String']>>;
  stateCodes?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<DocumentStatus>;
};

export type IntakePage = Page & {
  __typename?: 'IntakePage';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  items: Array<Intake>;
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ItxProviderMatch = {
  __typename?: 'ItxProviderMatch';
  id: Scalars['ID'];
  itxRequest: ItxRequest;
  patient: Patient;
  provider: Provider;
  rejectedAt?: Maybe<Scalars['DateTime']>;
};

export type ItxRequest = {
  __typename?: 'ItxRequest';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  acceptingProviderNpi?: Maybe<Scalars['String']>;
  clinicianNotes?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  expiration?: Maybe<Scalars['DateTime']>;
  hasProviderMatches?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  markedAsIneligibleAt?: Maybe<Scalars['DateTime']>;
  patient: Patient;
  patientMrn: Scalars['String'];
  processedAt?: Maybe<Scalars['DateTime']>;
  reasonForIneligible?: Maybe<Scalars['String']>;
  reasonForTransfer?: Maybe<Scalars['String']>;
  requestingProvider: Provider;
  requestingProviderNpi: Scalars['String'];
  scheduleRequest?: Maybe<ScheduleRequest>;
  specialties?: Maybe<Array<Maybe<Specialty>>>;
};

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type LanguageInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  certificationType: Scalars['String'];
  stateCode: Scalars['String'];
};

export type MatchInput = {
  ehrPatientId: Scalars['String'];
  sessionPatientId: Scalars['String'];
};

export type MatchResult = {
  __typename?: 'MatchResult';
  provider: Provider;
  scores?: Maybe<Array<Scalars['Int']>>;
};

export type Medication = {
  __typename?: 'Medication';
  dosage?: Maybe<Scalars['String']>;
  drugSchedule?: Maybe<Scalars['String']>;
  encounterDate: Scalars['String'];
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  medicationName: Scalars['String'];
  medicationOrderNumber: Scalars['String'];
  patientMrn: Scalars['String'];
  strength?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTransferRequest?: Maybe<ItxRequest>;
  bookAppointment: BookingResult;
  cancelAppointment: EmptyResponse;
  cancelTransferRequest?: Maybe<ItxRequest>;
  claimIntake: IntakeClaim;
  clearAssessmentResponse?: Maybe<EmptyResponse>;
  createConsultNotAFit?: Maybe<EmptyResponse>;
  createInsurancePayerPlanMap: InsurancePayerPlanMap;
  createReferral: EmptyResponse;
  createScheduleRequest: ScheduleRequest;
  createScheduleRequests: Array<Maybe<ScheduleRequest>>;
  createSupportTicket: EmptyResponse;
  createTransferRequest?: Maybe<ItxRequest>;
  deleteInsurancePayerPlanMap: EmptyResponse;
  editPatient?: Maybe<Patient>;
  editPatientEmergencyContact?: Maybe<EmptyResponse>;
  editPatientGuardians?: Maybe<EmptyResponse>;
  editPatientPharmacy?: Maybe<EmptyResponse>;
  editPatientPrimaryPolicyholder?: Maybe<EmptyResponse>;
  matchWithPatient: Patient;
  patientAssignProviderMatch?: Maybe<EmptyResponse>;
  pccAssignProviderMatch?: Maybe<Patient>;
  rejectItxProviderMatch?: Maybe<EmptyResponse>;
  requestAppointment: EmptyResponse;
  rescheduleAppointment: EmptyResponse;
  sendPatientDischargeLetter?: Maybe<PatientDischargeLetter>;
  startAdherenceOutreach?: Maybe<PatientAdherenceOutreach>;
  unclaimIntake: EmptyResponse;
  updateAssessmentAnswers?: Maybe<EmptyResponse>;
  updateCarrier: Carrier;
  updateDocument: Document;
  updateDocumentManualSyncedStatus?: Maybe<Array<Maybe<File>>>;
  updateDocumentUpload?: Maybe<UnauthenticatedEntity>;
  updateDocumentUploadActionInternal?: Maybe<Document>;
  updateDocumentUploadActionOpenSearch?: Maybe<Document>;
  updateDocumentUploadDetails: Document;
  updateDocumentUploadInternal?: Maybe<Patient>;
  updateGoogleClickId?: Maybe<Patient>;
  updateInsurancePayerPlanMap: InsurancePayerPlanMap;
  updatePatientConsentReferrerSharing?: Maybe<EmptyResponse>;
  updatePatientDemographics?: Maybe<Patient>;
  updateProvider?: Maybe<Provider>;
  updateReferenceInsurancePlan: ReferenceInsurancePlan;
  updateSettings: Array<Setting>;
  updateSignedDocument?: Maybe<UnauthenticatedEntity>;
  updateValidatedScale?: Maybe<UnauthenticatedEntity>;
  writeBackDemographics?: Maybe<Patient>;
};


export type MutationAcceptTransferRequestArgs = {
  acceptingProviderNpi: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationBookAppointmentArgs = {
  input: BookAppointmentInput;
};


export type MutationCancelAppointmentArgs = {
  scheduleRequestId: Scalars['ID'];
};


export type MutationCancelTransferRequestArgs = {
  id: Scalars['ID'];
};


export type MutationClaimIntakeArgs = {
  uploadedDocumentId: Scalars['ID'];
};


export type MutationClearAssessmentResponseArgs = {
  input?: InputMaybe<ClearAssessmentResponseInput>;
};


export type MutationCreateConsultNotAFitArgs = {
  clinicianNotes: Scalars['String'];
  mrn: Scalars['String'];
  reasonForCnaf: Scalars['String'];
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateScheduleRequestArgs = {
  input: ScheduleRequestInput;
};


export type MutationCreateScheduleRequestsArgs = {
  inputs: Array<ScheduleRequestInput>;
};


export type MutationCreateSupportTicketArgs = {
  href: Scalars['String'];
  image: Scalars['String'];
  screenDescription: Scalars['String'];
  stepsAttempted: Scalars['String'];
  troubleshootingSteps: Scalars['String'];
};


export type MutationCreateTransferRequestArgs = {
  clinicianNotes: Scalars['String'];
  directTransferNpi?: InputMaybe<Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  initiator: Scalars['String'];
  patientMrn: Scalars['String'];
  reasonForTransfer: Scalars['String'];
  requestingProviderNpi: Scalars['String'];
  specialtyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationDeleteInsurancePayerPlanMapArgs = {
  id: Scalars['Int'];
};


export type MutationEditPatientArgs = {
  input?: InputMaybe<EditPatientInput>;
};


export type MutationEditPatientEmergencyContactArgs = {
  input: PatientEmergencyContactInput;
};


export type MutationEditPatientGuardiansArgs = {
  input: EditPatientGuardiansInput;
};


export type MutationEditPatientPharmacyArgs = {
  input?: InputMaybe<PatientPharmacyInput>;
};


export type MutationEditPatientPrimaryPolicyholderArgs = {
  input?: InputMaybe<PatientPrimaryPolicyholderInput>;
};


export type MutationMatchWithPatientArgs = {
  input: MatchInput;
};


export type MutationPatientAssignProviderMatchArgs = {
  providerId?: InputMaybe<Scalars['ID']>;
  sessionPatientId: Scalars['ID'];
};


export type MutationPccAssignProviderMatchArgs = {
  providerId?: InputMaybe<Scalars['ID']>;
  sessionPatientId: Scalars['ID'];
};


export type MutationRejectItxProviderMatchArgs = {
  id: Scalars['ID'];
  rejectionComments?: InputMaybe<Scalars['String']>;
  rejectionReason: Scalars['String'];
};


export type MutationRequestAppointmentArgs = {
  appointmentStartTime: Scalars['DateTime'];
  scheduleRequestId: Scalars['ID'];
};


export type MutationRescheduleAppointmentArgs = {
  appointmentStartTime: Scalars['DateTime'];
  scheduleRequestId: Scalars['ID'];
};


export type MutationSendPatientDischargeLetterArgs = {
  clinicianNotes?: InputMaybe<Scalars['String']>;
  externalMrn?: InputMaybe<Scalars['String']>;
  lastProviderName: Scalars['String'];
  lastProviderNpi: Scalars['ID'];
  patientBirthDate: Scalars['String'];
  patientEmail: Scalars['String'];
  patientFirstName: Scalars['String'];
  patientLastName: Scalars['String'];
  patientMrn: Scalars['String'];
  template: DischargeLetterTemplate;
};


export type MutationStartAdherenceOutreachArgs = {
  lastProviderNpi: Scalars['String'];
  patientMrn: Scalars['String'];
};


export type MutationUnclaimIntakeArgs = {
  uploadedDocumentId: Scalars['ID'];
};


export type MutationUpdateAssessmentAnswersArgs = {
  input?: InputMaybe<UpdateAssessmentAnswersInput>;
};


export type MutationUpdateCarrierArgs = {
  input: CarrierInput;
};


export type MutationUpdateDocumentArgs = {
  input: DocumentInput;
};


export type MutationUpdateDocumentManualSyncedStatusArgs = {
  documentId: Scalars['ID'];
  synced: Scalars['Boolean'];
};


export type MutationUpdateDocumentUploadArgs = {
  input?: InputMaybe<DocumentUploadInput>;
};


export type MutationUpdateDocumentUploadActionInternalArgs = {
  actionStatus?: InputMaybe<ActionStatus>;
  id?: InputMaybe<Scalars['ID']>;
  terminationReason?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDocumentUploadActionOpenSearchArgs = {
  actionStatus?: InputMaybe<ActionStatus>;
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateDocumentUploadDetailsArgs = {
  documentId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDocumentUploadInternalArgs = {
  input?: InputMaybe<DocumentUploadInternalInput>;
};


export type MutationUpdateGoogleClickIdArgs = {
  googleClickId: Scalars['String'];
};


export type MutationUpdateInsurancePayerPlanMapArgs = {
  input: UpdateInsurancePayerPlanMapInput;
};


export type MutationUpdatePatientConsentReferrerSharingArgs = {
  consentReferrerSharing: Scalars['Boolean'];
};


export type MutationUpdatePatientDemographicsArgs = {
  input?: InputMaybe<PatientInput>;
};


export type MutationUpdateProviderArgs = {
  input: ProviderInput;
  source?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateReferenceInsurancePlanArgs = {
  input: ReferenceInsurancePlanInput;
};


export type MutationUpdateSettingsArgs = {
  input: Array<SettingInput>;
};


export type MutationUpdateSignedDocumentArgs = {
  input?: InputMaybe<SignedFormInput>;
};


export type MutationUpdateValidatedScaleArgs = {
  input?: InputMaybe<ValidatedScaleInput>;
};


export type MutationWriteBackDemographicsArgs = {
  input?: InputMaybe<WriteBackDemographicsInput>;
};

export enum NirvanaPlanStatus {
  Active = 'ACTIVE',
  ActiveAtRisk = 'ACTIVE_AT_RISK',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export enum OnlineMatchingStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type Page = {
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PageOptions = {
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
};

export type Patient = {
  __typename?: 'Patient';
  addressCity?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  appointments: Array<Appointment>;
  assessments?: Maybe<Array<Assessment>>;
  birthDate?: Maybe<Scalars['Date']>;
  diagnoses: Array<RedoxDiagnosis>;
  document?: Maybe<Document>;
  ehrEncounterId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<PatientEmergencyContact>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastEntry?: Maybe<Patient>;
  lastName?: Maybe<Scalars['String']>;
  machineVersion?: Maybe<Scalars['Int']>;
  matchesLastEntry?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mrn?: Maybe<Scalars['String']>;
  patientGuardians?: Maybe<Array<Maybe<PatientGuardian>>>;
  pharmacy?: Maybe<PatientPharmacy>;
  phone?: Maybe<Scalars['String']>;
  providerMatch?: Maybe<ProviderMatch>;
  referralSource?: Maybe<Scalars['String']>;
  scales?: Maybe<Array<ValidatedScale>>;
  sex?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  smsOptIn?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  wasReferredByZocdoc?: Maybe<Scalars['Boolean']>;
  zocdocAppointment?: Maybe<ZocdocAppointment>;
};

export type PatientAdherenceOutreach = {
  __typename?: 'PatientAdherenceOutreach';
  createdByEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  patientMrn: Scalars['String'];
  providerId: Scalars['String'];
};

export type PatientDischargeLetter = {
  __typename?: 'PatientDischargeLetter';
  clinicianNotes?: Maybe<Scalars['String']>;
  createdByEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  patientMrn: Scalars['String'];
  providerId: Scalars['ID'];
  template: DischargeLetterTemplate;
};

export type PatientEmergencyContact = {
  __typename?: 'PatientEmergencyContact';
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  relation: Scalars['String'];
};

export type PatientEmergencyContactInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  relation: Scalars['String'];
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};

export type PatientGuardian = {
  __typename?: 'PatientGuardian';
  addressCity?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  consentForMinor?: Maybe<Scalars['Boolean']>;
  discoveryChannel?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  isAddressLinkedWithPatient: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  precedence: Precedence;
  relationToPatient: Scalars['String'];
};

export type PatientGuardianInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  consentForMinor?: InputMaybe<Scalars['Boolean']>;
  discoveryChannel?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isAddressLinkedWithPatient: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  precedence: Precedence;
  relationToPatient: Scalars['String'];
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};

export type PatientInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['String']>;
  discoveryChannel?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  patientPronouns?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  shortCode?: InputMaybe<Scalars['String']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  soharVerified?: InputMaybe<Scalars['Boolean']>;
  wasReferredByZocdoc?: InputMaybe<Scalars['Boolean']>;
};

export type PatientMatchResult = {
  __typename?: 'PatientMatchResult';
  patientMatchFailureReasons: Array<PatientShouldNotBeMatchedReason>;
  providers?: Maybe<Array<MatchResult>>;
};

export type PatientPharmacy = {
  __typename?: 'PatientPharmacy';
  addressCity?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  sessionPatientId: Scalars['ID'];
};

export type PatientPharmacyInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};

export type PatientPrimaryPolicyholder = {
  __typename?: 'PatientPrimaryPolicyholder';
  addressCity?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  addressZipCode?: Maybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  customRelation?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isAddressLinkedWithPatient?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  relationToPatient?: Maybe<Scalars['String']>;
  sessionPatientId: Scalars['ID'];
};

export type PatientPrimaryPolicyholderInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressZipCode?: InputMaybe<Scalars['String']>;
  birthDate: Scalars['DateTime'];
  customRelation?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  isAddressLinkedWithPatient?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  relationToPatient?: InputMaybe<Scalars['String']>;
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};

export enum PatientShouldNotBeMatchedReason {
  HasMedicare = 'HAS_MEDICARE',
  HasOonPlan = 'HAS_OON_PLAN',
  Minor = 'MINOR',
  NotOpenToTakingMedication = 'NOT_OPEN_TO_TAKING_MEDICATION',
  NoReasonsSelected = 'NO_REASONS_SELECTED'
}

export type PlanAutofill = {
  __typename?: 'PlanAutofill';
  carrier?: Maybe<Scalars['String']>;
  inNetwork?: Maybe<Scalars['Boolean']>;
  insuranceCarrierId?: Maybe<Scalars['Int']>;
  isOutOfStateNeeded?: Maybe<Scalars['Boolean']>;
  isReferralNeeded?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
};

export type PlansFilterOptions = {
  planName?: InputMaybe<Scalars['String']>;
};

export type Practice = {
  __typename?: 'Practice';
  stateCode: Scalars['String'];
};

export enum Precedence {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export type PresignedPost = {
  __typename?: 'PresignedPost';
  fields?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Provider = {
  __typename?: 'Provider';
  ageGroups?: Maybe<Array<AgeGroup>>;
  biography?: Maybe<Scalars['String']>;
  calendarUrl?: Maybe<Scalars['String']>;
  certification?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  graduatedAt?: Maybe<Scalars['DateTime']>;
  healowCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnlineMatchingEnabled?: Maybe<Scalars['Boolean']>;
  isOnlineSchedulingEnabled?: Maybe<Scalars['Boolean']>;
  isOpenToTransfers?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Language>>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<License>>;
  medallionStartDate?: Maybe<Scalars['DateTime']>;
  modality?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  npDailyMax?: Maybe<Scalars['Int']>;
  npi?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  photoDetail?: Maybe<Scalars['String']>;
  placeholderUser?: Maybe<Scalars['Boolean']>;
  practices?: Maybe<Array<Practice>>;
  primaryCredential?: Maybe<Scalars['String']>;
  primaryPracticeState?: Maybe<Scalars['String']>;
  providerInsuranceCarriers?: Maybe<Array<ProviderInsuranceCarrier>>;
  providerTimeslots?: Maybe<Array<Timeslot>>;
  school?: Maybe<Scalars['String']>;
  specialties?: Maybe<Array<Specialty>>;
  treatmentMethods?: Maybe<Array<TreatmentMethod>>;
};

export type ProviderFilterOptions = {
  ageGroupId?: InputMaybe<Scalars['ID']>;
  carriers?: InputMaybe<Array<Scalars['String']>>;
  gender?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<Scalars['String']>>;
  onlineMatchingStatus?: InputMaybe<OnlineMatchingStatus>;
  primaryConditions?: InputMaybe<Array<Scalars['String']>>;
  secondaryConditions?: InputMaybe<Array<Scalars['String']>>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type ProviderFilterOptionsOpenSearch = {
  ageGroups?: InputMaybe<Scalars['String']>;
  carriers?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<Scalars['String']>>;
  onlineMatchingStatus?: InputMaybe<OnlineMatchingStatus>;
  primaryConditions?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  secondaryConditions?: InputMaybe<Array<Scalars['String']>>;
  specialties?: InputMaybe<Array<Scalars['String']>>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type ProviderHistory = {
  __typename?: 'ProviderHistory';
  createdAt?: Maybe<Scalars['DateTime']>;
  details: Scalars['JSON'];
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  providerId: Scalars['ID'];
  source?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProviderHistoryPage = Page & {
  __typename?: 'ProviderHistoryPage';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  items: Array<Maybe<ProviderHistory>>;
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ProviderInput = {
  ageGroups?: InputMaybe<Array<AgeGroupInput>>;
  biography?: InputMaybe<Scalars['String']>;
  calendarUrl?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  healowCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnlineMatchingEnabled?: InputMaybe<Scalars['Boolean']>;
  isOnlineSchedulingEnabled?: InputMaybe<Scalars['Boolean']>;
  isOpenToTransfers?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<LanguageInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  npDailyMax?: InputMaybe<Scalars['Int']>;
  photo?: InputMaybe<Scalars['String']>;
  primaryCredential?: InputMaybe<Scalars['String']>;
  providerInsuranceCarriers?: InputMaybe<Array<ProviderInsuranceCarrierInput>>;
  specialties?: InputMaybe<Array<SpecialtyInput>>;
  treatmentMethods?: InputMaybe<Array<TreatmentMethodInput>>;
};

export type ProviderInsuranceCarrier = {
  __typename?: 'ProviderInsuranceCarrier';
  insuranceCarrier?: Maybe<InsuranceCarrier>;
  provider?: Maybe<Provider>;
  stateCode?: Maybe<Scalars['String']>;
};

export type ProviderInsuranceCarrierInput = {
  insuranceCarrierId?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
  stateCode?: InputMaybe<Scalars['String']>;
};

export type ProviderMatch = {
  __typename?: 'ProviderMatch';
  assignedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  provider?: Maybe<Provider>;
  source?: Maybe<ProviderMatchSource>;
};

export enum ProviderMatchSource {
  ManualPcc = 'MANUAL_PCC',
  PatientSelection = 'PATIENT_SELECTION'
}

export enum ProviderNotMatchReason {
  CsDealbreaker = 'CS_DEALBREAKER',
  DoesNotPracticeInPatientState = 'DOES_NOT_PRACTICE_IN_PATIENT_STATE',
  DoesNotTreatAgeGroup = 'DOES_NOT_TREAT_AGE_GROUP',
  NoAvailableTimeslots = 'NO_AVAILABLE_TIMESLOTS',
  NoMedicalLicenseInPatientState = 'NO_MEDICAL_LICENSE_IN_PATIENT_STATE',
  ProviderNotActive = 'PROVIDER_NOT_ACTIVE',
  SpecialtyNotTreatedDealbreaker = 'SPECIALTY_NOT_TREATED_DEALBREAKER'
}

export type ProviderOpenSearch = {
  __typename?: 'ProviderOpenSearch';
  ageGroups?: Maybe<Array<AgeGroup>>;
  calendarUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isOnlineMatchingEnabled?: Maybe<Scalars['Boolean']>;
  isOnlineSchedulingEnabled?: Maybe<Scalars['Boolean']>;
  isOpenToTransfers?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Language>>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<License>>;
  medallionStartDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  npDailyMax?: Maybe<Scalars['Int']>;
  npi?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  practices?: Maybe<Array<Practice>>;
  primaryConditions?: Maybe<Array<Scalars['String']>>;
  primaryCredential?: Maybe<Scalars['String']>;
  primaryPracticeState?: Maybe<Scalars['String']>;
  providerInsuranceCarriers?: Maybe<Array<ProviderInsuranceCarrier>>;
  secondaryConditions?: Maybe<Array<Scalars['String']>>;
  specialties?: Maybe<Array<Specialty>>;
  treatmentMethods?: Maybe<Array<TreatmentMethod>>;
};

export type ProviderPage = Page & {
  __typename?: 'ProviderPage';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  items: Array<Provider>;
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type ProviderPageOpenSearch = Page & {
  __typename?: 'ProviderPageOpenSearch';
  hasNextPage: Scalars['Boolean'];
  hasPrevPage: Scalars['Boolean'];
  items: Array<ProviderOpenSearch>;
  pageNumber: Scalars['Int'];
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  checkZDProviderForMatch: CheckProviderMatch;
  findAppointments: Array<Appointment>;
  findPatients: Array<Patient>;
  getAcceptedItxRequests?: Maybe<Array<Maybe<ItxRequest>>>;
  getActivePatient: ActivePatient;
  getActivePatients: Array<ActivePatient>;
  getActivePatientsByMrns: Array<ActivePatient>;
  getAgeGroups?: Maybe<Array<AgeGroup>>;
  getAllItxProviderMatchesByNpi?: Maybe<Array<Maybe<ItxProviderMatch>>>;
  getAssessmentForCurrentUser?: Maybe<AuthenticatedAssessment>;
  getAvailableItxProviderMatches?: Maybe<Array<Maybe<ItxProviderMatch>>>;
  getAvailableTimeslotsForProvider: Array<Timeslot>;
  getCarriers: Array<Carrier>;
  getCityState: Array<CityStateAutofill>;
  getDBHealthCheck: EmptyResponse;
  getDiagnoses: Array<Diagnosis>;
  getHealthCheck: EmptyResponse;
  getInsurancePayerPlanMap: InsurancePayerPlanMapPage;
  getInsurancePayerPlanMapForAssessment: Array<InsurancePayerPlanMap>;
  getInsurancePayersForAssessment: Array<InsurancePayer>;
  getInsurancePlansForAssessment: Array<InsurancePayerPlanMap>;
  getIntakeBySessionPatientId?: Maybe<Intake>;
  getIntakeClaimByUploadedDocumentId?: Maybe<IntakeClaim>;
  getIntakes: IntakePage;
  getIntakesBySessionPatientIds: IntakePage;
  getIntakesFromOpenSearch: IntakePage;
  getItxProviderMatchById?: Maybe<ItxProviderMatch>;
  getItxRequest?: Maybe<ItxRequest>;
  getItxRequests?: Maybe<Array<Maybe<ItxRequest>>>;
  getLanguages?: Maybe<Array<Language>>;
  getMe?: Maybe<Patient>;
  getPatient?: Maybe<Patient>;
  getPatientDischargeLetter?: Maybe<Array<Maybe<PatientDischargeLetter>>>;
  getPatientMedications?: Maybe<Array<Maybe<Medication>>>;
  getPatientPrimaryPolicyHolder?: Maybe<PatientPrimaryPolicyholder>;
  getPlans: Array<PlanAutofill>;
  getProvider: Provider;
  getProviderByNpi: Provider;
  getProviderHistory: ProviderHistoryPage;
  getProviderMatches: PatientMatchResult;
  getProviders: ProviderPage;
  getProvidersForSearchbar: Array<Provider>;
  getProvidersFromOpenSearch: ProviderPageOpenSearch;
  getS3PresignedPost: PresignedPost;
  getScheduleRequest: ScheduleRequest;
  getSettingsForCategory: Array<Setting>;
  getSpecialties?: Maybe<Array<Specialty>>;
  getStates: Array<State>;
  getTreatmentMethods?: Maybe<Array<TreatmentMethod>>;
  getTreatmentPrerequisites?: Maybe<Array<TreatmentPrerequisite>>;
};


export type QueryFindAppointmentsArgs = {
  input?: InputMaybe<FindAppointmentsInput>;
};


export type QueryFindPatientsArgs = {
  input?: InputMaybe<FindPatientsInput>;
};


export type QueryGetAcceptedItxRequestsArgs = {
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivePatientArgs = {
  mrn: Scalars['String'];
};


export type QueryGetActivePatientsArgs = {
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivePatientsByMrnsArgs = {
  mrns: Array<Scalars['String']>;
};


export type QueryGetAllItxProviderMatchesByNpiArgs = {
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
};


export type QueryGetAvailableItxProviderMatchesArgs = {
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
};


export type QueryGetAvailableTimeslotsForProviderArgs = {
  absoluteDurationSeconds?: InputMaybe<Scalars['Int']>;
  checkForNpDailyMax: Scalars['Boolean'];
  endTime: Scalars['DateTime'];
  providerId: Scalars['String'];
  startTime: Scalars['DateTime'];
  timeslotDurationMinutes?: InputMaybe<Scalars['Int']>;
  timeslotVisitType?: InputMaybe<Scalars['String']>;
};


export type QueryGetCityStateArgs = {
  zipCode: Scalars['String'];
};


export type QueryGetInsurancePayerPlanMapArgs = {
  filterOptions: InsurancePayerPlanMapFilterOptions;
  pageOptions: InsurancePayerPlanMapPageOptions;
};


export type QueryGetInsurancePlansForAssessmentArgs = {
  payerName: Scalars['String'];
};


export type QueryGetIntakeBySessionPatientIdArgs = {
  sessionPatientId: Scalars['ID'];
};


export type QueryGetIntakeClaimByUploadedDocumentIdArgs = {
  uploadedDocumentId: Scalars['ID'];
};


export type QueryGetIntakesArgs = {
  filterOptions?: InputMaybe<IntakeFilterOptions>;
  pageOptions: PageOptions;
};


export type QueryGetIntakesBySessionPatientIdsArgs = {
  pageOptions: PageOptions;
  sessionPatientIds: Array<Scalars['ID']>;
};


export type QueryGetIntakesFromOpenSearchArgs = {
  filterOptions?: InputMaybe<IntakeFilterOptions>;
  pageOptions: PageOptions;
};


export type QueryGetItxProviderMatchByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetItxRequestArgs = {
  id: Scalars['ID'];
};


export type QueryGetItxRequestsArgs = {
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
};


export type QueryGetPatientArgs = {
  input?: InputMaybe<GetPatientInput>;
};


export type QueryGetPatientDischargeLetterArgs = {
  patientMrn: Scalars['String'];
};


export type QueryGetPatientMedicationsArgs = {
  patientMrn: Scalars['String'];
};


export type QueryGetPatientPrimaryPolicyHolderArgs = {
  sessionPatientId: Scalars['String'];
};


export type QueryGetPlansArgs = {
  carrier: Scalars['String'];
  filterOptions?: InputMaybe<PlansFilterOptions>;
};


export type QueryGetProviderArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetProviderByNpiArgs = {
  npi?: InputMaybe<Scalars['String']>;
};


export type QueryGetProviderHistoryArgs = {
  pageOptions: PageOptions;
  providerId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProviderMatchesArgs = {
  sessionPatientId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetProvidersArgs = {
  filterOptions?: InputMaybe<ProviderFilterOptions>;
  pageOptions: PageOptions;
};


export type QueryGetProvidersFromOpenSearchArgs = {
  filterOptions?: InputMaybe<ProviderFilterOptionsOpenSearch>;
  pageOptions: PageOptions;
};


export type QueryGetS3PresignedPostArgs = {
  fileName: Scalars['String'];
};


export type QueryGetScheduleRequestArgs = {
  scheduleRequestId: Scalars['ID'];
};


export type QueryGetSettingsForCategoryArgs = {
  category: Scalars['String'];
};

export type RedoxDiagnosis = {
  __typename?: 'RedoxDiagnosis';
  code: Scalars['String'];
  codeset: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReferenceInsurancePlan = {
  __typename?: 'ReferenceInsurancePlan';
  carrier: Scalars['String'];
  inNetwork: Scalars['Boolean'];
  insuranceCarrierId: Scalars['Int'];
  isOutOfStateNeeded: Scalars['Boolean'];
  isReferralNeeded: Scalars['Boolean'];
  notes: Scalars['String'];
  plan: Scalars['String'];
};

export type ReferenceInsurancePlanInput = {
  carrier: Scalars['String'];
  inNetwork: Scalars['Boolean'];
  insuranceCarrierId: Scalars['Int'];
  isOutOfStateNeeded: Scalars['Boolean'];
  isReferralNeeded: Scalars['Boolean'];
  notes: Scalars['String'];
  plan: Scalars['String'];
};

export type Referral = {
  __typename?: 'Referral';
  addressState: Scalars['String'];
  birthDate: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  guardianFirstName?: Maybe<Scalars['String']>;
  guardianLastName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  patientIsMinor?: Maybe<Scalars['Boolean']>;
  patientPhone: Scalars['String'];
  practiceName: Scalars['String'];
  practiceType: Scalars['String'];
  providerEmail: Scalars['String'];
  providerFirstName: Scalars['String'];
  providerLastName: Scalars['String'];
  reasonForReferral: Scalars['String'];
};

export type ScheduleRequest = {
  __typename?: 'ScheduleRequest';
  appointmentEndTime?: Maybe<Scalars['DateTime']>;
  appointmentStartTime?: Maybe<Scalars['DateTime']>;
  appointmentType: Scalars['String'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['ID'];
  mrn: Scalars['String'];
  npi: Scalars['String'];
  provider: Provider;
  visitDuration: Scalars['Int'];
};

export type ScheduleRequestInput = {
  appointmentType: Scalars['String'];
  mrn: Scalars['String'];
  npi: Scalars['String'];
  source: Scalars['String'];
  visitDuration: Scalars['Int'];
};

export enum SectionName {
  Demographics = 'DEMOGRAPHICS',
  Matching = 'MATCHING',
  MedicalInfo = 'MEDICAL_INFO',
  Preferences = 'PREFERENCES',
  ReasonVisit = 'REASON_VISIT'
}

export type Setting = {
  __typename?: 'Setting';
  category: Scalars['String'];
  id: Scalars['String'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type SettingInput = {
  category: Scalars['String'];
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type SignedFormInput = {
  id?: InputMaybe<Scalars['ID']>;
  patient?: InputMaybe<PatientInput>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Specialty = {
  __typename?: 'Specialty';
  canBePrimary?: Maybe<Scalars['Boolean']>;
  canBeSecondary?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  treatmentPrerequisiteId?: Maybe<Scalars['Int']>;
};

export type SpecialtyInput = {
  id: Scalars['ID'];
  treatmentPrerequisiteId: Scalars['Int'];
};

export type State = {
  __typename?: 'State';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum TerminationReason {
  CantChangeProviders = 'CantChangeProviders',
  CompletedByMinor = 'CompletedByMinor',
  Emergency = 'Emergency',
  InsurancePlanOutOfNetwork = 'InsurancePlanOutOfNetwork',
  NirvanaPlanOutOfNetwork = 'NirvanaPlanOutOfNetwork',
  NotAMinor = 'NotAMinor',
  PayorOutOfNetwork = 'PayorOutOfNetwork',
  RecentlyInpatient = 'RecentlyInpatient',
  Schizophrenic = 'Schizophrenic',
  StateNotCovered = 'StateNotCovered'
}

export type Timeslot = {
  __typename?: 'Timeslot';
  endTime: Scalars['DateTime'];
  healowTimeslotId?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  providerId: Scalars['String'];
  startTime: Scalars['DateTime'];
};

export type TreatmentMethod = {
  __typename?: 'TreatmentMethod';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type TreatmentMethodInput = {
  id: Scalars['ID'];
};

export type TreatmentPrerequisite = {
  __typename?: 'TreatmentPrerequisite';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UnauthenticatedAssessment = {
  __typename?: 'UnauthenticatedAssessment';
  documentId?: Maybe<Scalars['String']>;
  questionCode?: Maybe<Scalars['String']>;
  sessionPatientId: Scalars['ID'];
  shortCode?: Maybe<Scalars['String']>;
};

export type UnauthenticatedEntity = {
  __typename?: 'UnauthenticatedEntity';
  id: Scalars['ID'];
};

export type UpdateInsurancePayerPlanMapInput = {
  changeHealthcarePayerId?: InputMaybe<Scalars['String']>;
  changeHealthcarePayerName?: InputMaybe<Scalars['String']>;
  contractedInsuranceName?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  insuranceTier?: InputMaybe<Scalars['String']>;
  isPriority?: InputMaybe<Scalars['Boolean']>;
  networkStatus?: InputMaybe<Scalars['String']>;
  payerName?: InputMaybe<Scalars['String']>;
  payerPlans?: InputMaybe<Scalars['String']>;
  processingPlanName?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  subscriberIdPrefix?: InputMaybe<Scalars['String']>;
};

export type ValidatedScale = {
  __typename?: 'ValidatedScale';
  answers: Array<ValidatedScaleAnswer>;
  result?: Maybe<ValidatedScaleResult>;
  score?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ValidatedScaleAnswer = {
  __typename?: 'ValidatedScaleAnswer';
  answerCode: Scalars['String'];
  answerValue: Scalars['Int'];
  questionCode: Scalars['String'];
};

export type ValidatedScaleAnswerInput = {
  answerCode: Scalars['String'];
  answerValue: Scalars['Int'];
  questionCode: Scalars['String'];
};

export type ValidatedScaleInput = {
  answers: Array<ValidatedScaleAnswerInput>;
  id?: InputMaybe<Scalars['ID']>;
  patientId?: InputMaybe<Scalars['ID']>;
  scale: Scalars['String'];
};

export type ValidatedScaleResult = {
  __typename?: 'ValidatedScaleResult';
  cutoff: Scalars['Int'];
  label: Scalars['String'];
};

export type WriteBackDemographicsInput = {
  addressCity?: InputMaybe<Scalars['Boolean']>;
  addressState?: InputMaybe<Scalars['Boolean']>;
  addressStreet1?: InputMaybe<Scalars['Boolean']>;
  addressStreet2?: InputMaybe<Scalars['Boolean']>;
  addressZipCode?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['Boolean']>;
  mrn: Scalars['String'];
  phone?: InputMaybe<Scalars['Boolean']>;
};

export type ZocdocAppointment = {
  __typename?: 'ZocdocAppointment';
  id: Scalars['ID'];
  provider: Provider;
  providerId: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
};

export type UpdateAssessmentAnswersInput = {
  answers?: InputMaybe<Array<AssessmentAnswerInput>>;
  section?: InputMaybe<SectionName>;
};

export type FullPatientFragment = { __typename?: 'Patient', id: string, updatedAt?: any | null, matchesLastEntry?: boolean | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, lastEntry?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, startTime: any, duration: number, ehrProviderNpi: string, visitType?: string | null, provider?: { __typename?: 'AppointmentProvider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } | null }>, document?: { __typename?: 'Document', id: string, createdAt?: any | null, actionStatus?: ActionStatus | null, terminationReason?: string | null, files: Array<{ __typename?: 'File', id: string, fileName: string, type: FileType, ecwSyncStatus?: string | null }>, details?: { __typename?: 'DocumentDetails', id?: string | null, notes?: string | null } | null, events?: Array<{ __typename?: 'Event', id: string, documentId?: string | null, eventDescription?: string | null, createdByName?: string | null, createdByEmail?: string | null, createdAt?: any | null }> | null } | null, assessments?: Array<{ __typename?: 'Assessment', id: string, section?: string | null, questionCode?: string | null, answerValue?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null, scales?: Array<{ __typename?: 'ValidatedScale', type: string, answers: Array<{ __typename?: 'ValidatedScaleAnswer', questionCode: string, answerValue: number, answerCode: string }> }> | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', id: string, name?: string | null, codeset: string, code: string, createdAt?: any | null, deletedAt?: any | null }>, pharmacy?: { __typename?: 'PatientPharmacy', name: string, phone: string, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null } | null, providerMatch?: { __typename?: 'ProviderMatch', assignedBy?: string | null, source?: ProviderMatchSource | null, provider?: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, photo?: string | null, primaryCredential?: string | null } | null } | null, emergencyContact?: { __typename?: 'PatientEmergencyContact', id?: string | null, firstName: string, middleName?: string | null, lastName: string, relation: string, phone: string } | null, patientGuardians?: Array<{ __typename?: 'PatientGuardian', id?: string | null, firstName: string, lastName: string, birthDate: any, phone: string, email: string, isAddressLinkedWithPatient: boolean, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, discoveryChannel?: string | null, precedence: Precedence, relationToPatient: string } | null> | null };

export type PatientAssessmentResponsesFragment = { __typename?: 'Patient', assessments?: Array<{ __typename?: 'Assessment', id: string, questionCode?: string | null, answerValue?: string | null }> | null };

export type PatientDemographicsFragment = { __typename?: 'Patient', mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null };

export type AcceptTransferRequestMutationVariables = Exact<{
  id: Scalars['ID'];
  acceptingProviderNpi: Scalars['String'];
}>;


export type AcceptTransferRequestMutation = { __typename?: 'Mutation', acceptTransferRequest?: { __typename?: 'ItxRequest', id: string } | null };

export type BookAppointmentMutationVariables = Exact<{
  input: BookAppointmentInput;
}>;


export type BookAppointmentMutation = { __typename?: 'Mutation', bookAppointment: { __typename?: 'BookingResult', ehrEncounterId?: string | null } };

export type CancelAppointmentMutationVariables = Exact<{
  scheduleRequestId: Scalars['ID'];
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointment: { __typename?: 'EmptyResponse', ok: boolean } };

export type CancelTransferRequestMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelTransferRequestMutation = { __typename?: 'Mutation', cancelTransferRequest?: { __typename?: 'ItxRequest', id: string } | null };

export type CheckZdProviderForMatchQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckZdProviderForMatchQuery = { __typename?: 'Query', checkZDProviderForMatch: { __typename?: 'CheckProviderMatch', isZDProviderAMatch: boolean, zdProviderMatchFailureReasons?: Array<ProviderNotMatchReason> | null, zdProviderDealbreakersForPatientReasons?: Array<string> | null, patientMatchFailureReasons?: Array<PatientShouldNotBeMatchedReason> | null, zocdocAppointment: { __typename?: 'ZocdocAppointment', providerId: string, startTime?: any | null }, zocdocProvider: { __typename?: 'Provider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null }, matchedProviders?: Array<{ __typename?: 'MatchResult', provider: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, biography?: string | null, primaryCredential?: string | null, photo?: string | null, calendarUrl?: string | null, modality?: string | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, treatmentPrerequisiteId?: number | null }> | null, licenses?: Array<{ __typename?: 'License', stateCode: string, certificationType: string }> | null, providerTimeslots?: Array<{ __typename?: 'Timeslot', startTime: any, endTime: any, providerId: string, isAvailable?: boolean | null }> | null } }> | null } };

export type ClaimIntakeMutationVariables = Exact<{
  uploadedDocumentId: Scalars['ID'];
}>;


export type ClaimIntakeMutation = { __typename?: 'Mutation', claimIntake: { __typename?: 'IntakeClaim', id: string } };

export type ClearAssessmentResponseMutationVariables = Exact<{
  input?: InputMaybe<ClearAssessmentResponseInput>;
}>;


export type ClearAssessmentResponseMutation = { __typename?: 'Mutation', clearAssessmentResponse?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type CreateConsultNotAFitMutationVariables = Exact<{
  mrn: Scalars['String'];
  reasonForCnaf: Scalars['String'];
  clinicianNotes: Scalars['String'];
}>;


export type CreateConsultNotAFitMutation = { __typename?: 'Mutation', createConsultNotAFit?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type CreateInsurancePayerPlanMapMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateInsurancePayerPlanMapMutation = { __typename?: 'Mutation', createInsurancePayerPlanMap: { __typename?: 'InsurancePayerPlanMap', id: number } };

export type CreateReferralMutationVariables = Exact<{
  input: CreateReferralInput;
}>;


export type CreateReferralMutation = { __typename?: 'Mutation', createReferral: { __typename?: 'EmptyResponse', ok: boolean } };

export type CreateScheduleRequestMutationVariables = Exact<{
  input: ScheduleRequestInput;
}>;


export type CreateScheduleRequestMutation = { __typename?: 'Mutation', createScheduleRequest: { __typename?: 'ScheduleRequest', id: string } };

export type CreateScheduleRequestsMutationVariables = Exact<{
  inputs: Array<ScheduleRequestInput> | ScheduleRequestInput;
}>;


export type CreateScheduleRequestsMutation = { __typename?: 'Mutation', createScheduleRequests: Array<{ __typename?: 'ScheduleRequest', id: string, mrn: string, npi: string, appointmentType: string, visitDuration: number } | null> };

export type CreateSupportTicketMutationVariables = Exact<{
  stepsAttempted: Scalars['String'];
  screenDescription: Scalars['String'];
  troubleshootingSteps: Scalars['String'];
  href: Scalars['String'];
  image: Scalars['String'];
}>;


export type CreateSupportTicketMutation = { __typename?: 'Mutation', createSupportTicket: { __typename?: 'EmptyResponse', ok: boolean } };

export type CreateTransferRequestMutationVariables = Exact<{
  patientMrn: Scalars['String'];
  requestingProviderNpi: Scalars['String'];
  reasonForTransfer: Scalars['String'];
  clinicianNotes: Scalars['String'];
  initiator: Scalars['String'];
  specialtyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  genderPreference?: InputMaybe<Scalars['String']>;
  directTransferNpi?: InputMaybe<Scalars['String']>;
}>;


export type CreateTransferRequestMutation = { __typename?: 'Mutation', createTransferRequest?: { __typename?: 'ItxRequest', id: string } | null };

export type DeleteInsurancePayerPlanMapMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteInsurancePayerPlanMapMutation = { __typename?: 'Mutation', deleteInsurancePayerPlanMap: { __typename?: 'EmptyResponse', ok: boolean } };

export type EditPatientEmergencyContactMutationVariables = Exact<{
  input: PatientEmergencyContactInput;
}>;


export type EditPatientEmergencyContactMutation = { __typename?: 'Mutation', editPatientEmergencyContact?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type EditPatientGuardiansMutationVariables = Exact<{
  input: EditPatientGuardiansInput;
}>;


export type EditPatientGuardiansMutation = { __typename?: 'Mutation', editPatientGuardians?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type EditPatientPharmacyMutationVariables = Exact<{
  input?: InputMaybe<PatientPharmacyInput>;
}>;


export type EditPatientPharmacyMutation = { __typename?: 'Mutation', editPatientPharmacy?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type EditPatientPrimaryPolicyholderMutationVariables = Exact<{
  input?: InputMaybe<PatientPrimaryPolicyholderInput>;
}>;


export type EditPatientPrimaryPolicyholderMutation = { __typename?: 'Mutation', editPatientPrimaryPolicyholder?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type EditPatientMutationVariables = Exact<{
  input?: InputMaybe<EditPatientInput>;
}>;


export type EditPatientMutation = { __typename?: 'Mutation', editPatient?: { __typename?: 'Patient', id: string, matchesLastEntry?: boolean | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, lastEntry?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null } | null } | null };

export type FindAppointmentsQueryVariables = Exact<{
  input: FindAppointmentsInput;
}>;


export type FindAppointmentsQuery = { __typename?: 'Query', findAppointments: Array<{ __typename?: 'Appointment', id: string, startTime: any, duration: number, visitType?: string | null, ehrProviderNpi: string, patient: { __typename?: 'Patient', id: string, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null }, provider?: { __typename?: 'AppointmentProvider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } | null }> };

export type FindPatientsQueryVariables = Exact<{
  input: FindPatientsInput;
}>;


export type FindPatientsQuery = { __typename?: 'Query', findPatients: Array<{ __typename?: 'Patient', id: string, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, appointments: Array<{ __typename?: 'Appointment', id: string, startTime: any, duration: number, ehrProviderNpi: string, visitType?: string | null, provider?: { __typename?: 'AppointmentProvider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } | null }> }> };

export type GetAcceptedItxRequestsQueryVariables = Exact<{
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
}>;


export type GetAcceptedItxRequestsQuery = { __typename?: 'Query', getAcceptedItxRequests?: Array<{ __typename?: 'ItxRequest', id: string, createdAt: any, acceptedAt?: any | null } | null> | null };

export type GetActivePatientQueryVariables = Exact<{
  mrn: Scalars['String'];
}>;


export type GetActivePatientQuery = { __typename?: 'Query', getActivePatient: { __typename?: 'ActivePatient', adherenceLetterSent: boolean, clinicalStatus: string, daysSinceLastVisit?: number | null, dob: any, dutyOfCareCountdown?: number | null, ecwChartStatus: EcwChartStatus, email?: string | null, externalMrn?: string | null, firstName: string, isDischargeLetterSentWithinTwoDays?: boolean | null, isAdherenceLetterSentWithinTwoDays?: boolean | null, lastCompletedAppointment?: any | null, lastName: string, lastProviderEmail: string, lastProviderName: string, lastProviderNpi: string, mrn: string, nextAppointment?: any | null, primaryDiagnoses: Array<string>, recommendedAction: string, secondaryDiagnoses: Array<string>, transferStatus: string, itxRequests: Array<{ __typename?: 'ItxRequest', acceptedAt?: any | null, expiration?: any | null }> } };

export type GetActivePatientsByMrnsQueryVariables = Exact<{
  mrns: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetActivePatientsByMrnsQuery = { __typename?: 'Query', getActivePatientsByMrns: Array<{ __typename?: 'ActivePatient', mrn: string, primaryDiagnoses: Array<string>, secondaryDiagnoses: Array<string>, clinicalStatus: string }> };

export type GetActivePatientsQueryVariables = Exact<{
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
}>;


export type GetActivePatientsQuery = { __typename?: 'Query', getActivePatients: Array<{ __typename?: 'ActivePatient', adherenceLetterSent: boolean, clinicalStatus: string, daysSinceLastVisit?: number | null, dob: any, dutyOfCareCountdown?: number | null, ecwChartStatus: EcwChartStatus, email?: string | null, externalMrn?: string | null, firstName: string, isDischargeLetterSentWithinTwoDays?: boolean | null, isAdherenceLetterSentWithinTwoDays?: boolean | null, lastCompletedAppointment?: any | null, lastName: string, lastProviderEmail: string, lastProviderName: string, lastProviderNpi: string, mrn: string, nextAppointment?: any | null, primaryDiagnoses: Array<string>, recommendedAction: string, secondaryDiagnoses: Array<string>, transferStatus: string, itxRequests: Array<{ __typename?: 'ItxRequest', acceptedAt?: any | null, expiration?: any | null }> }> };

export type GetAgeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgeGroupsQuery = { __typename?: 'Query', getAgeGroups?: Array<{ __typename?: 'AgeGroup', id: string, name: string, rangeStart: number, rangeEnd?: number | null }> | null };

export type GetAllItxProviderMatchesByNpiQueryVariables = Exact<{
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
}>;


export type GetAllItxProviderMatchesByNpiQuery = { __typename?: 'Query', getAllItxProviderMatchesByNpi?: Array<{ __typename?: 'ItxProviderMatch', id: string, rejectedAt?: any | null } | null> | null };

export type GetAssessmentForCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentForCurrentUserQuery = { __typename?: 'Query', getAssessmentForCurrentUser?: { __typename?: 'AuthenticatedAssessment', shortCode?: string | null, documentId?: string | null, questionCode?: string | null, sessionPatientId: string } | null };

export type GetAvailableItxProviderMatchesQueryVariables = Exact<{
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
}>;


export type GetAvailableItxProviderMatchesQuery = { __typename?: 'Query', getAvailableItxProviderMatches?: Array<{ __typename?: 'ItxProviderMatch', id: string, itxRequest: { __typename?: 'ItxRequest', reasonForTransfer?: string | null, expiration?: any | null }, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, mrn?: string | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', name?: string | null }> } } | null> | null };

export type GetAvailableTimeslotsForProviderQueryVariables = Exact<{
  absoluteDurationSeconds?: InputMaybe<Scalars['Int']>;
  checkForNpDailyMax: Scalars['Boolean'];
  endTime: Scalars['DateTime'];
  providerId: Scalars['String'];
  startTime: Scalars['DateTime'];
  timeslotDurationMinutes?: InputMaybe<Scalars['Int']>;
  timeslotVisitType?: InputMaybe<Scalars['String']>;
}>;


export type GetAvailableTimeslotsForProviderQuery = { __typename?: 'Query', getAvailableTimeslotsForProvider: Array<{ __typename?: 'Timeslot', endTime: any, healowTimeslotId?: string | null, isAvailable?: boolean | null, providerId: string, startTime: any }> };

export type GetCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCarriersQuery = { __typename?: 'Query', getCarriers: Array<{ __typename?: 'Carrier', id: string, name: string, parentCarrierId?: string | null, isInNetwork: boolean }> };

export type GetCityStateQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;


export type GetCityStateQuery = { __typename?: 'Query', getCityState: Array<{ __typename?: 'CityStateAutofill', zipCode?: string | null, city?: string | null, stateCode?: string | null, stateName?: string | null }> };

export type GetDbHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDbHealthCheckQuery = { __typename?: 'Query', getDBHealthCheck: { __typename?: 'EmptyResponse', ok: boolean } };

export type GetDiagnosesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiagnosesQuery = { __typename?: 'Query', getDiagnoses: Array<{ __typename?: 'Diagnosis', diagnosisCodeRegex: string, name: string }> };

export type GetDocumentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentStatusQuery = { __typename?: 'Query', getMe?: { __typename?: 'Patient', mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, document?: { __typename?: 'Document', status?: DocumentStatus | null } | null, zocdocAppointment?: { __typename?: 'ZocdocAppointment', provider: { __typename?: 'Provider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } } | null } | null };

export type GetHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHealthCheckQuery = { __typename?: 'Query', getHealthCheck: { __typename?: 'EmptyResponse', ok: boolean } };

export type GetInsurancePayerPlanMapForAssessmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsurancePayerPlanMapForAssessmentQuery = { __typename?: 'Query', getInsurancePayerPlanMapForAssessment: Array<{ __typename?: 'InsurancePayerPlanMap', id: number, isPriority?: boolean | null, payerName?: string | null, payerPlans?: string | null, networkStatus?: string | null }> };

export type GetInsurancePayerPlanMapQueryVariables = Exact<{
  filterOptions: InsurancePayerPlanMapFilterOptions;
  pageOptions: InsurancePayerPlanMapPageOptions;
}>;


export type GetInsurancePayerPlanMapQuery = { __typename?: 'Query', getInsurancePayerPlanMap: { __typename?: 'InsurancePayerPlanMapPage', hasNextPage: boolean, hasPrevPage: boolean, pageNumber: number, perPage: number, totalCount: number, items: Array<{ __typename?: 'InsurancePayerPlanMap', changeHealthcarePayerId?: string | null, changeHealthcarePayerName?: string | null, contractedInsuranceName?: string | null, id: number, insuranceTier?: string | null, isPriority?: boolean | null, networkStatus?: string | null, payerName?: string | null, payerPlans?: string | null, processingPlanName?: string | null, stateCode?: string | null, subscriberIdPrefix?: string | null }> } };

export type GetInsurancePayersForAssessmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsurancePayersForAssessmentQuery = { __typename?: 'Query', getInsurancePayersForAssessment: Array<{ __typename?: 'InsurancePayer', id: number, isPriority?: boolean | null, payerName?: string | null, networkStatus?: string | null }> };

export type GetInsurancePlansForAssessmentQueryVariables = Exact<{
  payerName: Scalars['String'];
}>;


export type GetInsurancePlansForAssessmentQuery = { __typename?: 'Query', getInsurancePlansForAssessment: Array<{ __typename?: 'InsurancePayerPlanMap', id: number, payerName?: string | null, payerPlans?: string | null, networkStatus?: string | null }> };

export type GetIntakeBySessionPatientIdQueryVariables = Exact<{
  sessionPatientId: Scalars['ID'];
}>;


export type GetIntakeBySessionPatientIdQuery = { __typename?: 'Query', getIntakeBySessionPatientId?: { __typename?: 'Intake', ecwManualSyncedFileCount?: number | null, ecwPendingFileCount?: number | null, ecwSyncedFileCount?: number | null, ecwTimeoutFileCount?: number | null, ehrEncounterId?: string | null, fileCount?: number | null, hasAppt?: string | null, mainReasons?: string | null, mentalHealthCoverage?: NirvanaPlanStatus | null, msBookingCount?: number | null, planStatus?: NirvanaPlanStatus | null, status?: DocumentStatus | null, terminationReason?: string | null, uploadedDocumentId?: string | null, wasReferredByZocdoc?: boolean | null } | null };

export type GetIntakeClaimByUploadedDocumentIdQueryVariables = Exact<{
  uploadedDocumentId: Scalars['ID'];
}>;


export type GetIntakeClaimByUploadedDocumentIdQuery = { __typename?: 'Query', getIntakeClaimByUploadedDocumentId?: { __typename?: 'IntakeClaim', id: string, assigneeName: string, assigneeEmail: string } | null };

export type GetIntakesBySessionPatientIdsQueryVariables = Exact<{
  sessionPatientIds: Array<Scalars['ID']> | Scalars['ID'];
  pageOptions: PageOptions;
}>;


export type GetIntakesBySessionPatientIdsQuery = { __typename?: 'Query', getIntakesBySessionPatientIds: { __typename?: 'IntakePage', hasNextPage: boolean, hasPrevPage: boolean, pageNumber: number, perPage: number, totalCount: number, items: Array<{ __typename?: 'Intake', addressCity?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressZipCode?: string | null, assigneeName?: string | null, birthDate?: string | null, createdAt?: any | null, ecwManualSyncedFileCount?: number | null, ecwPendingFileCount?: number | null, ecwSyncedFileCount?: number | null, ecwTimeoutFileCount?: number | null, ehrEncounterId?: string | null, email?: string | null, fileCount?: number | null, firstName?: string | null, hasAppt?: string | null, lastName?: string | null, mainReasons?: string | null, mentalHealthCoverage?: NirvanaPlanStatus | null, middleName?: string | null, mrn?: number | null, msBookingCount?: number | null, phone?: string | null, planNetworkStatus?: InsurancePlanStatus | null, planStatus?: NirvanaPlanStatus | null, providerId?: string | null, referralSource?: string | null, secondaryReasons?: string | null, sessionPatientId: string, shortCode?: string | null, specialtyCare?: string | null, status?: DocumentStatus | null, terminationReason?: string | null, updatedAt?: any | null, uploadedDocumentId?: string | null, wasReferredByZocdoc?: boolean | null }> } };

export type GetIntakesFromOpenSearchQueryVariables = Exact<{
  filterOptions?: InputMaybe<IntakeFilterOptions>;
  pageOptions: PageOptions;
}>;


export type GetIntakesFromOpenSearchQuery = { __typename?: 'Query', getIntakesFromOpenSearch: { __typename?: 'IntakePage', hasNextPage: boolean, hasPrevPage: boolean, pageNumber: number, perPage: number, totalCount: number, items: Array<{ __typename?: 'Intake', actionStatus?: ActionStatus | null, addressCity?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressZipCode?: string | null, assigneeName?: string | null, birthDate?: string | null, createdAt?: any | null, ecwManualSyncedFileCount?: number | null, ecwPendingFileCount?: number | null, ecwSyncedFileCount?: number | null, ecwTimeoutFileCount?: number | null, ehrEncounterId?: string | null, email?: string | null, fileCount?: number | null, firstName?: string | null, hasAppt?: string | null, lastName?: string | null, mainReasons?: string | null, mentalHealthCoverage?: NirvanaPlanStatus | null, middleName?: string | null, mrn?: number | null, msBookingCount?: number | null, phone?: string | null, planNetworkStatus?: InsurancePlanStatus | null, planStatus?: NirvanaPlanStatus | null, providerId?: string | null, referralSource?: string | null, secondaryReasons?: string | null, sessionPatientId: string, shortCode?: string | null, specialtyCare?: string | null, status?: DocumentStatus | null, terminationReason?: string | null, updatedAt?: any | null, uploadedDocumentId?: string | null, wasReferredByZocdoc?: boolean | null }> } };

export type GetIntakesQueryVariables = Exact<{
  filterOptions?: InputMaybe<IntakeFilterOptions>;
  pageOptions: PageOptions;
}>;


export type GetIntakesQuery = { __typename?: 'Query', getIntakes: { __typename?: 'IntakePage', hasNextPage: boolean, hasPrevPage: boolean, pageNumber: number, perPage: number, totalCount: number, items: Array<{ __typename?: 'Intake', actionStatus?: ActionStatus | null, addressCity?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressZipCode?: string | null, assigneeName?: string | null, birthDate?: string | null, createdAt?: any | null, ecwManualSyncedFileCount?: number | null, ecwPendingFileCount?: number | null, ecwSyncedFileCount?: number | null, ecwTimeoutFileCount?: number | null, ehrEncounterId?: string | null, email?: string | null, fileCount?: number | null, firstName?: string | null, hasAppt?: string | null, lastName?: string | null, mainReasons?: string | null, mentalHealthCoverage?: NirvanaPlanStatus | null, middleName?: string | null, mrn?: number | null, msBookingCount?: number | null, phone?: string | null, planNetworkStatus?: InsurancePlanStatus | null, planStatus?: NirvanaPlanStatus | null, providerId?: string | null, referralSource?: string | null, secondaryReasons?: string | null, sessionPatientId: string, shortCode?: string | null, specialtyCare?: string | null, status?: DocumentStatus | null, terminationReason?: string | null, updatedAt?: any | null, uploadedDocumentId?: string | null, wasReferredByZocdoc?: boolean | null }> } };

export type GetItxProviderMatchByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetItxProviderMatchByIdQuery = { __typename?: 'Query', getItxProviderMatchById?: { __typename?: 'ItxProviderMatch', id: string, provider: { __typename?: 'Provider', npi?: string | null, firstName?: string | null, lastName?: string | null }, itxRequest: { __typename?: 'ItxRequest', id: string, reasonForTransfer?: string | null, expiration?: any | null, requestingProviderNpi: string, clinicianNotes?: string | null }, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, mrn?: string | null, addressState?: string | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', name?: string | null }> } } | null };

export type GetItxRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetItxRequestQuery = { __typename?: 'Query', getItxRequest?: { __typename?: 'ItxRequest', id: string, createdAt: any, acceptedAt?: any | null, clinicianNotes?: string | null, expiration?: any | null, reasonForTransfer?: string | null, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, mrn?: string | null, birthDate?: Day | null, addressState?: string | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', name?: string | null }> }, requestingProvider: { __typename?: 'Provider', firstName?: string | null, lastName?: string | null }, specialties?: Array<{ __typename?: 'Specialty', name?: string | null } | null> | null } | null };

export type GetItxRequestsQueryVariables = Exact<{
  overrideProviderNpi?: InputMaybe<Scalars['String']>;
}>;


export type GetItxRequestsQuery = { __typename?: 'Query', getItxRequests?: Array<{ __typename?: 'ItxRequest', id: string, createdAt: any, acceptedAt?: any | null, expiration?: any | null, reasonForTransfer?: string | null, processedAt?: any | null, hasProviderMatches?: boolean | null, patient: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, mrn?: string | null, birthDate?: Day | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', name?: string | null }> }, specialties?: Array<{ __typename?: 'Specialty', name?: string | null } | null> | null, scheduleRequest?: { __typename?: 'ScheduleRequest', expiresAt: any, appointmentStartTime?: any | null } | null } | null> | null };

export type GetLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLanguagesQuery = { __typename?: 'Query', getLanguages?: Array<{ __typename?: 'Language', id: string, name?: string | null }> | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'Patient', id: string, updatedAt?: any | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, document?: { __typename?: 'Document', id: string, createdAt?: any | null, actionStatus?: ActionStatus | null, files: Array<{ __typename?: 'File', id: string, fileName: string, type: FileType }> } | null } | null };

export type GetPatientDischargeLetterQueryVariables = Exact<{
  patientMrn: Scalars['String'];
}>;


export type GetPatientDischargeLetterQuery = { __typename?: 'Query', getPatientDischargeLetter?: Array<{ __typename?: 'PatientDischargeLetter', id: string } | null> | null };

export type GetPatientMedicationsQueryVariables = Exact<{
  patientMrn: Scalars['String'];
}>;


export type GetPatientMedicationsQuery = { __typename?: 'Query', getPatientMedications?: Array<{ __typename?: 'Medication', id: number, medicationOrderNumber: string, patientMrn: string, encounterDate: string, medicationName: string, frequency?: string | null, strength?: string | null, dosage?: string | null, drugSchedule?: string | null } | null> | null };

export type GetPatientPrimaryPolicyHolderQueryVariables = Exact<{
  sessionPatientId: Scalars['String'];
}>;


export type GetPatientPrimaryPolicyHolderQuery = { __typename?: 'Query', getPatientPrimaryPolicyHolder?: { __typename?: 'PatientPrimaryPolicyholder', id: string, firstName: string, lastName: string, birthDate: any, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, isAddressLinkedWithPatient?: boolean | null, relationToPatient?: string | null, customRelation?: string | null } | null };

export type GetPatientQueryVariables = Exact<{
  input?: InputMaybe<GetPatientInput>;
}>;


export type GetPatientQuery = { __typename?: 'Query', getPatient?: { __typename?: 'Patient', id: string, updatedAt?: any | null, matchesLastEntry?: boolean | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, lastEntry?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, startTime: any, duration: number, ehrProviderNpi: string, visitType?: string | null, provider?: { __typename?: 'AppointmentProvider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } | null }>, document?: { __typename?: 'Document', id: string, createdAt?: any | null, actionStatus?: ActionStatus | null, terminationReason?: string | null, files: Array<{ __typename?: 'File', id: string, fileName: string, type: FileType, ecwSyncStatus?: string | null }>, details?: { __typename?: 'DocumentDetails', id?: string | null, notes?: string | null } | null, events?: Array<{ __typename?: 'Event', id: string, documentId?: string | null, eventDescription?: string | null, createdByName?: string | null, createdByEmail?: string | null, createdAt?: any | null }> | null } | null, assessments?: Array<{ __typename?: 'Assessment', id: string, section?: string | null, questionCode?: string | null, answerValue?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null, scales?: Array<{ __typename?: 'ValidatedScale', type: string, answers: Array<{ __typename?: 'ValidatedScaleAnswer', questionCode: string, answerValue: number, answerCode: string }> }> | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', id: string, name?: string | null, codeset: string, code: string, createdAt?: any | null, deletedAt?: any | null }>, pharmacy?: { __typename?: 'PatientPharmacy', name: string, phone: string, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null } | null, providerMatch?: { __typename?: 'ProviderMatch', assignedBy?: string | null, source?: ProviderMatchSource | null, provider?: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, photo?: string | null, primaryCredential?: string | null } | null } | null, emergencyContact?: { __typename?: 'PatientEmergencyContact', id?: string | null, firstName: string, middleName?: string | null, lastName: string, relation: string, phone: string } | null, patientGuardians?: Array<{ __typename?: 'PatientGuardian', id?: string | null, firstName: string, lastName: string, birthDate: any, phone: string, email: string, isAddressLinkedWithPatient: boolean, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, discoveryChannel?: string | null, precedence: Precedence, relationToPatient: string } | null> | null } | null };

export type GetPlansQueryVariables = Exact<{
  carrier: Scalars['String'];
  filterOptions?: InputMaybe<PlansFilterOptions>;
}>;


export type GetPlansQuery = { __typename?: 'Query', getPlans: Array<{ __typename?: 'PlanAutofill', carrier?: string | null, plan?: string | null, inNetwork?: boolean | null, isReferralNeeded?: boolean | null, isOutOfStateNeeded?: boolean | null, notes?: string | null, insuranceCarrierId?: number | null }> };

export type GetProviderByNpiQueryVariables = Exact<{
  npi?: InputMaybe<Scalars['String']>;
}>;


export type GetProviderByNpiQuery = { __typename?: 'Query', getProviderByNpi: { __typename?: 'Provider', id: string, npi?: string | null, firstName?: string | null, lastName?: string | null, primaryCredential?: string | null, photo?: string | null, photoDetail?: string | null, biography?: string | null, graduatedAt?: any | null, notes?: string | null, school?: string | null, certification?: string | null, modality?: string | null, npDailyMax?: number | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, treatmentPrerequisiteId?: number | null }> | null, languages?: Array<{ __typename?: 'Language', name?: string | null }> | null } };

export type GetProviderHistoryQueryVariables = Exact<{
  providerId?: InputMaybe<Scalars['String']>;
  pageOptions: PageOptions;
}>;


export type GetProviderHistoryQuery = { __typename?: 'Query', getProviderHistory: { __typename?: 'ProviderHistoryPage', pageNumber: number, totalCount: number, hasNextPage: boolean, hasPrevPage: boolean, items: Array<{ __typename?: 'ProviderHistory', id: string, providerId: string, source?: string | null, eventType?: EventType | null, details: any, createdAt?: any | null } | null> } };

export type GetProviderMatchesQueryVariables = Exact<{
  sessionPatientId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProviderMatchesQuery = { __typename?: 'Query', getProviderMatches: { __typename?: 'PatientMatchResult', patientMatchFailureReasons: Array<PatientShouldNotBeMatchedReason>, providers?: Array<{ __typename?: 'MatchResult', provider: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, biography?: string | null, primaryCredential?: string | null, photo?: string | null, calendarUrl?: string | null, modality?: string | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, treatmentPrerequisiteId?: number | null }> | null, licenses?: Array<{ __typename?: 'License', stateCode: string, certificationType: string }> | null, providerTimeslots?: Array<{ __typename?: 'Timeslot', startTime: any, endTime: any, providerId: string, isAvailable?: boolean | null }> | null } }> | null } };

export type GetProviderQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetProviderQuery = { __typename?: 'Query', getProvider: { __typename?: 'Provider', id: string, npi?: string | null, modality?: string | null, calendarUrl?: string | null, firstName?: string | null, lastName?: string | null, healowCode?: string | null, medallionStartDate?: any | null, primaryCredential?: string | null, photo?: string | null, photoDetail?: string | null, biography?: string | null, isOnlineMatchingEnabled?: boolean | null, isOnlineSchedulingEnabled?: boolean | null, graduatedAt?: any | null, primaryPracticeState?: string | null, notes?: string | null, school?: string | null, certification?: string | null, isOpenToTransfers?: boolean | null, npDailyMax?: number | null, ageGroups?: Array<{ __typename?: 'AgeGroup', id: string, name: string, rangeStart: number, rangeEnd?: number | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, treatmentPrerequisiteId?: number | null }> | null, treatmentMethods?: Array<{ __typename?: 'TreatmentMethod', id: string, name?: string | null }> | null, providerInsuranceCarriers?: Array<{ __typename?: 'ProviderInsuranceCarrier', stateCode?: string | null, insuranceCarrier?: { __typename?: 'InsuranceCarrier', name: string, medallionName?: string | null, isInNetwork: boolean } | null }> | null, languages?: Array<{ __typename?: 'Language', id: string, name?: string | null }> | null, licenses?: Array<{ __typename?: 'License', stateCode: string, certificationType: string }> | null, practices?: Array<{ __typename?: 'Practice', stateCode: string }> | null } };

export type GetProvidersForSearchbarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvidersForSearchbarQuery = { __typename?: 'Query', getProvidersForSearchbar: Array<{ __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, photo?: string | null, npi?: string | null }> };

export type GetProvidersFromOpenSearchQueryVariables = Exact<{
  filterOptions?: InputMaybe<ProviderFilterOptionsOpenSearch>;
  pageOptions: PageOptions;
}>;


export type GetProvidersFromOpenSearchQuery = { __typename?: 'Query', getProvidersFromOpenSearch: { __typename?: 'ProviderPageOpenSearch', pageNumber: number, totalCount: number, hasNextPage: boolean, hasPrevPage: boolean, items: Array<{ __typename?: 'ProviderOpenSearch', id: string, firstName?: string | null, lastName?: string | null, calendarUrl?: string | null, isOnlineMatchingEnabled?: boolean | null, isOnlineSchedulingEnabled?: boolean | null, medallionStartDate?: any | null, npi?: string | null, primaryPracticeState?: string | null, primaryCredential?: string | null, photo?: string | null, notes?: string | null, primaryConditions?: Array<string> | null, secondaryConditions?: Array<string> | null, npDailyMax?: number | null, practices?: Array<{ __typename?: 'Practice', stateCode: string }> | null, ageGroups?: Array<{ __typename?: 'AgeGroup', name: string }> | null, providerInsuranceCarriers?: Array<{ __typename?: 'ProviderInsuranceCarrier', stateCode?: string | null, insuranceCarrier?: { __typename?: 'InsuranceCarrier', name: string, medallionName?: string | null, isInNetwork: boolean } | null }> | null, treatmentMethods?: Array<{ __typename?: 'TreatmentMethod', id: string, name?: string | null }> | null, languages?: Array<{ __typename?: 'Language', id: string, name?: string | null }> | null, licenses?: Array<{ __typename?: 'License', stateCode: string, certificationType: string }> | null }> } };

export type GetProvidersQueryVariables = Exact<{
  filterOptions?: InputMaybe<ProviderFilterOptions>;
  pageOptions: PageOptions;
}>;


export type GetProvidersQuery = { __typename?: 'Query', getProviders: { __typename?: 'ProviderPage', pageNumber: number, totalCount: number, hasNextPage: boolean, hasPrevPage: boolean, items: Array<{ __typename?: 'Provider', id: string, calendarUrl?: string | null, firstName?: string | null, lastName?: string | null, healowCode?: string | null, medallionStartDate?: any | null, primaryCredential?: string | null, photo?: string | null, photoDetail?: string | null, biography?: string | null, isOnlineMatchingEnabled?: boolean | null, graduatedAt?: any | null, primaryPracticeState?: string | null, notes?: string | null, school?: string | null, certification?: string | null, npDailyMax?: number | null, ageGroups?: Array<{ __typename?: 'AgeGroup', id: string, name: string, rangeStart: number, rangeEnd?: number | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, treatmentPrerequisiteId?: number | null }> | null, treatmentMethods?: Array<{ __typename?: 'TreatmentMethod', id: string, name?: string | null }> | null, providerInsuranceCarriers?: Array<{ __typename?: 'ProviderInsuranceCarrier', stateCode?: string | null, insuranceCarrier?: { __typename?: 'InsuranceCarrier', name: string, medallionName?: string | null, isInNetwork: boolean } | null }> | null, languages?: Array<{ __typename?: 'Language', id: string, name?: string | null }> | null, licenses?: Array<{ __typename?: 'License', stateCode: string, certificationType: string }> | null, practices?: Array<{ __typename?: 'Practice', stateCode: string }> | null }> } };

export type GetS3PresignedPostQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GetS3PresignedPostQuery = { __typename?: 'Query', getS3PresignedPost: { __typename?: 'PresignedPost', url?: string | null, fields?: string | null } };

export type GetScheduleRequestQueryVariables = Exact<{
  scheduleRequestId: Scalars['ID'];
}>;


export type GetScheduleRequestQuery = { __typename?: 'Query', getScheduleRequest: { __typename?: 'ScheduleRequest', id: string, mrn: string, npi: string, appointmentStartTime?: any | null, appointmentEndTime?: any | null, expiresAt: any, visitDuration: number, provider: { __typename?: 'Provider', id: string, biography?: string | null, photo?: string | null, firstName?: string | null, lastName?: string | null, primaryCredential?: string | null, npDailyMax?: number | null, ageGroups?: Array<{ __typename?: 'AgeGroup', id: string, name: string, rangeStart: number, rangeEnd?: number | null }> | null, languages?: Array<{ __typename?: 'Language', id: string, name?: string | null }> | null, specialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null }> | null } } };

export type GetSettingsForCategoryQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type GetSettingsForCategoryQuery = { __typename?: 'Query', getSettingsForCategory: Array<{ __typename?: 'Setting', id: string, category: string, key: string, value?: string | null }> };

export type GetSpecialtiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpecialtiesQuery = { __typename?: 'Query', getSpecialties?: Array<{ __typename?: 'Specialty', id: string, name?: string | null, canBePrimary?: boolean | null, canBeSecondary?: boolean | null }> | null };

export type GetStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatesQuery = { __typename?: 'Query', getStates: Array<{ __typename?: 'State', code?: string | null, name?: string | null }> };

export type GetTreatmentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreatmentMethodsQuery = { __typename?: 'Query', getTreatmentMethods?: Array<{ __typename?: 'TreatmentMethod', id: string, name?: string | null }> | null };

export type GetTreatmentPrerequisitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreatmentPrerequisitesQuery = { __typename?: 'Query', getTreatmentPrerequisites?: Array<{ __typename?: 'TreatmentPrerequisite', id: number, name: string }> | null };

export type MatchWithPatientMutationVariables = Exact<{
  input: MatchInput;
}>;


export type MatchWithPatientMutation = { __typename?: 'Mutation', matchWithPatient: { __typename?: 'Patient', id: string, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null } };

export type PatientAssignProviderMatchMutationVariables = Exact<{
  sessionPatientId: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
}>;


export type PatientAssignProviderMatchMutation = { __typename?: 'Mutation', patientAssignProviderMatch?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type PccAssignProviderMatchMutationVariables = Exact<{
  sessionPatientId: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
}>;


export type PccAssignProviderMatchMutation = { __typename?: 'Mutation', pccAssignProviderMatch?: { __typename?: 'Patient', id: string, providerMatch?: { __typename?: 'ProviderMatch', assignedBy?: string | null, source?: ProviderMatchSource | null, provider?: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, primaryCredential?: string | null, photo?: string | null } | null } | null } | null };

export type RejectItxProviderMatchMutationVariables = Exact<{
  id: Scalars['ID'];
  rejectionReason: Scalars['String'];
  rejectionComments?: InputMaybe<Scalars['String']>;
}>;


export type RejectItxProviderMatchMutation = { __typename?: 'Mutation', rejectItxProviderMatch?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type RequestAppointmentMutationVariables = Exact<{
  scheduleRequestId: Scalars['ID'];
  appointmentStartTime: Scalars['DateTime'];
}>;


export type RequestAppointmentMutation = { __typename?: 'Mutation', requestAppointment: { __typename?: 'EmptyResponse', ok: boolean } };

export type RescheduleAppointmentMutationVariables = Exact<{
  scheduleRequestId: Scalars['ID'];
  appointmentStartTime: Scalars['DateTime'];
}>;


export type RescheduleAppointmentMutation = { __typename?: 'Mutation', rescheduleAppointment: { __typename?: 'EmptyResponse', ok: boolean } };

export type SendPatientDischargeLetterMutationVariables = Exact<{
  patientMrn: Scalars['String'];
  patientFirstName: Scalars['String'];
  patientLastName: Scalars['String'];
  patientBirthDate: Scalars['String'];
  patientEmail: Scalars['String'];
  externalMrn?: InputMaybe<Scalars['String']>;
  lastProviderNpi: Scalars['ID'];
  lastProviderName: Scalars['String'];
  template: DischargeLetterTemplate;
  clinicianNotes?: InputMaybe<Scalars['String']>;
}>;


export type SendPatientDischargeLetterMutation = { __typename?: 'Mutation', sendPatientDischargeLetter?: { __typename?: 'PatientDischargeLetter', id: string } | null };

export type StartAdherenceOutreachMutationVariables = Exact<{
  patientMrn: Scalars['String'];
  lastProviderNpi: Scalars['String'];
}>;


export type StartAdherenceOutreachMutation = { __typename?: 'Mutation', startAdherenceOutreach?: { __typename?: 'PatientAdherenceOutreach', id: string } | null };

export type UnclaimIntakeMutationVariables = Exact<{
  uploadedDocumentId: Scalars['ID'];
}>;


export type UnclaimIntakeMutation = { __typename?: 'Mutation', unclaimIntake: { __typename?: 'EmptyResponse', ok: boolean } };

export type UpdateAssessmentAnswersMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssessmentAnswersInput>;
}>;


export type UpdateAssessmentAnswersMutation = { __typename?: 'Mutation', updateAssessmentAnswers?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type UpdateCarrierMutationVariables = Exact<{
  input: CarrierInput;
}>;


export type UpdateCarrierMutation = { __typename?: 'Mutation', updateCarrier: { __typename?: 'Carrier', id: string, name: string, medallionName?: string | null, parentCarrierId?: string | null, isInNetwork: boolean } };

export type UpdateDocumentManualSyncedStatusMutationVariables = Exact<{
  documentId: Scalars['ID'];
  synced: Scalars['Boolean'];
}>;


export type UpdateDocumentManualSyncedStatusMutation = { __typename?: 'Mutation', updateDocumentManualSyncedStatus?: Array<{ __typename?: 'File', id: string } | null> | null };

export type UpdateDocumentUploadActionInternalMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  actionStatus?: InputMaybe<ActionStatus>;
  terminationReason?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDocumentUploadActionInternalMutation = { __typename?: 'Mutation', updateDocumentUploadActionInternal?: { __typename?: 'Document', id: string } | null };

export type UpdateDocumentUploadActionOpenSearchMutationVariables = Exact<{
  sessionPatientId?: InputMaybe<Scalars['ID']>;
  actionStatus?: InputMaybe<ActionStatus>;
}>;


export type UpdateDocumentUploadActionOpenSearchMutation = { __typename?: 'Mutation', updateDocumentUploadActionOpenSearch?: { __typename?: 'Document', id: string, actionStatus?: ActionStatus | null } | null };

export type UpdateDocumentUploadDetailsMutationVariables = Exact<{
  documentId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateDocumentUploadDetailsMutation = { __typename?: 'Mutation', updateDocumentUploadDetails: { __typename?: 'Document', id: string, details?: { __typename?: 'DocumentDetails', id?: string | null, notes?: string | null } | null } };

export type UpdateDocumentUploadInternalMutationVariables = Exact<{
  input?: InputMaybe<DocumentUploadInternalInput>;
}>;


export type UpdateDocumentUploadInternalMutation = { __typename?: 'Mutation', updateDocumentUploadInternal?: { __typename?: 'Patient', id: string, updatedAt?: any | null, matchesLastEntry?: boolean | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, lastEntry?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null } | null, appointments: Array<{ __typename?: 'Appointment', id: string, startTime: any, duration: number, ehrProviderNpi: string, visitType?: string | null, provider?: { __typename?: 'AppointmentProvider', firstName?: string | null, lastName?: string | null, primaryCredential?: string | null } | null }>, document?: { __typename?: 'Document', id: string, createdAt?: any | null, actionStatus?: ActionStatus | null, terminationReason?: string | null, files: Array<{ __typename?: 'File', id: string, fileName: string, type: FileType, ecwSyncStatus?: string | null }>, details?: { __typename?: 'DocumentDetails', id?: string | null, notes?: string | null } | null, events?: Array<{ __typename?: 'Event', id: string, documentId?: string | null, eventDescription?: string | null, createdByName?: string | null, createdByEmail?: string | null, createdAt?: any | null }> | null } | null, assessments?: Array<{ __typename?: 'Assessment', id: string, section?: string | null, questionCode?: string | null, answerValue?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null, scales?: Array<{ __typename?: 'ValidatedScale', type: string, answers: Array<{ __typename?: 'ValidatedScaleAnswer', questionCode: string, answerValue: number, answerCode: string }> }> | null, diagnoses: Array<{ __typename?: 'RedoxDiagnosis', id: string, name?: string | null, codeset: string, code: string, createdAt?: any | null, deletedAt?: any | null }>, pharmacy?: { __typename?: 'PatientPharmacy', name: string, phone: string, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null } | null, providerMatch?: { __typename?: 'ProviderMatch', assignedBy?: string | null, source?: ProviderMatchSource | null, provider?: { __typename?: 'Provider', id: string, firstName?: string | null, lastName?: string | null, photo?: string | null, primaryCredential?: string | null } | null } | null, emergencyContact?: { __typename?: 'PatientEmergencyContact', id?: string | null, firstName: string, middleName?: string | null, lastName: string, relation: string, phone: string } | null, patientGuardians?: Array<{ __typename?: 'PatientGuardian', id?: string | null, firstName: string, lastName: string, birthDate: any, phone: string, email: string, isAddressLinkedWithPatient: boolean, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, discoveryChannel?: string | null, precedence: Precedence, relationToPatient: string } | null> | null } | null };

export type UpdateDocumentUploadMutationVariables = Exact<{
  input?: InputMaybe<DocumentUploadInput>;
}>;


export type UpdateDocumentUploadMutation = { __typename?: 'Mutation', updateDocumentUpload?: { __typename?: 'UnauthenticatedEntity', id: string } | null };

export type UpdateGoogleClickIdMutationVariables = Exact<{
  googleClickId: Scalars['String'];
}>;


export type UpdateGoogleClickIdMutation = { __typename?: 'Mutation', updateGoogleClickId?: { __typename?: 'Patient', id: string } | null };

export type UpdateInsurancePayerPlanMapMutationVariables = Exact<{
  input: UpdateInsurancePayerPlanMapInput;
}>;


export type UpdateInsurancePayerPlanMapMutation = { __typename?: 'Mutation', updateInsurancePayerPlanMap: { __typename?: 'InsurancePayerPlanMap', changeHealthcarePayerId?: string | null, changeHealthcarePayerName?: string | null, contractedInsuranceName?: string | null, id: number, isPriority?: boolean | null, networkStatus?: string | null, payerName?: string | null, payerPlans?: string | null, processingPlanName?: string | null, stateCode?: string | null, subscriberIdPrefix?: string | null } };

export type UpdatePatientConsentReferrerSharingMutationVariables = Exact<{
  consentReferrerSharing: Scalars['Boolean'];
}>;


export type UpdatePatientConsentReferrerSharingMutation = { __typename?: 'Mutation', updatePatientConsentReferrerSharing?: { __typename?: 'EmptyResponse', ok: boolean } | null };

export type UpdateProviderMutationVariables = Exact<{
  input: ProviderInput;
  source?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'Provider', id: string, calendarUrl?: string | null, firstName?: string | null, lastName?: string | null, healowCode?: string | null, primaryCredential?: string | null, isOnlineMatchingEnabled?: boolean | null, isOnlineSchedulingEnabled?: boolean | null, biography?: string | null, notes?: string | null, photo?: string | null, isOpenToTransfers?: boolean | null, npDailyMax?: number | null, specialties?: Array<{ __typename?: 'Specialty', id: string }> | null, ageGroups?: Array<{ __typename?: 'AgeGroup', id: string }> | null, languages?: Array<{ __typename?: 'Language', id: string }> | null, treatmentMethods?: Array<{ __typename?: 'TreatmentMethod', id: string }> | null, providerInsuranceCarriers?: Array<{ __typename?: 'ProviderInsuranceCarrier', stateCode?: string | null, insuranceCarrier?: { __typename?: 'InsuranceCarrier', name: string } | null }> | null } | null };

export type UpdateReferenceInsurancePlanMutationVariables = Exact<{
  input: ReferenceInsurancePlanInput;
}>;


export type UpdateReferenceInsurancePlanMutation = { __typename?: 'Mutation', updateReferenceInsurancePlan: { __typename?: 'ReferenceInsurancePlan', carrier: string, plan: string, inNetwork: boolean, isReferralNeeded: boolean, isOutOfStateNeeded: boolean, notes: string, insuranceCarrierId: number } };

export type UpdatePatientDemographicsMutationVariables = Exact<{
  input?: InputMaybe<PatientInput>;
}>;


export type UpdatePatientDemographicsMutation = { __typename?: 'Mutation', updatePatientDemographics?: { __typename?: 'Patient', id: string, shortCode?: string | null } | null };

export type UpdateSettingsMutationVariables = Exact<{
  input: Array<SettingInput> | SettingInput;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings: Array<{ __typename?: 'Setting', id: string, category: string, key: string, value?: string | null }> };

export type UpdateValidatedScaleMutationVariables = Exact<{
  input?: InputMaybe<ValidatedScaleInput>;
}>;


export type UpdateValidatedScaleMutation = { __typename?: 'Mutation', updateValidatedScale?: { __typename?: 'UnauthenticatedEntity', id: string } | null };

export type UpdateDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string } };

export type WriteBackDemographicsMutationVariables = Exact<{
  input?: InputMaybe<WriteBackDemographicsInput>;
}>;


export type WriteBackDemographicsMutation = { __typename?: 'Mutation', writeBackDemographics?: { __typename?: 'Patient', id: string, matchesLastEntry?: boolean | null, mrn?: string | null, shortCode?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null, sex?: string | null, referralSource?: string | null, lastEntry?: { __typename?: 'Patient', firstName?: string | null, lastName?: string | null, birthDate?: Day | null, phone?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCity?: string | null, addressState?: string | null, addressZipCode?: string | null, email?: string | null } | null } | null };

export const PatientDemographicsFragmentDoc = /*#__PURE__*/ gql`
    fragment PatientDemographics on Patient {
  mrn
  shortCode
  firstName
  middleName
  lastName
  birthDate
  phone
  addressStreet1
  addressStreet2
  addressCity
  addressState
  addressZipCode
  email
  sex
  referralSource
}
    `;
export const FullPatientFragmentDoc = /*#__PURE__*/ gql`
    fragment FullPatient on Patient {
  id
  updatedAt
  ...PatientDemographics
  lastEntry {
    firstName
    lastName
    birthDate
    phone
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressZipCode
    email
  }
  matchesLastEntry
  appointments {
    id
    startTime
    duration
    ehrProviderNpi
    visitType
    provider {
      firstName
      lastName
      primaryCredential
    }
  }
  document {
    id
    createdAt
    actionStatus
    files {
      id
      fileName
      type
      ecwSyncStatus
    }
    details {
      id
      notes
    }
    events {
      id
      documentId
      eventDescription
      createdByName
      createdByEmail
      createdAt
    }
    terminationReason
  }
  assessments {
    id
    section
    questionCode
    answerValue
    createdAt
    updatedAt
  }
  scales {
    type
    answers {
      questionCode
      answerValue
      answerCode
    }
  }
  diagnoses {
    id
    name
    codeset
    code
    createdAt
    deletedAt
  }
  pharmacy {
    name
    phone
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressZipCode
  }
  providerMatch {
    assignedBy
    source
    provider {
      id
      firstName
      lastName
      photo
      primaryCredential
    }
  }
  emergencyContact {
    id
    firstName
    middleName
    lastName
    relation
    phone
  }
  patientGuardians {
    id
    firstName
    lastName
    birthDate
    phone
    email
    isAddressLinkedWithPatient
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressZipCode
    discoveryChannel
    precedence
    relationToPatient
  }
}
    ${PatientDemographicsFragmentDoc}`;
export const PatientAssessmentResponsesFragmentDoc = /*#__PURE__*/ gql`
    fragment PatientAssessmentResponses on Patient {
  assessments {
    id
    questionCode
    answerValue
  }
}
    `;
export const AcceptTransferRequestDocument = /*#__PURE__*/ gql`
    mutation acceptTransferRequest($id: ID!, $acceptingProviderNpi: String!) {
  acceptTransferRequest(id: $id, acceptingProviderNpi: $acceptingProviderNpi) {
    id
  }
}
    `;
export type AcceptTransferRequestMutationFn = Apollo.MutationFunction<AcceptTransferRequestMutation, AcceptTransferRequestMutationVariables>;

/**
 * __useAcceptTransferRequestMutation__
 *
 * To run a mutation, you first call `useAcceptTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTransferRequestMutation, { data, loading, error }] = useAcceptTransferRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      acceptingProviderNpi: // value for 'acceptingProviderNpi'
 *   },
 * });
 */
export function useAcceptTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTransferRequestMutation, AcceptTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTransferRequestMutation, AcceptTransferRequestMutationVariables>(AcceptTransferRequestDocument, options);
      }
export type AcceptTransferRequestMutationHookResult = ReturnType<typeof useAcceptTransferRequestMutation>;
export type AcceptTransferRequestMutationResult = Apollo.MutationResult<AcceptTransferRequestMutation>;
export type AcceptTransferRequestMutationOptions = Apollo.BaseMutationOptions<AcceptTransferRequestMutation, AcceptTransferRequestMutationVariables>;
export const BookAppointmentDocument = /*#__PURE__*/ gql`
    mutation bookAppointment($input: BookAppointmentInput!) {
  bookAppointment(input: $input) {
    ehrEncounterId
  }
}
    `;
export type BookAppointmentMutationFn = Apollo.MutationFunction<BookAppointmentMutation, BookAppointmentMutationVariables>;

/**
 * __useBookAppointmentMutation__
 *
 * To run a mutation, you first call `useBookAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookAppointmentMutation, { data, loading, error }] = useBookAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<BookAppointmentMutation, BookAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookAppointmentMutation, BookAppointmentMutationVariables>(BookAppointmentDocument, options);
      }
export type BookAppointmentMutationHookResult = ReturnType<typeof useBookAppointmentMutation>;
export type BookAppointmentMutationResult = Apollo.MutationResult<BookAppointmentMutation>;
export type BookAppointmentMutationOptions = Apollo.BaseMutationOptions<BookAppointmentMutation, BookAppointmentMutationVariables>;
export const CancelAppointmentDocument = /*#__PURE__*/ gql`
    mutation cancelAppointment($scheduleRequestId: ID!) {
  cancelAppointment(scheduleRequestId: $scheduleRequestId) {
    ok
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      scheduleRequestId: // value for 'scheduleRequestId'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const CancelTransferRequestDocument = /*#__PURE__*/ gql`
    mutation cancelTransferRequest($id: ID!) {
  cancelTransferRequest(id: $id) {
    id
  }
}
    `;
export type CancelTransferRequestMutationFn = Apollo.MutationFunction<CancelTransferRequestMutation, CancelTransferRequestMutationVariables>;

/**
 * __useCancelTransferRequestMutation__
 *
 * To run a mutation, you first call `useCancelTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransferRequestMutation, { data, loading, error }] = useCancelTransferRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelTransferRequestMutation, CancelTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTransferRequestMutation, CancelTransferRequestMutationVariables>(CancelTransferRequestDocument, options);
      }
export type CancelTransferRequestMutationHookResult = ReturnType<typeof useCancelTransferRequestMutation>;
export type CancelTransferRequestMutationResult = Apollo.MutationResult<CancelTransferRequestMutation>;
export type CancelTransferRequestMutationOptions = Apollo.BaseMutationOptions<CancelTransferRequestMutation, CancelTransferRequestMutationVariables>;
export const CheckZdProviderForMatchDocument = /*#__PURE__*/ gql`
    query checkZDProviderForMatch {
  checkZDProviderForMatch {
    zocdocAppointment {
      providerId
      startTime
    }
    zocdocProvider {
      firstName
      lastName
      primaryCredential
    }
    isZDProviderAMatch
    zdProviderMatchFailureReasons
    zdProviderDealbreakersForPatientReasons
    patientMatchFailureReasons
    matchedProviders {
      provider {
        id
        firstName
        lastName
        biography
        primaryCredential
        photo
        calendarUrl
        modality
        specialties {
          id
          name
          treatmentPrerequisiteId
        }
        licenses {
          stateCode
          certificationType
        }
        providerTimeslots {
          startTime
          endTime
          providerId
          isAvailable
        }
      }
    }
  }
}
    `;

/**
 * __useCheckZdProviderForMatchQuery__
 *
 * To run a query within a React component, call `useCheckZdProviderForMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckZdProviderForMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckZdProviderForMatchQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckZdProviderForMatchQuery(baseOptions?: Apollo.QueryHookOptions<CheckZdProviderForMatchQuery, CheckZdProviderForMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckZdProviderForMatchQuery, CheckZdProviderForMatchQueryVariables>(CheckZdProviderForMatchDocument, options);
      }
export function useCheckZdProviderForMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckZdProviderForMatchQuery, CheckZdProviderForMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckZdProviderForMatchQuery, CheckZdProviderForMatchQueryVariables>(CheckZdProviderForMatchDocument, options);
        }
export type CheckZdProviderForMatchQueryHookResult = ReturnType<typeof useCheckZdProviderForMatchQuery>;
export type CheckZdProviderForMatchLazyQueryHookResult = ReturnType<typeof useCheckZdProviderForMatchLazyQuery>;
export type CheckZdProviderForMatchQueryResult = Apollo.QueryResult<CheckZdProviderForMatchQuery, CheckZdProviderForMatchQueryVariables>;
export const ClaimIntakeDocument = /*#__PURE__*/ gql`
    mutation claimIntake($uploadedDocumentId: ID!) {
  claimIntake(uploadedDocumentId: $uploadedDocumentId) {
    id
  }
}
    `;
export type ClaimIntakeMutationFn = Apollo.MutationFunction<ClaimIntakeMutation, ClaimIntakeMutationVariables>;

/**
 * __useClaimIntakeMutation__
 *
 * To run a mutation, you first call `useClaimIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimIntakeMutation, { data, loading, error }] = useClaimIntakeMutation({
 *   variables: {
 *      uploadedDocumentId: // value for 'uploadedDocumentId'
 *   },
 * });
 */
export function useClaimIntakeMutation(baseOptions?: Apollo.MutationHookOptions<ClaimIntakeMutation, ClaimIntakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimIntakeMutation, ClaimIntakeMutationVariables>(ClaimIntakeDocument, options);
      }
export type ClaimIntakeMutationHookResult = ReturnType<typeof useClaimIntakeMutation>;
export type ClaimIntakeMutationResult = Apollo.MutationResult<ClaimIntakeMutation>;
export type ClaimIntakeMutationOptions = Apollo.BaseMutationOptions<ClaimIntakeMutation, ClaimIntakeMutationVariables>;
export const ClearAssessmentResponseDocument = /*#__PURE__*/ gql`
    mutation clearAssessmentResponse($input: ClearAssessmentResponseInput) {
  clearAssessmentResponse(input: $input) {
    ok
  }
}
    `;
export type ClearAssessmentResponseMutationFn = Apollo.MutationFunction<ClearAssessmentResponseMutation, ClearAssessmentResponseMutationVariables>;

/**
 * __useClearAssessmentResponseMutation__
 *
 * To run a mutation, you first call `useClearAssessmentResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAssessmentResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAssessmentResponseMutation, { data, loading, error }] = useClearAssessmentResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearAssessmentResponseMutation(baseOptions?: Apollo.MutationHookOptions<ClearAssessmentResponseMutation, ClearAssessmentResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearAssessmentResponseMutation, ClearAssessmentResponseMutationVariables>(ClearAssessmentResponseDocument, options);
      }
export type ClearAssessmentResponseMutationHookResult = ReturnType<typeof useClearAssessmentResponseMutation>;
export type ClearAssessmentResponseMutationResult = Apollo.MutationResult<ClearAssessmentResponseMutation>;
export type ClearAssessmentResponseMutationOptions = Apollo.BaseMutationOptions<ClearAssessmentResponseMutation, ClearAssessmentResponseMutationVariables>;
export const CreateConsultNotAFitDocument = /*#__PURE__*/ gql`
    mutation createConsultNotAFit($mrn: String!, $reasonForCnaf: String!, $clinicianNotes: String!) {
  createConsultNotAFit(
    mrn: $mrn
    reasonForCnaf: $reasonForCnaf
    clinicianNotes: $clinicianNotes
  ) {
    ok
  }
}
    `;
export type CreateConsultNotAFitMutationFn = Apollo.MutationFunction<CreateConsultNotAFitMutation, CreateConsultNotAFitMutationVariables>;

/**
 * __useCreateConsultNotAFitMutation__
 *
 * To run a mutation, you first call `useCreateConsultNotAFitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsultNotAFitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsultNotAFitMutation, { data, loading, error }] = useCreateConsultNotAFitMutation({
 *   variables: {
 *      mrn: // value for 'mrn'
 *      reasonForCnaf: // value for 'reasonForCnaf'
 *      clinicianNotes: // value for 'clinicianNotes'
 *   },
 * });
 */
export function useCreateConsultNotAFitMutation(baseOptions?: Apollo.MutationHookOptions<CreateConsultNotAFitMutation, CreateConsultNotAFitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConsultNotAFitMutation, CreateConsultNotAFitMutationVariables>(CreateConsultNotAFitDocument, options);
      }
export type CreateConsultNotAFitMutationHookResult = ReturnType<typeof useCreateConsultNotAFitMutation>;
export type CreateConsultNotAFitMutationResult = Apollo.MutationResult<CreateConsultNotAFitMutation>;
export type CreateConsultNotAFitMutationOptions = Apollo.BaseMutationOptions<CreateConsultNotAFitMutation, CreateConsultNotAFitMutationVariables>;
export const CreateInsurancePayerPlanMapDocument = /*#__PURE__*/ gql`
    mutation createInsurancePayerPlanMap {
  createInsurancePayerPlanMap {
    id
  }
}
    `;
export type CreateInsurancePayerPlanMapMutationFn = Apollo.MutationFunction<CreateInsurancePayerPlanMapMutation, CreateInsurancePayerPlanMapMutationVariables>;

/**
 * __useCreateInsurancePayerPlanMapMutation__
 *
 * To run a mutation, you first call `useCreateInsurancePayerPlanMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsurancePayerPlanMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsurancePayerPlanMapMutation, { data, loading, error }] = useCreateInsurancePayerPlanMapMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateInsurancePayerPlanMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsurancePayerPlanMapMutation, CreateInsurancePayerPlanMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsurancePayerPlanMapMutation, CreateInsurancePayerPlanMapMutationVariables>(CreateInsurancePayerPlanMapDocument, options);
      }
export type CreateInsurancePayerPlanMapMutationHookResult = ReturnType<typeof useCreateInsurancePayerPlanMapMutation>;
export type CreateInsurancePayerPlanMapMutationResult = Apollo.MutationResult<CreateInsurancePayerPlanMapMutation>;
export type CreateInsurancePayerPlanMapMutationOptions = Apollo.BaseMutationOptions<CreateInsurancePayerPlanMapMutation, CreateInsurancePayerPlanMapMutationVariables>;
export const CreateReferralDocument = /*#__PURE__*/ gql`
    mutation createReferral($input: CreateReferralInput!) {
  createReferral(input: $input) {
    ok
  }
}
    `;
export type CreateReferralMutationFn = Apollo.MutationFunction<CreateReferralMutation, CreateReferralMutationVariables>;

/**
 * __useCreateReferralMutation__
 *
 * To run a mutation, you first call `useCreateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferralMutation, { data, loading, error }] = useCreateReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferralMutation, CreateReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferralMutation, CreateReferralMutationVariables>(CreateReferralDocument, options);
      }
export type CreateReferralMutationHookResult = ReturnType<typeof useCreateReferralMutation>;
export type CreateReferralMutationResult = Apollo.MutationResult<CreateReferralMutation>;
export type CreateReferralMutationOptions = Apollo.BaseMutationOptions<CreateReferralMutation, CreateReferralMutationVariables>;
export const CreateScheduleRequestDocument = /*#__PURE__*/ gql`
    mutation createScheduleRequest($input: ScheduleRequestInput!) {
  createScheduleRequest(input: $input) {
    id
  }
}
    `;
export type CreateScheduleRequestMutationFn = Apollo.MutationFunction<CreateScheduleRequestMutation, CreateScheduleRequestMutationVariables>;

/**
 * __useCreateScheduleRequestMutation__
 *
 * To run a mutation, you first call `useCreateScheduleRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleRequestMutation, { data, loading, error }] = useCreateScheduleRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleRequestMutation, CreateScheduleRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleRequestMutation, CreateScheduleRequestMutationVariables>(CreateScheduleRequestDocument, options);
      }
export type CreateScheduleRequestMutationHookResult = ReturnType<typeof useCreateScheduleRequestMutation>;
export type CreateScheduleRequestMutationResult = Apollo.MutationResult<CreateScheduleRequestMutation>;
export type CreateScheduleRequestMutationOptions = Apollo.BaseMutationOptions<CreateScheduleRequestMutation, CreateScheduleRequestMutationVariables>;
export const CreateScheduleRequestsDocument = /*#__PURE__*/ gql`
    mutation createScheduleRequests($inputs: [ScheduleRequestInput!]!) {
  createScheduleRequests(inputs: $inputs) {
    id
    mrn
    npi
    appointmentType
    visitDuration
  }
}
    `;
export type CreateScheduleRequestsMutationFn = Apollo.MutationFunction<CreateScheduleRequestsMutation, CreateScheduleRequestsMutationVariables>;

/**
 * __useCreateScheduleRequestsMutation__
 *
 * To run a mutation, you first call `useCreateScheduleRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleRequestsMutation, { data, loading, error }] = useCreateScheduleRequestsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateScheduleRequestsMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleRequestsMutation, CreateScheduleRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleRequestsMutation, CreateScheduleRequestsMutationVariables>(CreateScheduleRequestsDocument, options);
      }
export type CreateScheduleRequestsMutationHookResult = ReturnType<typeof useCreateScheduleRequestsMutation>;
export type CreateScheduleRequestsMutationResult = Apollo.MutationResult<CreateScheduleRequestsMutation>;
export type CreateScheduleRequestsMutationOptions = Apollo.BaseMutationOptions<CreateScheduleRequestsMutation, CreateScheduleRequestsMutationVariables>;
export const CreateSupportTicketDocument = /*#__PURE__*/ gql`
    mutation createSupportTicket($stepsAttempted: String!, $screenDescription: String!, $troubleshootingSteps: String!, $href: String!, $image: String!) {
  createSupportTicket(
    stepsAttempted: $stepsAttempted
    screenDescription: $screenDescription
    troubleshootingSteps: $troubleshootingSteps
    href: $href
    image: $image
  ) {
    ok
  }
}
    `;
export type CreateSupportTicketMutationFn = Apollo.MutationFunction<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;

/**
 * __useCreateSupportTicketMutation__
 *
 * To run a mutation, you first call `useCreateSupportTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportTicketMutation, { data, loading, error }] = useCreateSupportTicketMutation({
 *   variables: {
 *      stepsAttempted: // value for 'stepsAttempted'
 *      screenDescription: // value for 'screenDescription'
 *      troubleshootingSteps: // value for 'troubleshootingSteps'
 *      href: // value for 'href'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useCreateSupportTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>(CreateSupportTicketDocument, options);
      }
export type CreateSupportTicketMutationHookResult = ReturnType<typeof useCreateSupportTicketMutation>;
export type CreateSupportTicketMutationResult = Apollo.MutationResult<CreateSupportTicketMutation>;
export type CreateSupportTicketMutationOptions = Apollo.BaseMutationOptions<CreateSupportTicketMutation, CreateSupportTicketMutationVariables>;
export const CreateTransferRequestDocument = /*#__PURE__*/ gql`
    mutation createTransferRequest($patientMrn: String!, $requestingProviderNpi: String!, $reasonForTransfer: String!, $clinicianNotes: String!, $initiator: String!, $specialtyIds: [String!], $genderPreference: String, $directTransferNpi: String) {
  createTransferRequest(
    patientMrn: $patientMrn
    requestingProviderNpi: $requestingProviderNpi
    reasonForTransfer: $reasonForTransfer
    clinicianNotes: $clinicianNotes
    initiator: $initiator
    specialtyIds: $specialtyIds
    genderPreference: $genderPreference
    directTransferNpi: $directTransferNpi
  ) {
    id
  }
}
    `;
export type CreateTransferRequestMutationFn = Apollo.MutationFunction<CreateTransferRequestMutation, CreateTransferRequestMutationVariables>;

/**
 * __useCreateTransferRequestMutation__
 *
 * To run a mutation, you first call `useCreateTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferRequestMutation, { data, loading, error }] = useCreateTransferRequestMutation({
 *   variables: {
 *      patientMrn: // value for 'patientMrn'
 *      requestingProviderNpi: // value for 'requestingProviderNpi'
 *      reasonForTransfer: // value for 'reasonForTransfer'
 *      clinicianNotes: // value for 'clinicianNotes'
 *      initiator: // value for 'initiator'
 *      specialtyIds: // value for 'specialtyIds'
 *      genderPreference: // value for 'genderPreference'
 *      directTransferNpi: // value for 'directTransferNpi'
 *   },
 * });
 */
export function useCreateTransferRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferRequestMutation, CreateTransferRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferRequestMutation, CreateTransferRequestMutationVariables>(CreateTransferRequestDocument, options);
      }
export type CreateTransferRequestMutationHookResult = ReturnType<typeof useCreateTransferRequestMutation>;
export type CreateTransferRequestMutationResult = Apollo.MutationResult<CreateTransferRequestMutation>;
export type CreateTransferRequestMutationOptions = Apollo.BaseMutationOptions<CreateTransferRequestMutation, CreateTransferRequestMutationVariables>;
export const DeleteInsurancePayerPlanMapDocument = /*#__PURE__*/ gql`
    mutation deleteInsurancePayerPlanMap($id: Int!) {
  deleteInsurancePayerPlanMap(id: $id) {
    ok
  }
}
    `;
export type DeleteInsurancePayerPlanMapMutationFn = Apollo.MutationFunction<DeleteInsurancePayerPlanMapMutation, DeleteInsurancePayerPlanMapMutationVariables>;

/**
 * __useDeleteInsurancePayerPlanMapMutation__
 *
 * To run a mutation, you first call `useDeleteInsurancePayerPlanMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsurancePayerPlanMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsurancePayerPlanMapMutation, { data, loading, error }] = useDeleteInsurancePayerPlanMapMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsurancePayerPlanMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsurancePayerPlanMapMutation, DeleteInsurancePayerPlanMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsurancePayerPlanMapMutation, DeleteInsurancePayerPlanMapMutationVariables>(DeleteInsurancePayerPlanMapDocument, options);
      }
export type DeleteInsurancePayerPlanMapMutationHookResult = ReturnType<typeof useDeleteInsurancePayerPlanMapMutation>;
export type DeleteInsurancePayerPlanMapMutationResult = Apollo.MutationResult<DeleteInsurancePayerPlanMapMutation>;
export type DeleteInsurancePayerPlanMapMutationOptions = Apollo.BaseMutationOptions<DeleteInsurancePayerPlanMapMutation, DeleteInsurancePayerPlanMapMutationVariables>;
export const EditPatientEmergencyContactDocument = /*#__PURE__*/ gql`
    mutation editPatientEmergencyContact($input: PatientEmergencyContactInput!) {
  editPatientEmergencyContact(input: $input) {
    ok
  }
}
    `;
export type EditPatientEmergencyContactMutationFn = Apollo.MutationFunction<EditPatientEmergencyContactMutation, EditPatientEmergencyContactMutationVariables>;

/**
 * __useEditPatientEmergencyContactMutation__
 *
 * To run a mutation, you first call `useEditPatientEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientEmergencyContactMutation, { data, loading, error }] = useEditPatientEmergencyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPatientEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<EditPatientEmergencyContactMutation, EditPatientEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPatientEmergencyContactMutation, EditPatientEmergencyContactMutationVariables>(EditPatientEmergencyContactDocument, options);
      }
export type EditPatientEmergencyContactMutationHookResult = ReturnType<typeof useEditPatientEmergencyContactMutation>;
export type EditPatientEmergencyContactMutationResult = Apollo.MutationResult<EditPatientEmergencyContactMutation>;
export type EditPatientEmergencyContactMutationOptions = Apollo.BaseMutationOptions<EditPatientEmergencyContactMutation, EditPatientEmergencyContactMutationVariables>;
export const EditPatientGuardiansDocument = /*#__PURE__*/ gql`
    mutation editPatientGuardians($input: EditPatientGuardiansInput!) {
  editPatientGuardians(input: $input) {
    ok
  }
}
    `;
export type EditPatientGuardiansMutationFn = Apollo.MutationFunction<EditPatientGuardiansMutation, EditPatientGuardiansMutationVariables>;

/**
 * __useEditPatientGuardiansMutation__
 *
 * To run a mutation, you first call `useEditPatientGuardiansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientGuardiansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientGuardiansMutation, { data, loading, error }] = useEditPatientGuardiansMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPatientGuardiansMutation(baseOptions?: Apollo.MutationHookOptions<EditPatientGuardiansMutation, EditPatientGuardiansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPatientGuardiansMutation, EditPatientGuardiansMutationVariables>(EditPatientGuardiansDocument, options);
      }
export type EditPatientGuardiansMutationHookResult = ReturnType<typeof useEditPatientGuardiansMutation>;
export type EditPatientGuardiansMutationResult = Apollo.MutationResult<EditPatientGuardiansMutation>;
export type EditPatientGuardiansMutationOptions = Apollo.BaseMutationOptions<EditPatientGuardiansMutation, EditPatientGuardiansMutationVariables>;
export const EditPatientPharmacyDocument = /*#__PURE__*/ gql`
    mutation editPatientPharmacy($input: PatientPharmacyInput) {
  editPatientPharmacy(input: $input) {
    ok
  }
}
    `;
export type EditPatientPharmacyMutationFn = Apollo.MutationFunction<EditPatientPharmacyMutation, EditPatientPharmacyMutationVariables>;

/**
 * __useEditPatientPharmacyMutation__
 *
 * To run a mutation, you first call `useEditPatientPharmacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientPharmacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientPharmacyMutation, { data, loading, error }] = useEditPatientPharmacyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPatientPharmacyMutation(baseOptions?: Apollo.MutationHookOptions<EditPatientPharmacyMutation, EditPatientPharmacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPatientPharmacyMutation, EditPatientPharmacyMutationVariables>(EditPatientPharmacyDocument, options);
      }
export type EditPatientPharmacyMutationHookResult = ReturnType<typeof useEditPatientPharmacyMutation>;
export type EditPatientPharmacyMutationResult = Apollo.MutationResult<EditPatientPharmacyMutation>;
export type EditPatientPharmacyMutationOptions = Apollo.BaseMutationOptions<EditPatientPharmacyMutation, EditPatientPharmacyMutationVariables>;
export const EditPatientPrimaryPolicyholderDocument = /*#__PURE__*/ gql`
    mutation editPatientPrimaryPolicyholder($input: PatientPrimaryPolicyholderInput) {
  editPatientPrimaryPolicyholder(input: $input) {
    ok
  }
}
    `;
export type EditPatientPrimaryPolicyholderMutationFn = Apollo.MutationFunction<EditPatientPrimaryPolicyholderMutation, EditPatientPrimaryPolicyholderMutationVariables>;

/**
 * __useEditPatientPrimaryPolicyholderMutation__
 *
 * To run a mutation, you first call `useEditPatientPrimaryPolicyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientPrimaryPolicyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientPrimaryPolicyholderMutation, { data, loading, error }] = useEditPatientPrimaryPolicyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPatientPrimaryPolicyholderMutation(baseOptions?: Apollo.MutationHookOptions<EditPatientPrimaryPolicyholderMutation, EditPatientPrimaryPolicyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPatientPrimaryPolicyholderMutation, EditPatientPrimaryPolicyholderMutationVariables>(EditPatientPrimaryPolicyholderDocument, options);
      }
export type EditPatientPrimaryPolicyholderMutationHookResult = ReturnType<typeof useEditPatientPrimaryPolicyholderMutation>;
export type EditPatientPrimaryPolicyholderMutationResult = Apollo.MutationResult<EditPatientPrimaryPolicyholderMutation>;
export type EditPatientPrimaryPolicyholderMutationOptions = Apollo.BaseMutationOptions<EditPatientPrimaryPolicyholderMutation, EditPatientPrimaryPolicyholderMutationVariables>;
export const EditPatientDocument = /*#__PURE__*/ gql`
    mutation editPatient($input: EditPatientInput) {
  editPatient(input: $input) {
    id
    ...PatientDemographics
    lastEntry {
      firstName
      lastName
      birthDate
      phone
      addressStreet1
      addressStreet2
      addressCity
      addressState
      addressZipCode
      email
      sex
    }
    matchesLastEntry
  }
}
    ${PatientDemographicsFragmentDoc}`;
export type EditPatientMutationFn = Apollo.MutationFunction<EditPatientMutation, EditPatientMutationVariables>;

/**
 * __useEditPatientMutation__
 *
 * To run a mutation, you first call `useEditPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPatientMutation, { data, loading, error }] = useEditPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditPatientMutation(baseOptions?: Apollo.MutationHookOptions<EditPatientMutation, EditPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPatientMutation, EditPatientMutationVariables>(EditPatientDocument, options);
      }
export type EditPatientMutationHookResult = ReturnType<typeof useEditPatientMutation>;
export type EditPatientMutationResult = Apollo.MutationResult<EditPatientMutation>;
export type EditPatientMutationOptions = Apollo.BaseMutationOptions<EditPatientMutation, EditPatientMutationVariables>;
export const FindAppointmentsDocument = /*#__PURE__*/ gql`
    query findAppointments($input: FindAppointmentsInput!) {
  findAppointments(input: $input) {
    id
    patient {
      id
      ...PatientDemographics
    }
    startTime
    duration
    visitType
    ehrProviderNpi
    provider {
      firstName
      lastName
      primaryCredential
    }
  }
}
    ${PatientDemographicsFragmentDoc}`;

/**
 * __useFindAppointmentsQuery__
 *
 * To run a query within a React component, call `useFindAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<FindAppointmentsQuery, FindAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAppointmentsQuery, FindAppointmentsQueryVariables>(FindAppointmentsDocument, options);
      }
export function useFindAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAppointmentsQuery, FindAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAppointmentsQuery, FindAppointmentsQueryVariables>(FindAppointmentsDocument, options);
        }
export type FindAppointmentsQueryHookResult = ReturnType<typeof useFindAppointmentsQuery>;
export type FindAppointmentsLazyQueryHookResult = ReturnType<typeof useFindAppointmentsLazyQuery>;
export type FindAppointmentsQueryResult = Apollo.QueryResult<FindAppointmentsQuery, FindAppointmentsQueryVariables>;
export const FindPatientsDocument = /*#__PURE__*/ gql`
    query findPatients($input: FindPatientsInput!) {
  findPatients(input: $input) {
    id
    ...PatientDemographics
    appointments {
      id
      startTime
      duration
      ehrProviderNpi
      visitType
      provider {
        firstName
        lastName
        primaryCredential
      }
    }
  }
}
    ${PatientDemographicsFragmentDoc}`;

/**
 * __useFindPatientsQuery__
 *
 * To run a query within a React component, call `useFindPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPatientsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindPatientsQuery(baseOptions: Apollo.QueryHookOptions<FindPatientsQuery, FindPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPatientsQuery, FindPatientsQueryVariables>(FindPatientsDocument, options);
      }
export function useFindPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPatientsQuery, FindPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPatientsQuery, FindPatientsQueryVariables>(FindPatientsDocument, options);
        }
export type FindPatientsQueryHookResult = ReturnType<typeof useFindPatientsQuery>;
export type FindPatientsLazyQueryHookResult = ReturnType<typeof useFindPatientsLazyQuery>;
export type FindPatientsQueryResult = Apollo.QueryResult<FindPatientsQuery, FindPatientsQueryVariables>;
export const GetAcceptedItxRequestsDocument = /*#__PURE__*/ gql`
    query getAcceptedItxRequests($overrideProviderNpi: String) {
  getAcceptedItxRequests(overrideProviderNpi: $overrideProviderNpi) {
    id
    createdAt
    acceptedAt
  }
}
    `;

/**
 * __useGetAcceptedItxRequestsQuery__
 *
 * To run a query within a React component, call `useGetAcceptedItxRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedItxRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedItxRequestsQuery({
 *   variables: {
 *      overrideProviderNpi: // value for 'overrideProviderNpi'
 *   },
 * });
 */
export function useGetAcceptedItxRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetAcceptedItxRequestsQuery, GetAcceptedItxRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcceptedItxRequestsQuery, GetAcceptedItxRequestsQueryVariables>(GetAcceptedItxRequestsDocument, options);
      }
export function useGetAcceptedItxRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedItxRequestsQuery, GetAcceptedItxRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcceptedItxRequestsQuery, GetAcceptedItxRequestsQueryVariables>(GetAcceptedItxRequestsDocument, options);
        }
export type GetAcceptedItxRequestsQueryHookResult = ReturnType<typeof useGetAcceptedItxRequestsQuery>;
export type GetAcceptedItxRequestsLazyQueryHookResult = ReturnType<typeof useGetAcceptedItxRequestsLazyQuery>;
export type GetAcceptedItxRequestsQueryResult = Apollo.QueryResult<GetAcceptedItxRequestsQuery, GetAcceptedItxRequestsQueryVariables>;
export const GetActivePatientDocument = /*#__PURE__*/ gql`
    query getActivePatient($mrn: String!) {
  getActivePatient(mrn: $mrn) {
    adherenceLetterSent
    clinicalStatus
    daysSinceLastVisit
    dob
    dutyOfCareCountdown
    ecwChartStatus
    email
    externalMrn
    firstName
    isDischargeLetterSentWithinTwoDays
    isAdherenceLetterSentWithinTwoDays
    itxRequests {
      acceptedAt
      expiration
    }
    lastCompletedAppointment
    lastName
    lastProviderEmail
    lastProviderName
    lastProviderNpi
    mrn
    nextAppointment
    primaryDiagnoses
    recommendedAction
    secondaryDiagnoses
    transferStatus
  }
}
    `;

/**
 * __useGetActivePatientQuery__
 *
 * To run a query within a React component, call `useGetActivePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePatientQuery({
 *   variables: {
 *      mrn: // value for 'mrn'
 *   },
 * });
 */
export function useGetActivePatientQuery(baseOptions: Apollo.QueryHookOptions<GetActivePatientQuery, GetActivePatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePatientQuery, GetActivePatientQueryVariables>(GetActivePatientDocument, options);
      }
export function useGetActivePatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePatientQuery, GetActivePatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePatientQuery, GetActivePatientQueryVariables>(GetActivePatientDocument, options);
        }
export type GetActivePatientQueryHookResult = ReturnType<typeof useGetActivePatientQuery>;
export type GetActivePatientLazyQueryHookResult = ReturnType<typeof useGetActivePatientLazyQuery>;
export type GetActivePatientQueryResult = Apollo.QueryResult<GetActivePatientQuery, GetActivePatientQueryVariables>;
export const GetActivePatientsByMrnsDocument = /*#__PURE__*/ gql`
    query getActivePatientsByMrns($mrns: [String!]!) {
  getActivePatientsByMrns(mrns: $mrns) {
    mrn
    primaryDiagnoses
    secondaryDiagnoses
    clinicalStatus
  }
}
    `;

/**
 * __useGetActivePatientsByMrnsQuery__
 *
 * To run a query within a React component, call `useGetActivePatientsByMrnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePatientsByMrnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePatientsByMrnsQuery({
 *   variables: {
 *      mrns: // value for 'mrns'
 *   },
 * });
 */
export function useGetActivePatientsByMrnsQuery(baseOptions: Apollo.QueryHookOptions<GetActivePatientsByMrnsQuery, GetActivePatientsByMrnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePatientsByMrnsQuery, GetActivePatientsByMrnsQueryVariables>(GetActivePatientsByMrnsDocument, options);
      }
export function useGetActivePatientsByMrnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePatientsByMrnsQuery, GetActivePatientsByMrnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePatientsByMrnsQuery, GetActivePatientsByMrnsQueryVariables>(GetActivePatientsByMrnsDocument, options);
        }
export type GetActivePatientsByMrnsQueryHookResult = ReturnType<typeof useGetActivePatientsByMrnsQuery>;
export type GetActivePatientsByMrnsLazyQueryHookResult = ReturnType<typeof useGetActivePatientsByMrnsLazyQuery>;
export type GetActivePatientsByMrnsQueryResult = Apollo.QueryResult<GetActivePatientsByMrnsQuery, GetActivePatientsByMrnsQueryVariables>;
export const GetActivePatientsDocument = /*#__PURE__*/ gql`
    query getActivePatients($overrideProviderNpi: String) {
  getActivePatients(overrideProviderNpi: $overrideProviderNpi) {
    adherenceLetterSent
    clinicalStatus
    daysSinceLastVisit
    dob
    dutyOfCareCountdown
    ecwChartStatus
    email
    externalMrn
    firstName
    isDischargeLetterSentWithinTwoDays
    isAdherenceLetterSentWithinTwoDays
    itxRequests {
      acceptedAt
      expiration
    }
    lastCompletedAppointment
    lastName
    lastProviderEmail
    lastProviderName
    lastProviderNpi
    mrn
    nextAppointment
    primaryDiagnoses
    recommendedAction
    secondaryDiagnoses
    transferStatus
  }
}
    `;

/**
 * __useGetActivePatientsQuery__
 *
 * To run a query within a React component, call `useGetActivePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePatientsQuery({
 *   variables: {
 *      overrideProviderNpi: // value for 'overrideProviderNpi'
 *   },
 * });
 */
export function useGetActivePatientsQuery(baseOptions?: Apollo.QueryHookOptions<GetActivePatientsQuery, GetActivePatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePatientsQuery, GetActivePatientsQueryVariables>(GetActivePatientsDocument, options);
      }
export function useGetActivePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePatientsQuery, GetActivePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePatientsQuery, GetActivePatientsQueryVariables>(GetActivePatientsDocument, options);
        }
export type GetActivePatientsQueryHookResult = ReturnType<typeof useGetActivePatientsQuery>;
export type GetActivePatientsLazyQueryHookResult = ReturnType<typeof useGetActivePatientsLazyQuery>;
export type GetActivePatientsQueryResult = Apollo.QueryResult<GetActivePatientsQuery, GetActivePatientsQueryVariables>;
export const GetAgeGroupsDocument = /*#__PURE__*/ gql`
    query getAgeGroups {
  getAgeGroups {
    id
    name
    rangeStart
    rangeEnd
  }
}
    `;

/**
 * __useGetAgeGroupsQuery__
 *
 * To run a query within a React component, call `useGetAgeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgeGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgeGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgeGroupsQuery, GetAgeGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgeGroupsQuery, GetAgeGroupsQueryVariables>(GetAgeGroupsDocument, options);
      }
export function useGetAgeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgeGroupsQuery, GetAgeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgeGroupsQuery, GetAgeGroupsQueryVariables>(GetAgeGroupsDocument, options);
        }
export type GetAgeGroupsQueryHookResult = ReturnType<typeof useGetAgeGroupsQuery>;
export type GetAgeGroupsLazyQueryHookResult = ReturnType<typeof useGetAgeGroupsLazyQuery>;
export type GetAgeGroupsQueryResult = Apollo.QueryResult<GetAgeGroupsQuery, GetAgeGroupsQueryVariables>;
export const GetAllItxProviderMatchesByNpiDocument = /*#__PURE__*/ gql`
    query getAllItxProviderMatchesByNpi($overrideProviderNpi: String) {
  getAllItxProviderMatchesByNpi(overrideProviderNpi: $overrideProviderNpi) {
    id
    rejectedAt
  }
}
    `;

/**
 * __useGetAllItxProviderMatchesByNpiQuery__
 *
 * To run a query within a React component, call `useGetAllItxProviderMatchesByNpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllItxProviderMatchesByNpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllItxProviderMatchesByNpiQuery({
 *   variables: {
 *      overrideProviderNpi: // value for 'overrideProviderNpi'
 *   },
 * });
 */
export function useGetAllItxProviderMatchesByNpiQuery(baseOptions?: Apollo.QueryHookOptions<GetAllItxProviderMatchesByNpiQuery, GetAllItxProviderMatchesByNpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllItxProviderMatchesByNpiQuery, GetAllItxProviderMatchesByNpiQueryVariables>(GetAllItxProviderMatchesByNpiDocument, options);
      }
export function useGetAllItxProviderMatchesByNpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllItxProviderMatchesByNpiQuery, GetAllItxProviderMatchesByNpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllItxProviderMatchesByNpiQuery, GetAllItxProviderMatchesByNpiQueryVariables>(GetAllItxProviderMatchesByNpiDocument, options);
        }
export type GetAllItxProviderMatchesByNpiQueryHookResult = ReturnType<typeof useGetAllItxProviderMatchesByNpiQuery>;
export type GetAllItxProviderMatchesByNpiLazyQueryHookResult = ReturnType<typeof useGetAllItxProviderMatchesByNpiLazyQuery>;
export type GetAllItxProviderMatchesByNpiQueryResult = Apollo.QueryResult<GetAllItxProviderMatchesByNpiQuery, GetAllItxProviderMatchesByNpiQueryVariables>;
export const GetAssessmentForCurrentUserDocument = /*#__PURE__*/ gql`
    query getAssessmentForCurrentUser {
  getAssessmentForCurrentUser {
    shortCode
    documentId
    questionCode
    sessionPatientId
  }
}
    `;

/**
 * __useGetAssessmentForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetAssessmentForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssessmentForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAssessmentForCurrentUserQuery, GetAssessmentForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentForCurrentUserQuery, GetAssessmentForCurrentUserQueryVariables>(GetAssessmentForCurrentUserDocument, options);
      }
export function useGetAssessmentForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentForCurrentUserQuery, GetAssessmentForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentForCurrentUserQuery, GetAssessmentForCurrentUserQueryVariables>(GetAssessmentForCurrentUserDocument, options);
        }
export type GetAssessmentForCurrentUserQueryHookResult = ReturnType<typeof useGetAssessmentForCurrentUserQuery>;
export type GetAssessmentForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetAssessmentForCurrentUserLazyQuery>;
export type GetAssessmentForCurrentUserQueryResult = Apollo.QueryResult<GetAssessmentForCurrentUserQuery, GetAssessmentForCurrentUserQueryVariables>;
export const GetAvailableItxProviderMatchesDocument = /*#__PURE__*/ gql`
    query getAvailableItxProviderMatches($overrideProviderNpi: String) {
  getAvailableItxProviderMatches(overrideProviderNpi: $overrideProviderNpi) {
    id
    itxRequest {
      reasonForTransfer
      expiration
    }
    patient {
      firstName
      lastName
      birthDate
      mrn
      diagnoses {
        name
      }
    }
  }
}
    `;

/**
 * __useGetAvailableItxProviderMatchesQuery__
 *
 * To run a query within a React component, call `useGetAvailableItxProviderMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableItxProviderMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableItxProviderMatchesQuery({
 *   variables: {
 *      overrideProviderNpi: // value for 'overrideProviderNpi'
 *   },
 * });
 */
export function useGetAvailableItxProviderMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableItxProviderMatchesQuery, GetAvailableItxProviderMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableItxProviderMatchesQuery, GetAvailableItxProviderMatchesQueryVariables>(GetAvailableItxProviderMatchesDocument, options);
      }
export function useGetAvailableItxProviderMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableItxProviderMatchesQuery, GetAvailableItxProviderMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableItxProviderMatchesQuery, GetAvailableItxProviderMatchesQueryVariables>(GetAvailableItxProviderMatchesDocument, options);
        }
export type GetAvailableItxProviderMatchesQueryHookResult = ReturnType<typeof useGetAvailableItxProviderMatchesQuery>;
export type GetAvailableItxProviderMatchesLazyQueryHookResult = ReturnType<typeof useGetAvailableItxProviderMatchesLazyQuery>;
export type GetAvailableItxProviderMatchesQueryResult = Apollo.QueryResult<GetAvailableItxProviderMatchesQuery, GetAvailableItxProviderMatchesQueryVariables>;
export const GetAvailableTimeslotsForProviderDocument = /*#__PURE__*/ gql`
    query getAvailableTimeslotsForProvider($absoluteDurationSeconds: Int, $checkForNpDailyMax: Boolean!, $endTime: DateTime!, $providerId: String!, $startTime: DateTime!, $timeslotDurationMinutes: Int, $timeslotVisitType: String) {
  getAvailableTimeslotsForProvider(
    absoluteDurationSeconds: $absoluteDurationSeconds
    checkForNpDailyMax: $checkForNpDailyMax
    endTime: $endTime
    providerId: $providerId
    startTime: $startTime
    timeslotDurationMinutes: $timeslotDurationMinutes
    timeslotVisitType: $timeslotVisitType
  ) {
    endTime
    healowTimeslotId
    isAvailable
    providerId
    startTime
  }
}
    `;

/**
 * __useGetAvailableTimeslotsForProviderQuery__
 *
 * To run a query within a React component, call `useGetAvailableTimeslotsForProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTimeslotsForProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTimeslotsForProviderQuery({
 *   variables: {
 *      absoluteDurationSeconds: // value for 'absoluteDurationSeconds'
 *      checkForNpDailyMax: // value for 'checkForNpDailyMax'
 *      endTime: // value for 'endTime'
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      timeslotDurationMinutes: // value for 'timeslotDurationMinutes'
 *      timeslotVisitType: // value for 'timeslotVisitType'
 *   },
 * });
 */
export function useGetAvailableTimeslotsForProviderQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableTimeslotsForProviderQuery, GetAvailableTimeslotsForProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableTimeslotsForProviderQuery, GetAvailableTimeslotsForProviderQueryVariables>(GetAvailableTimeslotsForProviderDocument, options);
      }
export function useGetAvailableTimeslotsForProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableTimeslotsForProviderQuery, GetAvailableTimeslotsForProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableTimeslotsForProviderQuery, GetAvailableTimeslotsForProviderQueryVariables>(GetAvailableTimeslotsForProviderDocument, options);
        }
export type GetAvailableTimeslotsForProviderQueryHookResult = ReturnType<typeof useGetAvailableTimeslotsForProviderQuery>;
export type GetAvailableTimeslotsForProviderLazyQueryHookResult = ReturnType<typeof useGetAvailableTimeslotsForProviderLazyQuery>;
export type GetAvailableTimeslotsForProviderQueryResult = Apollo.QueryResult<GetAvailableTimeslotsForProviderQuery, GetAvailableTimeslotsForProviderQueryVariables>;
export const GetCarriersDocument = /*#__PURE__*/ gql`
    query getCarriers {
  getCarriers {
    id
    name
    parentCarrierId
    isInNetwork
  }
}
    `;

/**
 * __useGetCarriersQuery__
 *
 * To run a query within a React component, call `useGetCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCarriersQuery(baseOptions?: Apollo.QueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
      }
export function useGetCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarriersQuery, GetCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarriersQuery, GetCarriersQueryVariables>(GetCarriersDocument, options);
        }
export type GetCarriersQueryHookResult = ReturnType<typeof useGetCarriersQuery>;
export type GetCarriersLazyQueryHookResult = ReturnType<typeof useGetCarriersLazyQuery>;
export type GetCarriersQueryResult = Apollo.QueryResult<GetCarriersQuery, GetCarriersQueryVariables>;
export const GetCityStateDocument = /*#__PURE__*/ gql`
    query getCityState($zipCode: String!) {
  getCityState(zipCode: $zipCode) {
    zipCode
    city
    stateCode
    stateName
  }
}
    `;

/**
 * __useGetCityStateQuery__
 *
 * To run a query within a React component, call `useGetCityStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCityStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCityStateQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useGetCityStateQuery(baseOptions: Apollo.QueryHookOptions<GetCityStateQuery, GetCityStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCityStateQuery, GetCityStateQueryVariables>(GetCityStateDocument, options);
      }
export function useGetCityStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCityStateQuery, GetCityStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCityStateQuery, GetCityStateQueryVariables>(GetCityStateDocument, options);
        }
export type GetCityStateQueryHookResult = ReturnType<typeof useGetCityStateQuery>;
export type GetCityStateLazyQueryHookResult = ReturnType<typeof useGetCityStateLazyQuery>;
export type GetCityStateQueryResult = Apollo.QueryResult<GetCityStateQuery, GetCityStateQueryVariables>;
export const GetDbHealthCheckDocument = /*#__PURE__*/ gql`
    query getDBHealthCheck {
  getDBHealthCheck {
    ok
  }
}
    `;

/**
 * __useGetDbHealthCheckQuery__
 *
 * To run a query within a React component, call `useGetDbHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDbHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDbHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDbHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GetDbHealthCheckQuery, GetDbHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDbHealthCheckQuery, GetDbHealthCheckQueryVariables>(GetDbHealthCheckDocument, options);
      }
export function useGetDbHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDbHealthCheckQuery, GetDbHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDbHealthCheckQuery, GetDbHealthCheckQueryVariables>(GetDbHealthCheckDocument, options);
        }
export type GetDbHealthCheckQueryHookResult = ReturnType<typeof useGetDbHealthCheckQuery>;
export type GetDbHealthCheckLazyQueryHookResult = ReturnType<typeof useGetDbHealthCheckLazyQuery>;
export type GetDbHealthCheckQueryResult = Apollo.QueryResult<GetDbHealthCheckQuery, GetDbHealthCheckQueryVariables>;
export const GetDiagnosesDocument = /*#__PURE__*/ gql`
    query getDiagnoses {
  getDiagnoses {
    diagnosisCodeRegex
    name
  }
}
    `;

/**
 * __useGetDiagnosesQuery__
 *
 * To run a query within a React component, call `useGetDiagnosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiagnosesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiagnosesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDiagnosesQuery(baseOptions?: Apollo.QueryHookOptions<GetDiagnosesQuery, GetDiagnosesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiagnosesQuery, GetDiagnosesQueryVariables>(GetDiagnosesDocument, options);
      }
export function useGetDiagnosesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiagnosesQuery, GetDiagnosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiagnosesQuery, GetDiagnosesQueryVariables>(GetDiagnosesDocument, options);
        }
export type GetDiagnosesQueryHookResult = ReturnType<typeof useGetDiagnosesQuery>;
export type GetDiagnosesLazyQueryHookResult = ReturnType<typeof useGetDiagnosesLazyQuery>;
export type GetDiagnosesQueryResult = Apollo.QueryResult<GetDiagnosesQuery, GetDiagnosesQueryVariables>;
export const GetDocumentStatusDocument = /*#__PURE__*/ gql`
    query getDocumentStatus {
  getMe {
    ...PatientDemographics
    document {
      status
    }
    zocdocAppointment {
      provider {
        firstName
        lastName
        primaryCredential
      }
    }
  }
}
    ${PatientDemographicsFragmentDoc}`;

/**
 * __useGetDocumentStatusQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDocumentStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
      }
export function useGetDocumentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>(GetDocumentStatusDocument, options);
        }
export type GetDocumentStatusQueryHookResult = ReturnType<typeof useGetDocumentStatusQuery>;
export type GetDocumentStatusLazyQueryHookResult = ReturnType<typeof useGetDocumentStatusLazyQuery>;
export type GetDocumentStatusQueryResult = Apollo.QueryResult<GetDocumentStatusQuery, GetDocumentStatusQueryVariables>;
export const GetHealthCheckDocument = /*#__PURE__*/ gql`
    query getHealthCheck {
  getHealthCheck {
    ok
  }
}
    `;

/**
 * __useGetHealthCheckQuery__
 *
 * To run a query within a React component, call `useGetHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
      }
export function useGetHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
        }
export type GetHealthCheckQueryHookResult = ReturnType<typeof useGetHealthCheckQuery>;
export type GetHealthCheckLazyQueryHookResult = ReturnType<typeof useGetHealthCheckLazyQuery>;
export type GetHealthCheckQueryResult = Apollo.QueryResult<GetHealthCheckQuery, GetHealthCheckQueryVariables>;
export const GetInsurancePayerPlanMapForAssessmentDocument = /*#__PURE__*/ gql`
    query getInsurancePayerPlanMapForAssessment {
  getInsurancePayerPlanMapForAssessment {
    id
    isPriority
    payerName
    payerPlans
    networkStatus
  }
}
    `;

/**
 * __useGetInsurancePayerPlanMapForAssessmentQuery__
 *
 * To run a query within a React component, call `useGetInsurancePayerPlanMapForAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePayerPlanMapForAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePayerPlanMapForAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsurancePayerPlanMapForAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<GetInsurancePayerPlanMapForAssessmentQuery, GetInsurancePayerPlanMapForAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePayerPlanMapForAssessmentQuery, GetInsurancePayerPlanMapForAssessmentQueryVariables>(GetInsurancePayerPlanMapForAssessmentDocument, options);
      }
export function useGetInsurancePayerPlanMapForAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePayerPlanMapForAssessmentQuery, GetInsurancePayerPlanMapForAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePayerPlanMapForAssessmentQuery, GetInsurancePayerPlanMapForAssessmentQueryVariables>(GetInsurancePayerPlanMapForAssessmentDocument, options);
        }
export type GetInsurancePayerPlanMapForAssessmentQueryHookResult = ReturnType<typeof useGetInsurancePayerPlanMapForAssessmentQuery>;
export type GetInsurancePayerPlanMapForAssessmentLazyQueryHookResult = ReturnType<typeof useGetInsurancePayerPlanMapForAssessmentLazyQuery>;
export type GetInsurancePayerPlanMapForAssessmentQueryResult = Apollo.QueryResult<GetInsurancePayerPlanMapForAssessmentQuery, GetInsurancePayerPlanMapForAssessmentQueryVariables>;
export const GetInsurancePayerPlanMapDocument = /*#__PURE__*/ gql`
    query getInsurancePayerPlanMap($filterOptions: InsurancePayerPlanMapFilterOptions!, $pageOptions: InsurancePayerPlanMapPageOptions!) {
  getInsurancePayerPlanMap(
    filterOptions: $filterOptions
    pageOptions: $pageOptions
  ) {
    items {
      changeHealthcarePayerId
      changeHealthcarePayerName
      contractedInsuranceName
      id
      insuranceTier
      isPriority
      networkStatus
      payerName
      payerPlans
      processingPlanName
      stateCode
      subscriberIdPrefix
    }
    hasNextPage
    hasPrevPage
    pageNumber
    perPage
    totalCount
  }
}
    `;

/**
 * __useGetInsurancePayerPlanMapQuery__
 *
 * To run a query within a React component, call `useGetInsurancePayerPlanMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePayerPlanMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePayerPlanMapQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetInsurancePayerPlanMapQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePayerPlanMapQuery, GetInsurancePayerPlanMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePayerPlanMapQuery, GetInsurancePayerPlanMapQueryVariables>(GetInsurancePayerPlanMapDocument, options);
      }
export function useGetInsurancePayerPlanMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePayerPlanMapQuery, GetInsurancePayerPlanMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePayerPlanMapQuery, GetInsurancePayerPlanMapQueryVariables>(GetInsurancePayerPlanMapDocument, options);
        }
export type GetInsurancePayerPlanMapQueryHookResult = ReturnType<typeof useGetInsurancePayerPlanMapQuery>;
export type GetInsurancePayerPlanMapLazyQueryHookResult = ReturnType<typeof useGetInsurancePayerPlanMapLazyQuery>;
export type GetInsurancePayerPlanMapQueryResult = Apollo.QueryResult<GetInsurancePayerPlanMapQuery, GetInsurancePayerPlanMapQueryVariables>;
export const GetInsurancePayersForAssessmentDocument = /*#__PURE__*/ gql`
    query getInsurancePayersForAssessment {
  getInsurancePayersForAssessment {
    id
    isPriority
    payerName
    networkStatus
  }
}
    `;

/**
 * __useGetInsurancePayersForAssessmentQuery__
 *
 * To run a query within a React component, call `useGetInsurancePayersForAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePayersForAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePayersForAssessmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsurancePayersForAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<GetInsurancePayersForAssessmentQuery, GetInsurancePayersForAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePayersForAssessmentQuery, GetInsurancePayersForAssessmentQueryVariables>(GetInsurancePayersForAssessmentDocument, options);
      }
export function useGetInsurancePayersForAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePayersForAssessmentQuery, GetInsurancePayersForAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePayersForAssessmentQuery, GetInsurancePayersForAssessmentQueryVariables>(GetInsurancePayersForAssessmentDocument, options);
        }
export type GetInsurancePayersForAssessmentQueryHookResult = ReturnType<typeof useGetInsurancePayersForAssessmentQuery>;
export type GetInsurancePayersForAssessmentLazyQueryHookResult = ReturnType<typeof useGetInsurancePayersForAssessmentLazyQuery>;
export type GetInsurancePayersForAssessmentQueryResult = Apollo.QueryResult<GetInsurancePayersForAssessmentQuery, GetInsurancePayersForAssessmentQueryVariables>;
export const GetInsurancePlansForAssessmentDocument = /*#__PURE__*/ gql`
    query getInsurancePlansForAssessment($payerName: String!) {
  getInsurancePlansForAssessment(payerName: $payerName) {
    id
    payerName
    payerPlans
    networkStatus
  }
}
    `;

/**
 * __useGetInsurancePlansForAssessmentQuery__
 *
 * To run a query within a React component, call `useGetInsurancePlansForAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePlansForAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePlansForAssessmentQuery({
 *   variables: {
 *      payerName: // value for 'payerName'
 *   },
 * });
 */
export function useGetInsurancePlansForAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetInsurancePlansForAssessmentQuery, GetInsurancePlansForAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsurancePlansForAssessmentQuery, GetInsurancePlansForAssessmentQueryVariables>(GetInsurancePlansForAssessmentDocument, options);
      }
export function useGetInsurancePlansForAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsurancePlansForAssessmentQuery, GetInsurancePlansForAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsurancePlansForAssessmentQuery, GetInsurancePlansForAssessmentQueryVariables>(GetInsurancePlansForAssessmentDocument, options);
        }
export type GetInsurancePlansForAssessmentQueryHookResult = ReturnType<typeof useGetInsurancePlansForAssessmentQuery>;
export type GetInsurancePlansForAssessmentLazyQueryHookResult = ReturnType<typeof useGetInsurancePlansForAssessmentLazyQuery>;
export type GetInsurancePlansForAssessmentQueryResult = Apollo.QueryResult<GetInsurancePlansForAssessmentQuery, GetInsurancePlansForAssessmentQueryVariables>;
export const GetIntakeBySessionPatientIdDocument = /*#__PURE__*/ gql`
    query getIntakeBySessionPatientId($sessionPatientId: ID!) {
  getIntakeBySessionPatientId(sessionPatientId: $sessionPatientId) {
    ecwManualSyncedFileCount
    ecwPendingFileCount
    ecwSyncedFileCount
    ecwTimeoutFileCount
    ehrEncounterId
    fileCount
    hasAppt
    mainReasons
    mentalHealthCoverage
    msBookingCount
    planStatus
    status
    terminationReason
    uploadedDocumentId
    wasReferredByZocdoc
  }
}
    `;

/**
 * __useGetIntakeBySessionPatientIdQuery__
 *
 * To run a query within a React component, call `useGetIntakeBySessionPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeBySessionPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeBySessionPatientIdQuery({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *   },
 * });
 */
export function useGetIntakeBySessionPatientIdQuery(baseOptions: Apollo.QueryHookOptions<GetIntakeBySessionPatientIdQuery, GetIntakeBySessionPatientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntakeBySessionPatientIdQuery, GetIntakeBySessionPatientIdQueryVariables>(GetIntakeBySessionPatientIdDocument, options);
      }
export function useGetIntakeBySessionPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntakeBySessionPatientIdQuery, GetIntakeBySessionPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntakeBySessionPatientIdQuery, GetIntakeBySessionPatientIdQueryVariables>(GetIntakeBySessionPatientIdDocument, options);
        }
export type GetIntakeBySessionPatientIdQueryHookResult = ReturnType<typeof useGetIntakeBySessionPatientIdQuery>;
export type GetIntakeBySessionPatientIdLazyQueryHookResult = ReturnType<typeof useGetIntakeBySessionPatientIdLazyQuery>;
export type GetIntakeBySessionPatientIdQueryResult = Apollo.QueryResult<GetIntakeBySessionPatientIdQuery, GetIntakeBySessionPatientIdQueryVariables>;
export const GetIntakeClaimByUploadedDocumentIdDocument = /*#__PURE__*/ gql`
    query getIntakeClaimByUploadedDocumentId($uploadedDocumentId: ID!) {
  getIntakeClaimByUploadedDocumentId(uploadedDocumentId: $uploadedDocumentId) {
    id
    assigneeName
    assigneeEmail
  }
}
    `;

/**
 * __useGetIntakeClaimByUploadedDocumentIdQuery__
 *
 * To run a query within a React component, call `useGetIntakeClaimByUploadedDocumentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeClaimByUploadedDocumentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeClaimByUploadedDocumentIdQuery({
 *   variables: {
 *      uploadedDocumentId: // value for 'uploadedDocumentId'
 *   },
 * });
 */
export function useGetIntakeClaimByUploadedDocumentIdQuery(baseOptions: Apollo.QueryHookOptions<GetIntakeClaimByUploadedDocumentIdQuery, GetIntakeClaimByUploadedDocumentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntakeClaimByUploadedDocumentIdQuery, GetIntakeClaimByUploadedDocumentIdQueryVariables>(GetIntakeClaimByUploadedDocumentIdDocument, options);
      }
export function useGetIntakeClaimByUploadedDocumentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntakeClaimByUploadedDocumentIdQuery, GetIntakeClaimByUploadedDocumentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntakeClaimByUploadedDocumentIdQuery, GetIntakeClaimByUploadedDocumentIdQueryVariables>(GetIntakeClaimByUploadedDocumentIdDocument, options);
        }
export type GetIntakeClaimByUploadedDocumentIdQueryHookResult = ReturnType<typeof useGetIntakeClaimByUploadedDocumentIdQuery>;
export type GetIntakeClaimByUploadedDocumentIdLazyQueryHookResult = ReturnType<typeof useGetIntakeClaimByUploadedDocumentIdLazyQuery>;
export type GetIntakeClaimByUploadedDocumentIdQueryResult = Apollo.QueryResult<GetIntakeClaimByUploadedDocumentIdQuery, GetIntakeClaimByUploadedDocumentIdQueryVariables>;
export const GetIntakesBySessionPatientIdsDocument = /*#__PURE__*/ gql`
    query getIntakesBySessionPatientIds($sessionPatientIds: [ID!]!, $pageOptions: PageOptions!) {
  getIntakesBySessionPatientIds(
    sessionPatientIds: $sessionPatientIds
    pageOptions: $pageOptions
  ) {
    items {
      addressCity
      addressState
      addressStreet1
      addressStreet2
      addressZipCode
      assigneeName
      birthDate
      createdAt
      ecwManualSyncedFileCount
      ecwPendingFileCount
      ecwSyncedFileCount
      ecwTimeoutFileCount
      ehrEncounterId
      email
      fileCount
      firstName
      hasAppt
      lastName
      mainReasons
      mentalHealthCoverage
      middleName
      mrn
      msBookingCount
      phone
      planNetworkStatus
      planStatus
      providerId
      referralSource
      secondaryReasons
      sessionPatientId
      shortCode
      specialtyCare
      status
      terminationReason
      updatedAt
      uploadedDocumentId
      wasReferredByZocdoc
    }
    hasNextPage
    hasPrevPage
    pageNumber
    perPage
    totalCount
  }
}
    `;

/**
 * __useGetIntakesBySessionPatientIdsQuery__
 *
 * To run a query within a React component, call `useGetIntakesBySessionPatientIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakesBySessionPatientIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakesBySessionPatientIdsQuery({
 *   variables: {
 *      sessionPatientIds: // value for 'sessionPatientIds'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetIntakesBySessionPatientIdsQuery(baseOptions: Apollo.QueryHookOptions<GetIntakesBySessionPatientIdsQuery, GetIntakesBySessionPatientIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntakesBySessionPatientIdsQuery, GetIntakesBySessionPatientIdsQueryVariables>(GetIntakesBySessionPatientIdsDocument, options);
      }
export function useGetIntakesBySessionPatientIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntakesBySessionPatientIdsQuery, GetIntakesBySessionPatientIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntakesBySessionPatientIdsQuery, GetIntakesBySessionPatientIdsQueryVariables>(GetIntakesBySessionPatientIdsDocument, options);
        }
export type GetIntakesBySessionPatientIdsQueryHookResult = ReturnType<typeof useGetIntakesBySessionPatientIdsQuery>;
export type GetIntakesBySessionPatientIdsLazyQueryHookResult = ReturnType<typeof useGetIntakesBySessionPatientIdsLazyQuery>;
export type GetIntakesBySessionPatientIdsQueryResult = Apollo.QueryResult<GetIntakesBySessionPatientIdsQuery, GetIntakesBySessionPatientIdsQueryVariables>;
export const GetIntakesFromOpenSearchDocument = /*#__PURE__*/ gql`
    query getIntakesFromOpenSearch($filterOptions: IntakeFilterOptions, $pageOptions: PageOptions!) {
  getIntakesFromOpenSearch(
    filterOptions: $filterOptions
    pageOptions: $pageOptions
  ) {
    items {
      actionStatus
      addressCity
      addressState
      addressStreet1
      addressStreet2
      addressZipCode
      assigneeName
      birthDate
      createdAt
      ecwManualSyncedFileCount
      ecwPendingFileCount
      ecwSyncedFileCount
      ecwTimeoutFileCount
      ehrEncounterId
      email
      fileCount
      firstName
      hasAppt
      lastName
      mainReasons
      mentalHealthCoverage
      middleName
      mrn
      msBookingCount
      phone
      planNetworkStatus
      planStatus
      providerId
      referralSource
      secondaryReasons
      sessionPatientId
      shortCode
      specialtyCare
      status
      terminationReason
      updatedAt
      uploadedDocumentId
      wasReferredByZocdoc
    }
    hasNextPage
    hasPrevPage
    pageNumber
    perPage
    totalCount
  }
}
    `;

/**
 * __useGetIntakesFromOpenSearchQuery__
 *
 * To run a query within a React component, call `useGetIntakesFromOpenSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakesFromOpenSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakesFromOpenSearchQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetIntakesFromOpenSearchQuery(baseOptions: Apollo.QueryHookOptions<GetIntakesFromOpenSearchQuery, GetIntakesFromOpenSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntakesFromOpenSearchQuery, GetIntakesFromOpenSearchQueryVariables>(GetIntakesFromOpenSearchDocument, options);
      }
export function useGetIntakesFromOpenSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntakesFromOpenSearchQuery, GetIntakesFromOpenSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntakesFromOpenSearchQuery, GetIntakesFromOpenSearchQueryVariables>(GetIntakesFromOpenSearchDocument, options);
        }
export type GetIntakesFromOpenSearchQueryHookResult = ReturnType<typeof useGetIntakesFromOpenSearchQuery>;
export type GetIntakesFromOpenSearchLazyQueryHookResult = ReturnType<typeof useGetIntakesFromOpenSearchLazyQuery>;
export type GetIntakesFromOpenSearchQueryResult = Apollo.QueryResult<GetIntakesFromOpenSearchQuery, GetIntakesFromOpenSearchQueryVariables>;
export const GetIntakesDocument = /*#__PURE__*/ gql`
    query getIntakes($filterOptions: IntakeFilterOptions, $pageOptions: PageOptions!) {
  getIntakes(filterOptions: $filterOptions, pageOptions: $pageOptions) {
    items {
      actionStatus
      addressCity
      addressState
      addressStreet1
      addressStreet2
      addressZipCode
      assigneeName
      birthDate
      createdAt
      ecwManualSyncedFileCount
      ecwPendingFileCount
      ecwSyncedFileCount
      ecwTimeoutFileCount
      ehrEncounterId
      email
      fileCount
      firstName
      hasAppt
      lastName
      mainReasons
      mentalHealthCoverage
      middleName
      mrn
      msBookingCount
      phone
      planNetworkStatus
      planStatus
      providerId
      referralSource
      secondaryReasons
      sessionPatientId
      shortCode
      specialtyCare
      status
      terminationReason
      updatedAt
      uploadedDocumentId
      wasReferredByZocdoc
    }
    hasNextPage
    hasPrevPage
    pageNumber
    perPage
    totalCount
  }
}
    `;

/**
 * __useGetIntakesQuery__
 *
 * To run a query within a React component, call `useGetIntakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakesQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetIntakesQuery(baseOptions: Apollo.QueryHookOptions<GetIntakesQuery, GetIntakesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntakesQuery, GetIntakesQueryVariables>(GetIntakesDocument, options);
      }
export function useGetIntakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntakesQuery, GetIntakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntakesQuery, GetIntakesQueryVariables>(GetIntakesDocument, options);
        }
export type GetIntakesQueryHookResult = ReturnType<typeof useGetIntakesQuery>;
export type GetIntakesLazyQueryHookResult = ReturnType<typeof useGetIntakesLazyQuery>;
export type GetIntakesQueryResult = Apollo.QueryResult<GetIntakesQuery, GetIntakesQueryVariables>;
export const GetItxProviderMatchByIdDocument = /*#__PURE__*/ gql`
    query getItxProviderMatchById($id: ID!) {
  getItxProviderMatchById(id: $id) {
    id
    provider {
      npi
      firstName
      lastName
    }
    itxRequest {
      id
      reasonForTransfer
      expiration
      requestingProviderNpi
      clinicianNotes
    }
    patient {
      firstName
      lastName
      birthDate
      mrn
      diagnoses {
        name
      }
      addressState
    }
  }
}
    `;

/**
 * __useGetItxProviderMatchByIdQuery__
 *
 * To run a query within a React component, call `useGetItxProviderMatchByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItxProviderMatchByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItxProviderMatchByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItxProviderMatchByIdQuery(baseOptions: Apollo.QueryHookOptions<GetItxProviderMatchByIdQuery, GetItxProviderMatchByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItxProviderMatchByIdQuery, GetItxProviderMatchByIdQueryVariables>(GetItxProviderMatchByIdDocument, options);
      }
export function useGetItxProviderMatchByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItxProviderMatchByIdQuery, GetItxProviderMatchByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItxProviderMatchByIdQuery, GetItxProviderMatchByIdQueryVariables>(GetItxProviderMatchByIdDocument, options);
        }
export type GetItxProviderMatchByIdQueryHookResult = ReturnType<typeof useGetItxProviderMatchByIdQuery>;
export type GetItxProviderMatchByIdLazyQueryHookResult = ReturnType<typeof useGetItxProviderMatchByIdLazyQuery>;
export type GetItxProviderMatchByIdQueryResult = Apollo.QueryResult<GetItxProviderMatchByIdQuery, GetItxProviderMatchByIdQueryVariables>;
export const GetItxRequestDocument = /*#__PURE__*/ gql`
    query getItxRequest($id: ID!) {
  getItxRequest(id: $id) {
    id
    createdAt
    acceptedAt
    patient {
      firstName
      lastName
      mrn
      birthDate
      diagnoses {
        name
      }
      addressState
    }
    requestingProvider {
      firstName
      lastName
    }
    clinicianNotes
    expiration
    reasonForTransfer
    specialties {
      name
    }
  }
}
    `;

/**
 * __useGetItxRequestQuery__
 *
 * To run a query within a React component, call `useGetItxRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItxRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItxRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItxRequestQuery(baseOptions: Apollo.QueryHookOptions<GetItxRequestQuery, GetItxRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItxRequestQuery, GetItxRequestQueryVariables>(GetItxRequestDocument, options);
      }
export function useGetItxRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItxRequestQuery, GetItxRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItxRequestQuery, GetItxRequestQueryVariables>(GetItxRequestDocument, options);
        }
export type GetItxRequestQueryHookResult = ReturnType<typeof useGetItxRequestQuery>;
export type GetItxRequestLazyQueryHookResult = ReturnType<typeof useGetItxRequestLazyQuery>;
export type GetItxRequestQueryResult = Apollo.QueryResult<GetItxRequestQuery, GetItxRequestQueryVariables>;
export const GetItxRequestsDocument = /*#__PURE__*/ gql`
    query getItxRequests($overrideProviderNpi: String) {
  getItxRequests(overrideProviderNpi: $overrideProviderNpi) {
    id
    createdAt
    acceptedAt
    patient {
      firstName
      lastName
      mrn
      birthDate
      diagnoses {
        name
      }
    }
    expiration
    reasonForTransfer
    acceptedAt
    specialties {
      name
    }
    processedAt
    hasProviderMatches
    scheduleRequest {
      expiresAt
      appointmentStartTime
    }
  }
}
    `;

/**
 * __useGetItxRequestsQuery__
 *
 * To run a query within a React component, call `useGetItxRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItxRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItxRequestsQuery({
 *   variables: {
 *      overrideProviderNpi: // value for 'overrideProviderNpi'
 *   },
 * });
 */
export function useGetItxRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetItxRequestsQuery, GetItxRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItxRequestsQuery, GetItxRequestsQueryVariables>(GetItxRequestsDocument, options);
      }
export function useGetItxRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItxRequestsQuery, GetItxRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItxRequestsQuery, GetItxRequestsQueryVariables>(GetItxRequestsDocument, options);
        }
export type GetItxRequestsQueryHookResult = ReturnType<typeof useGetItxRequestsQuery>;
export type GetItxRequestsLazyQueryHookResult = ReturnType<typeof useGetItxRequestsLazyQuery>;
export type GetItxRequestsQueryResult = Apollo.QueryResult<GetItxRequestsQuery, GetItxRequestsQueryVariables>;
export const GetLanguagesDocument = /*#__PURE__*/ gql`
    query getLanguages {
  getLanguages {
    id
    name
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetMeDocument = /*#__PURE__*/ gql`
    query getMe {
  getMe {
    id
    updatedAt
    ...PatientDemographics
    document {
      id
      createdAt
      actionStatus
      files {
        id
        fileName
        type
      }
    }
  }
}
    ${PatientDemographicsFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetPatientDischargeLetterDocument = /*#__PURE__*/ gql`
    query getPatientDischargeLetter($patientMrn: String!) {
  getPatientDischargeLetter(patientMrn: $patientMrn) {
    id
  }
}
    `;

/**
 * __useGetPatientDischargeLetterQuery__
 *
 * To run a query within a React component, call `useGetPatientDischargeLetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDischargeLetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDischargeLetterQuery({
 *   variables: {
 *      patientMrn: // value for 'patientMrn'
 *   },
 * });
 */
export function useGetPatientDischargeLetterQuery(baseOptions: Apollo.QueryHookOptions<GetPatientDischargeLetterQuery, GetPatientDischargeLetterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientDischargeLetterQuery, GetPatientDischargeLetterQueryVariables>(GetPatientDischargeLetterDocument, options);
      }
export function useGetPatientDischargeLetterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientDischargeLetterQuery, GetPatientDischargeLetterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientDischargeLetterQuery, GetPatientDischargeLetterQueryVariables>(GetPatientDischargeLetterDocument, options);
        }
export type GetPatientDischargeLetterQueryHookResult = ReturnType<typeof useGetPatientDischargeLetterQuery>;
export type GetPatientDischargeLetterLazyQueryHookResult = ReturnType<typeof useGetPatientDischargeLetterLazyQuery>;
export type GetPatientDischargeLetterQueryResult = Apollo.QueryResult<GetPatientDischargeLetterQuery, GetPatientDischargeLetterQueryVariables>;
export const GetPatientMedicationsDocument = /*#__PURE__*/ gql`
    query getPatientMedications($patientMrn: String!) {
  getPatientMedications(patientMrn: $patientMrn) {
    id
    medicationOrderNumber
    patientMrn
    encounterDate
    medicationName
    frequency
    strength
    dosage
    drugSchedule
  }
}
    `;

/**
 * __useGetPatientMedicationsQuery__
 *
 * To run a query within a React component, call `useGetPatientMedicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientMedicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientMedicationsQuery({
 *   variables: {
 *      patientMrn: // value for 'patientMrn'
 *   },
 * });
 */
export function useGetPatientMedicationsQuery(baseOptions: Apollo.QueryHookOptions<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>(GetPatientMedicationsDocument, options);
      }
export function useGetPatientMedicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>(GetPatientMedicationsDocument, options);
        }
export type GetPatientMedicationsQueryHookResult = ReturnType<typeof useGetPatientMedicationsQuery>;
export type GetPatientMedicationsLazyQueryHookResult = ReturnType<typeof useGetPatientMedicationsLazyQuery>;
export type GetPatientMedicationsQueryResult = Apollo.QueryResult<GetPatientMedicationsQuery, GetPatientMedicationsQueryVariables>;
export const GetPatientPrimaryPolicyHolderDocument = /*#__PURE__*/ gql`
    query getPatientPrimaryPolicyHolder($sessionPatientId: String!) {
  getPatientPrimaryPolicyHolder(sessionPatientId: $sessionPatientId) {
    id
    firstName
    lastName
    birthDate
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressZipCode
    isAddressLinkedWithPatient
    relationToPatient
    customRelation
  }
}
    `;

/**
 * __useGetPatientPrimaryPolicyHolderQuery__
 *
 * To run a query within a React component, call `useGetPatientPrimaryPolicyHolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientPrimaryPolicyHolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientPrimaryPolicyHolderQuery({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *   },
 * });
 */
export function useGetPatientPrimaryPolicyHolderQuery(baseOptions: Apollo.QueryHookOptions<GetPatientPrimaryPolicyHolderQuery, GetPatientPrimaryPolicyHolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientPrimaryPolicyHolderQuery, GetPatientPrimaryPolicyHolderQueryVariables>(GetPatientPrimaryPolicyHolderDocument, options);
      }
export function useGetPatientPrimaryPolicyHolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientPrimaryPolicyHolderQuery, GetPatientPrimaryPolicyHolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientPrimaryPolicyHolderQuery, GetPatientPrimaryPolicyHolderQueryVariables>(GetPatientPrimaryPolicyHolderDocument, options);
        }
export type GetPatientPrimaryPolicyHolderQueryHookResult = ReturnType<typeof useGetPatientPrimaryPolicyHolderQuery>;
export type GetPatientPrimaryPolicyHolderLazyQueryHookResult = ReturnType<typeof useGetPatientPrimaryPolicyHolderLazyQuery>;
export type GetPatientPrimaryPolicyHolderQueryResult = Apollo.QueryResult<GetPatientPrimaryPolicyHolderQuery, GetPatientPrimaryPolicyHolderQueryVariables>;
export const GetPatientDocument = /*#__PURE__*/ gql`
    query getPatient($input: GetPatientInput) {
  getPatient(input: $input) {
    id
    ...FullPatient
  }
}
    ${FullPatientFragmentDoc}`;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const GetPlansDocument = /*#__PURE__*/ gql`
    query getPlans($carrier: String!, $filterOptions: PlansFilterOptions) {
  getPlans(carrier: $carrier, filterOptions: $filterOptions) {
    carrier
    plan
    inNetwork
    isReferralNeeded
    isOutOfStateNeeded
    notes
    insuranceCarrierId
  }
}
    `;

/**
 * __useGetPlansQuery__
 *
 * To run a query within a React component, call `useGetPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansQuery({
 *   variables: {
 *      carrier: // value for 'carrier'
 *      filterOptions: // value for 'filterOptions'
 *   },
 * });
 */
export function useGetPlansQuery(baseOptions: Apollo.QueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
      }
export function useGetPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansQuery, GetPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansQuery, GetPlansQueryVariables>(GetPlansDocument, options);
        }
export type GetPlansQueryHookResult = ReturnType<typeof useGetPlansQuery>;
export type GetPlansLazyQueryHookResult = ReturnType<typeof useGetPlansLazyQuery>;
export type GetPlansQueryResult = Apollo.QueryResult<GetPlansQuery, GetPlansQueryVariables>;
export const GetProviderByNpiDocument = /*#__PURE__*/ gql`
    query getProviderByNpi($npi: String) {
  getProviderByNpi(npi: $npi) {
    id
    npi
    firstName
    lastName
    primaryCredential
    photo
    photoDetail
    biography
    graduatedAt
    specialties {
      id
      name
      treatmentPrerequisiteId
    }
    notes
    school
    certification
    modality
    languages {
      name
    }
    npDailyMax
  }
}
    `;

/**
 * __useGetProviderByNpiQuery__
 *
 * To run a query within a React component, call `useGetProviderByNpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderByNpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderByNpiQuery({
 *   variables: {
 *      npi: // value for 'npi'
 *   },
 * });
 */
export function useGetProviderByNpiQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderByNpiQuery, GetProviderByNpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderByNpiQuery, GetProviderByNpiQueryVariables>(GetProviderByNpiDocument, options);
      }
export function useGetProviderByNpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderByNpiQuery, GetProviderByNpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderByNpiQuery, GetProviderByNpiQueryVariables>(GetProviderByNpiDocument, options);
        }
export type GetProviderByNpiQueryHookResult = ReturnType<typeof useGetProviderByNpiQuery>;
export type GetProviderByNpiLazyQueryHookResult = ReturnType<typeof useGetProviderByNpiLazyQuery>;
export type GetProviderByNpiQueryResult = Apollo.QueryResult<GetProviderByNpiQuery, GetProviderByNpiQueryVariables>;
export const GetProviderHistoryDocument = /*#__PURE__*/ gql`
    query getProviderHistory($providerId: String, $pageOptions: PageOptions!) {
  getProviderHistory(providerId: $providerId, pageOptions: $pageOptions) {
    items {
      id
      providerId
      source
      eventType
      details
      createdAt
    }
    pageNumber
    totalCount
    hasNextPage
    hasPrevPage
  }
}
    `;

/**
 * __useGetProviderHistoryQuery__
 *
 * To run a query within a React component, call `useGetProviderHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderHistoryQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetProviderHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetProviderHistoryQuery, GetProviderHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderHistoryQuery, GetProviderHistoryQueryVariables>(GetProviderHistoryDocument, options);
      }
export function useGetProviderHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderHistoryQuery, GetProviderHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderHistoryQuery, GetProviderHistoryQueryVariables>(GetProviderHistoryDocument, options);
        }
export type GetProviderHistoryQueryHookResult = ReturnType<typeof useGetProviderHistoryQuery>;
export type GetProviderHistoryLazyQueryHookResult = ReturnType<typeof useGetProviderHistoryLazyQuery>;
export type GetProviderHistoryQueryResult = Apollo.QueryResult<GetProviderHistoryQuery, GetProviderHistoryQueryVariables>;
export const GetProviderMatchesDocument = /*#__PURE__*/ gql`
    query GetProviderMatches($sessionPatientId: ID) {
  getProviderMatches(sessionPatientId: $sessionPatientId) {
    patientMatchFailureReasons
    providers {
      provider {
        id
        firstName
        lastName
        biography
        primaryCredential
        photo
        calendarUrl
        modality
        specialties {
          id
          name
          treatmentPrerequisiteId
        }
        licenses {
          stateCode
          certificationType
        }
        providerTimeslots {
          startTime
          endTime
          providerId
          isAvailable
        }
      }
    }
  }
}
    `;

/**
 * __useGetProviderMatchesQuery__
 *
 * To run a query within a React component, call `useGetProviderMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderMatchesQuery({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *   },
 * });
 */
export function useGetProviderMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderMatchesQuery, GetProviderMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderMatchesQuery, GetProviderMatchesQueryVariables>(GetProviderMatchesDocument, options);
      }
export function useGetProviderMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderMatchesQuery, GetProviderMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderMatchesQuery, GetProviderMatchesQueryVariables>(GetProviderMatchesDocument, options);
        }
export type GetProviderMatchesQueryHookResult = ReturnType<typeof useGetProviderMatchesQuery>;
export type GetProviderMatchesLazyQueryHookResult = ReturnType<typeof useGetProviderMatchesLazyQuery>;
export type GetProviderMatchesQueryResult = Apollo.QueryResult<GetProviderMatchesQuery, GetProviderMatchesQueryVariables>;
export const GetProviderDocument = /*#__PURE__*/ gql`
    query getProvider($id: String) {
  getProvider(id: $id) {
    id
    npi
    modality
    calendarUrl
    ageGroups {
      id
      name
      rangeStart
      rangeEnd
    }
    firstName
    lastName
    healowCode
    medallionStartDate
    primaryCredential
    photo
    photoDetail
    biography
    isOnlineMatchingEnabled
    isOnlineSchedulingEnabled
    graduatedAt
    primaryPracticeState
    specialties {
      id
      name
      treatmentPrerequisiteId
    }
    notes
    school
    certification
    treatmentMethods {
      id
      name
    }
    providerInsuranceCarriers {
      insuranceCarrier {
        name
        medallionName
        isInNetwork
      }
      stateCode
    }
    languages {
      id
      name
    }
    licenses {
      stateCode
      certificationType
    }
    practices {
      stateCode
    }
    isOpenToTransfers
    npDailyMax
  }
}
    `;

/**
 * __useGetProviderQuery__
 *
 * To run a query within a React component, call `useGetProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderQuery, GetProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
      }
export function useGetProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
        }
export type GetProviderQueryHookResult = ReturnType<typeof useGetProviderQuery>;
export type GetProviderLazyQueryHookResult = ReturnType<typeof useGetProviderLazyQuery>;
export type GetProviderQueryResult = Apollo.QueryResult<GetProviderQuery, GetProviderQueryVariables>;
export const GetProvidersForSearchbarDocument = /*#__PURE__*/ gql`
    query getProvidersForSearchbar {
  getProvidersForSearchbar {
    id
    firstName
    lastName
    photo
    npi
  }
}
    `;

/**
 * __useGetProvidersForSearchbarQuery__
 *
 * To run a query within a React component, call `useGetProvidersForSearchbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersForSearchbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersForSearchbarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProvidersForSearchbarQuery(baseOptions?: Apollo.QueryHookOptions<GetProvidersForSearchbarQuery, GetProvidersForSearchbarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersForSearchbarQuery, GetProvidersForSearchbarQueryVariables>(GetProvidersForSearchbarDocument, options);
      }
export function useGetProvidersForSearchbarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersForSearchbarQuery, GetProvidersForSearchbarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersForSearchbarQuery, GetProvidersForSearchbarQueryVariables>(GetProvidersForSearchbarDocument, options);
        }
export type GetProvidersForSearchbarQueryHookResult = ReturnType<typeof useGetProvidersForSearchbarQuery>;
export type GetProvidersForSearchbarLazyQueryHookResult = ReturnType<typeof useGetProvidersForSearchbarLazyQuery>;
export type GetProvidersForSearchbarQueryResult = Apollo.QueryResult<GetProvidersForSearchbarQuery, GetProvidersForSearchbarQueryVariables>;
export const GetProvidersFromOpenSearchDocument = /*#__PURE__*/ gql`
    query getProvidersFromOpenSearch($filterOptions: ProviderFilterOptionsOpenSearch, $pageOptions: PageOptions!) {
  getProvidersFromOpenSearch(
    filterOptions: $filterOptions
    pageOptions: $pageOptions
  ) {
    items {
      id
      firstName
      lastName
      calendarUrl
      isOnlineMatchingEnabled
      isOnlineSchedulingEnabled
      medallionStartDate
      npi
      primaryPracticeState
      primaryCredential
      photo
      notes
      practices {
        stateCode
      }
      ageGroups {
        name
      }
      primaryConditions
      secondaryConditions
      providerInsuranceCarriers {
        insuranceCarrier {
          name
          medallionName
          isInNetwork
        }
        stateCode
      }
      treatmentMethods {
        id
        name
      }
      languages {
        id
        name
      }
      licenses {
        stateCode
        certificationType
      }
      npDailyMax
    }
    pageNumber
    totalCount
    hasNextPage
    hasPrevPage
  }
}
    `;

/**
 * __useGetProvidersFromOpenSearchQuery__
 *
 * To run a query within a React component, call `useGetProvidersFromOpenSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersFromOpenSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersFromOpenSearchQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetProvidersFromOpenSearchQuery(baseOptions: Apollo.QueryHookOptions<GetProvidersFromOpenSearchQuery, GetProvidersFromOpenSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersFromOpenSearchQuery, GetProvidersFromOpenSearchQueryVariables>(GetProvidersFromOpenSearchDocument, options);
      }
export function useGetProvidersFromOpenSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersFromOpenSearchQuery, GetProvidersFromOpenSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersFromOpenSearchQuery, GetProvidersFromOpenSearchQueryVariables>(GetProvidersFromOpenSearchDocument, options);
        }
export type GetProvidersFromOpenSearchQueryHookResult = ReturnType<typeof useGetProvidersFromOpenSearchQuery>;
export type GetProvidersFromOpenSearchLazyQueryHookResult = ReturnType<typeof useGetProvidersFromOpenSearchLazyQuery>;
export type GetProvidersFromOpenSearchQueryResult = Apollo.QueryResult<GetProvidersFromOpenSearchQuery, GetProvidersFromOpenSearchQueryVariables>;
export const GetProvidersDocument = /*#__PURE__*/ gql`
    query getProviders($filterOptions: ProviderFilterOptions, $pageOptions: PageOptions!) {
  getProviders(filterOptions: $filterOptions, pageOptions: $pageOptions) {
    items {
      id
      calendarUrl
      ageGroups {
        id
        name
        rangeStart
        rangeEnd
      }
      firstName
      lastName
      healowCode
      medallionStartDate
      primaryCredential
      photo
      photoDetail
      biography
      isOnlineMatchingEnabled
      graduatedAt
      primaryPracticeState
      specialties {
        id
        name
        treatmentPrerequisiteId
      }
      notes
      school
      certification
      treatmentMethods {
        id
        name
      }
      providerInsuranceCarriers {
        insuranceCarrier {
          name
          medallionName
          isInNetwork
        }
        stateCode
      }
      languages {
        id
        name
      }
      licenses {
        stateCode
        certificationType
      }
      practices {
        stateCode
      }
      npDailyMax
    }
    pageNumber
    totalCount
    hasNextPage
    hasPrevPage
  }
}
    `;

/**
 * __useGetProvidersQuery__
 *
 * To run a query within a React component, call `useGetProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *      pageOptions: // value for 'pageOptions'
 *   },
 * });
 */
export function useGetProvidersQuery(baseOptions: Apollo.QueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
      }
export function useGetProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersQuery, GetProvidersQueryVariables>(GetProvidersDocument, options);
        }
export type GetProvidersQueryHookResult = ReturnType<typeof useGetProvidersQuery>;
export type GetProvidersLazyQueryHookResult = ReturnType<typeof useGetProvidersLazyQuery>;
export type GetProvidersQueryResult = Apollo.QueryResult<GetProvidersQuery, GetProvidersQueryVariables>;
export const GetS3PresignedPostDocument = /*#__PURE__*/ gql`
    query getS3PresignedPost($fileName: String!) {
  getS3PresignedPost(fileName: $fileName) {
    url
    fields
  }
}
    `;

/**
 * __useGetS3PresignedPostQuery__
 *
 * To run a query within a React component, call `useGetS3PresignedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetS3PresignedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetS3PresignedPostQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useGetS3PresignedPostQuery(baseOptions: Apollo.QueryHookOptions<GetS3PresignedPostQuery, GetS3PresignedPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetS3PresignedPostQuery, GetS3PresignedPostQueryVariables>(GetS3PresignedPostDocument, options);
      }
export function useGetS3PresignedPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetS3PresignedPostQuery, GetS3PresignedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetS3PresignedPostQuery, GetS3PresignedPostQueryVariables>(GetS3PresignedPostDocument, options);
        }
export type GetS3PresignedPostQueryHookResult = ReturnType<typeof useGetS3PresignedPostQuery>;
export type GetS3PresignedPostLazyQueryHookResult = ReturnType<typeof useGetS3PresignedPostLazyQuery>;
export type GetS3PresignedPostQueryResult = Apollo.QueryResult<GetS3PresignedPostQuery, GetS3PresignedPostQueryVariables>;
export const GetScheduleRequestDocument = /*#__PURE__*/ gql`
    query getScheduleRequest($scheduleRequestId: ID!) {
  getScheduleRequest(scheduleRequestId: $scheduleRequestId) {
    id
    mrn
    npi
    provider {
      id
      biography
      ageGroups {
        id
        name
        rangeStart
        rangeEnd
      }
      languages {
        id
        name
      }
      specialties {
        id
        name
      }
      photo
      firstName
      lastName
      primaryCredential
      npDailyMax
    }
    appointmentStartTime
    appointmentEndTime
    expiresAt
    visitDuration
  }
}
    `;

/**
 * __useGetScheduleRequestQuery__
 *
 * To run a query within a React component, call `useGetScheduleRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleRequestQuery({
 *   variables: {
 *      scheduleRequestId: // value for 'scheduleRequestId'
 *   },
 * });
 */
export function useGetScheduleRequestQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleRequestQuery, GetScheduleRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleRequestQuery, GetScheduleRequestQueryVariables>(GetScheduleRequestDocument, options);
      }
export function useGetScheduleRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleRequestQuery, GetScheduleRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleRequestQuery, GetScheduleRequestQueryVariables>(GetScheduleRequestDocument, options);
        }
export type GetScheduleRequestQueryHookResult = ReturnType<typeof useGetScheduleRequestQuery>;
export type GetScheduleRequestLazyQueryHookResult = ReturnType<typeof useGetScheduleRequestLazyQuery>;
export type GetScheduleRequestQueryResult = Apollo.QueryResult<GetScheduleRequestQuery, GetScheduleRequestQueryVariables>;
export const GetSettingsForCategoryDocument = /*#__PURE__*/ gql`
    query getSettingsForCategory($category: String!) {
  getSettingsForCategory(category: $category) {
    id
    category
    key
    value
  }
}
    `;

/**
 * __useGetSettingsForCategoryQuery__
 *
 * To run a query within a React component, call `useGetSettingsForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsForCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetSettingsForCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsForCategoryQuery, GetSettingsForCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsForCategoryQuery, GetSettingsForCategoryQueryVariables>(GetSettingsForCategoryDocument, options);
      }
export function useGetSettingsForCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsForCategoryQuery, GetSettingsForCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsForCategoryQuery, GetSettingsForCategoryQueryVariables>(GetSettingsForCategoryDocument, options);
        }
export type GetSettingsForCategoryQueryHookResult = ReturnType<typeof useGetSettingsForCategoryQuery>;
export type GetSettingsForCategoryLazyQueryHookResult = ReturnType<typeof useGetSettingsForCategoryLazyQuery>;
export type GetSettingsForCategoryQueryResult = Apollo.QueryResult<GetSettingsForCategoryQuery, GetSettingsForCategoryQueryVariables>;
export const GetSpecialtiesDocument = /*#__PURE__*/ gql`
    query getSpecialties {
  getSpecialties {
    id
    name
    canBePrimary
    canBeSecondary
  }
}
    `;

/**
 * __useGetSpecialtiesQuery__
 *
 * To run a query within a React component, call `useGetSpecialtiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialtiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialtiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpecialtiesQuery(baseOptions?: Apollo.QueryHookOptions<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>(GetSpecialtiesDocument, options);
      }
export function useGetSpecialtiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>(GetSpecialtiesDocument, options);
        }
export type GetSpecialtiesQueryHookResult = ReturnType<typeof useGetSpecialtiesQuery>;
export type GetSpecialtiesLazyQueryHookResult = ReturnType<typeof useGetSpecialtiesLazyQuery>;
export type GetSpecialtiesQueryResult = Apollo.QueryResult<GetSpecialtiesQuery, GetSpecialtiesQueryVariables>;
export const GetStatesDocument = /*#__PURE__*/ gql`
    query getStates {
  getStates {
    code
    name
  }
}
    `;

/**
 * __useGetStatesQuery__
 *
 * To run a query within a React component, call `useGetStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetStatesQuery, GetStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatesQuery, GetStatesQueryVariables>(GetStatesDocument, options);
      }
export function useGetStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatesQuery, GetStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatesQuery, GetStatesQueryVariables>(GetStatesDocument, options);
        }
export type GetStatesQueryHookResult = ReturnType<typeof useGetStatesQuery>;
export type GetStatesLazyQueryHookResult = ReturnType<typeof useGetStatesLazyQuery>;
export type GetStatesQueryResult = Apollo.QueryResult<GetStatesQuery, GetStatesQueryVariables>;
export const GetTreatmentMethodsDocument = /*#__PURE__*/ gql`
    query getTreatmentMethods {
  getTreatmentMethods {
    id
    name
  }
}
    `;

/**
 * __useGetTreatmentMethodsQuery__
 *
 * To run a query within a React component, call `useGetTreatmentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatmentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatmentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTreatmentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetTreatmentMethodsQuery, GetTreatmentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreatmentMethodsQuery, GetTreatmentMethodsQueryVariables>(GetTreatmentMethodsDocument, options);
      }
export function useGetTreatmentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreatmentMethodsQuery, GetTreatmentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreatmentMethodsQuery, GetTreatmentMethodsQueryVariables>(GetTreatmentMethodsDocument, options);
        }
export type GetTreatmentMethodsQueryHookResult = ReturnType<typeof useGetTreatmentMethodsQuery>;
export type GetTreatmentMethodsLazyQueryHookResult = ReturnType<typeof useGetTreatmentMethodsLazyQuery>;
export type GetTreatmentMethodsQueryResult = Apollo.QueryResult<GetTreatmentMethodsQuery, GetTreatmentMethodsQueryVariables>;
export const GetTreatmentPrerequisitesDocument = /*#__PURE__*/ gql`
    query getTreatmentPrerequisites {
  getTreatmentPrerequisites {
    id
    name
  }
}
    `;

/**
 * __useGetTreatmentPrerequisitesQuery__
 *
 * To run a query within a React component, call `useGetTreatmentPrerequisitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatmentPrerequisitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatmentPrerequisitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTreatmentPrerequisitesQuery(baseOptions?: Apollo.QueryHookOptions<GetTreatmentPrerequisitesQuery, GetTreatmentPrerequisitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreatmentPrerequisitesQuery, GetTreatmentPrerequisitesQueryVariables>(GetTreatmentPrerequisitesDocument, options);
      }
export function useGetTreatmentPrerequisitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreatmentPrerequisitesQuery, GetTreatmentPrerequisitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreatmentPrerequisitesQuery, GetTreatmentPrerequisitesQueryVariables>(GetTreatmentPrerequisitesDocument, options);
        }
export type GetTreatmentPrerequisitesQueryHookResult = ReturnType<typeof useGetTreatmentPrerequisitesQuery>;
export type GetTreatmentPrerequisitesLazyQueryHookResult = ReturnType<typeof useGetTreatmentPrerequisitesLazyQuery>;
export type GetTreatmentPrerequisitesQueryResult = Apollo.QueryResult<GetTreatmentPrerequisitesQuery, GetTreatmentPrerequisitesQueryVariables>;
export const MatchWithPatientDocument = /*#__PURE__*/ gql`
    mutation matchWithPatient($input: MatchInput!) {
  matchWithPatient(input: $input) {
    id
    ...PatientDemographics
  }
}
    ${PatientDemographicsFragmentDoc}`;
export type MatchWithPatientMutationFn = Apollo.MutationFunction<MatchWithPatientMutation, MatchWithPatientMutationVariables>;

/**
 * __useMatchWithPatientMutation__
 *
 * To run a mutation, you first call `useMatchWithPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchWithPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchWithPatientMutation, { data, loading, error }] = useMatchWithPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMatchWithPatientMutation(baseOptions?: Apollo.MutationHookOptions<MatchWithPatientMutation, MatchWithPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchWithPatientMutation, MatchWithPatientMutationVariables>(MatchWithPatientDocument, options);
      }
export type MatchWithPatientMutationHookResult = ReturnType<typeof useMatchWithPatientMutation>;
export type MatchWithPatientMutationResult = Apollo.MutationResult<MatchWithPatientMutation>;
export type MatchWithPatientMutationOptions = Apollo.BaseMutationOptions<MatchWithPatientMutation, MatchWithPatientMutationVariables>;
export const PatientAssignProviderMatchDocument = /*#__PURE__*/ gql`
    mutation patientAssignProviderMatch($sessionPatientId: ID!, $providerId: ID) {
  patientAssignProviderMatch(
    sessionPatientId: $sessionPatientId
    providerId: $providerId
  ) {
    ok
  }
}
    `;
export type PatientAssignProviderMatchMutationFn = Apollo.MutationFunction<PatientAssignProviderMatchMutation, PatientAssignProviderMatchMutationVariables>;

/**
 * __usePatientAssignProviderMatchMutation__
 *
 * To run a mutation, you first call `usePatientAssignProviderMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientAssignProviderMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientAssignProviderMatchMutation, { data, loading, error }] = usePatientAssignProviderMatchMutation({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function usePatientAssignProviderMatchMutation(baseOptions?: Apollo.MutationHookOptions<PatientAssignProviderMatchMutation, PatientAssignProviderMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientAssignProviderMatchMutation, PatientAssignProviderMatchMutationVariables>(PatientAssignProviderMatchDocument, options);
      }
export type PatientAssignProviderMatchMutationHookResult = ReturnType<typeof usePatientAssignProviderMatchMutation>;
export type PatientAssignProviderMatchMutationResult = Apollo.MutationResult<PatientAssignProviderMatchMutation>;
export type PatientAssignProviderMatchMutationOptions = Apollo.BaseMutationOptions<PatientAssignProviderMatchMutation, PatientAssignProviderMatchMutationVariables>;
export const PccAssignProviderMatchDocument = /*#__PURE__*/ gql`
    mutation pccAssignProviderMatch($sessionPatientId: ID!, $providerId: ID) {
  pccAssignProviderMatch(
    sessionPatientId: $sessionPatientId
    providerId: $providerId
  ) {
    id
    providerMatch {
      assignedBy
      source
      provider {
        id
        firstName
        lastName
        primaryCredential
        photo
      }
    }
  }
}
    `;
export type PccAssignProviderMatchMutationFn = Apollo.MutationFunction<PccAssignProviderMatchMutation, PccAssignProviderMatchMutationVariables>;

/**
 * __usePccAssignProviderMatchMutation__
 *
 * To run a mutation, you first call `usePccAssignProviderMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePccAssignProviderMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pccAssignProviderMatchMutation, { data, loading, error }] = usePccAssignProviderMatchMutation({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function usePccAssignProviderMatchMutation(baseOptions?: Apollo.MutationHookOptions<PccAssignProviderMatchMutation, PccAssignProviderMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PccAssignProviderMatchMutation, PccAssignProviderMatchMutationVariables>(PccAssignProviderMatchDocument, options);
      }
export type PccAssignProviderMatchMutationHookResult = ReturnType<typeof usePccAssignProviderMatchMutation>;
export type PccAssignProviderMatchMutationResult = Apollo.MutationResult<PccAssignProviderMatchMutation>;
export type PccAssignProviderMatchMutationOptions = Apollo.BaseMutationOptions<PccAssignProviderMatchMutation, PccAssignProviderMatchMutationVariables>;
export const RejectItxProviderMatchDocument = /*#__PURE__*/ gql`
    mutation rejectItxProviderMatch($id: ID!, $rejectionReason: String!, $rejectionComments: String) {
  rejectItxProviderMatch(
    id: $id
    rejectionReason: $rejectionReason
    rejectionComments: $rejectionComments
  ) {
    ok
  }
}
    `;
export type RejectItxProviderMatchMutationFn = Apollo.MutationFunction<RejectItxProviderMatchMutation, RejectItxProviderMatchMutationVariables>;

/**
 * __useRejectItxProviderMatchMutation__
 *
 * To run a mutation, you first call `useRejectItxProviderMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectItxProviderMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectItxProviderMatchMutation, { data, loading, error }] = useRejectItxProviderMatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rejectionReason: // value for 'rejectionReason'
 *      rejectionComments: // value for 'rejectionComments'
 *   },
 * });
 */
export function useRejectItxProviderMatchMutation(baseOptions?: Apollo.MutationHookOptions<RejectItxProviderMatchMutation, RejectItxProviderMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectItxProviderMatchMutation, RejectItxProviderMatchMutationVariables>(RejectItxProviderMatchDocument, options);
      }
export type RejectItxProviderMatchMutationHookResult = ReturnType<typeof useRejectItxProviderMatchMutation>;
export type RejectItxProviderMatchMutationResult = Apollo.MutationResult<RejectItxProviderMatchMutation>;
export type RejectItxProviderMatchMutationOptions = Apollo.BaseMutationOptions<RejectItxProviderMatchMutation, RejectItxProviderMatchMutationVariables>;
export const RequestAppointmentDocument = /*#__PURE__*/ gql`
    mutation requestAppointment($scheduleRequestId: ID!, $appointmentStartTime: DateTime!) {
  requestAppointment(
    scheduleRequestId: $scheduleRequestId
    appointmentStartTime: $appointmentStartTime
  ) {
    ok
  }
}
    `;
export type RequestAppointmentMutationFn = Apollo.MutationFunction<RequestAppointmentMutation, RequestAppointmentMutationVariables>;

/**
 * __useRequestAppointmentMutation__
 *
 * To run a mutation, you first call `useRequestAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAppointmentMutation, { data, loading, error }] = useRequestAppointmentMutation({
 *   variables: {
 *      scheduleRequestId: // value for 'scheduleRequestId'
 *      appointmentStartTime: // value for 'appointmentStartTime'
 *   },
 * });
 */
export function useRequestAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestAppointmentMutation, RequestAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAppointmentMutation, RequestAppointmentMutationVariables>(RequestAppointmentDocument, options);
      }
export type RequestAppointmentMutationHookResult = ReturnType<typeof useRequestAppointmentMutation>;
export type RequestAppointmentMutationResult = Apollo.MutationResult<RequestAppointmentMutation>;
export type RequestAppointmentMutationOptions = Apollo.BaseMutationOptions<RequestAppointmentMutation, RequestAppointmentMutationVariables>;
export const RescheduleAppointmentDocument = /*#__PURE__*/ gql`
    mutation rescheduleAppointment($scheduleRequestId: ID!, $appointmentStartTime: DateTime!) {
  rescheduleAppointment(
    scheduleRequestId: $scheduleRequestId
    appointmentStartTime: $appointmentStartTime
  ) {
    ok
  }
}
    `;
export type RescheduleAppointmentMutationFn = Apollo.MutationFunction<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;

/**
 * __useRescheduleAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentMutation, { data, loading, error }] = useRescheduleAppointmentMutation({
 *   variables: {
 *      scheduleRequestId: // value for 'scheduleRequestId'
 *      appointmentStartTime: // value for 'appointmentStartTime'
 *   },
 * });
 */
export function useRescheduleAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>(RescheduleAppointmentDocument, options);
      }
export type RescheduleAppointmentMutationHookResult = ReturnType<typeof useRescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationResult = Apollo.MutationResult<RescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;
export const SendPatientDischargeLetterDocument = /*#__PURE__*/ gql`
    mutation sendPatientDischargeLetter($patientMrn: String!, $patientFirstName: String!, $patientLastName: String!, $patientBirthDate: String!, $patientEmail: String!, $externalMrn: String, $lastProviderNpi: ID!, $lastProviderName: String!, $template: DischargeLetterTemplate!, $clinicianNotes: String) {
  sendPatientDischargeLetter(
    patientMrn: $patientMrn
    patientFirstName: $patientFirstName
    patientLastName: $patientLastName
    patientBirthDate: $patientBirthDate
    patientEmail: $patientEmail
    externalMrn: $externalMrn
    lastProviderNpi: $lastProviderNpi
    lastProviderName: $lastProviderName
    template: $template
    clinicianNotes: $clinicianNotes
  ) {
    id
  }
}
    `;
export type SendPatientDischargeLetterMutationFn = Apollo.MutationFunction<SendPatientDischargeLetterMutation, SendPatientDischargeLetterMutationVariables>;

/**
 * __useSendPatientDischargeLetterMutation__
 *
 * To run a mutation, you first call `useSendPatientDischargeLetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPatientDischargeLetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPatientDischargeLetterMutation, { data, loading, error }] = useSendPatientDischargeLetterMutation({
 *   variables: {
 *      patientMrn: // value for 'patientMrn'
 *      patientFirstName: // value for 'patientFirstName'
 *      patientLastName: // value for 'patientLastName'
 *      patientBirthDate: // value for 'patientBirthDate'
 *      patientEmail: // value for 'patientEmail'
 *      externalMrn: // value for 'externalMrn'
 *      lastProviderNpi: // value for 'lastProviderNpi'
 *      lastProviderName: // value for 'lastProviderName'
 *      template: // value for 'template'
 *      clinicianNotes: // value for 'clinicianNotes'
 *   },
 * });
 */
export function useSendPatientDischargeLetterMutation(baseOptions?: Apollo.MutationHookOptions<SendPatientDischargeLetterMutation, SendPatientDischargeLetterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPatientDischargeLetterMutation, SendPatientDischargeLetterMutationVariables>(SendPatientDischargeLetterDocument, options);
      }
export type SendPatientDischargeLetterMutationHookResult = ReturnType<typeof useSendPatientDischargeLetterMutation>;
export type SendPatientDischargeLetterMutationResult = Apollo.MutationResult<SendPatientDischargeLetterMutation>;
export type SendPatientDischargeLetterMutationOptions = Apollo.BaseMutationOptions<SendPatientDischargeLetterMutation, SendPatientDischargeLetterMutationVariables>;
export const StartAdherenceOutreachDocument = /*#__PURE__*/ gql`
    mutation startAdherenceOutreach($patientMrn: String!, $lastProviderNpi: String!) {
  startAdherenceOutreach(
    patientMrn: $patientMrn
    lastProviderNpi: $lastProviderNpi
  ) {
    id
  }
}
    `;
export type StartAdherenceOutreachMutationFn = Apollo.MutationFunction<StartAdherenceOutreachMutation, StartAdherenceOutreachMutationVariables>;

/**
 * __useStartAdherenceOutreachMutation__
 *
 * To run a mutation, you first call `useStartAdherenceOutreachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAdherenceOutreachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAdherenceOutreachMutation, { data, loading, error }] = useStartAdherenceOutreachMutation({
 *   variables: {
 *      patientMrn: // value for 'patientMrn'
 *      lastProviderNpi: // value for 'lastProviderNpi'
 *   },
 * });
 */
export function useStartAdherenceOutreachMutation(baseOptions?: Apollo.MutationHookOptions<StartAdherenceOutreachMutation, StartAdherenceOutreachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAdherenceOutreachMutation, StartAdherenceOutreachMutationVariables>(StartAdherenceOutreachDocument, options);
      }
export type StartAdherenceOutreachMutationHookResult = ReturnType<typeof useStartAdherenceOutreachMutation>;
export type StartAdherenceOutreachMutationResult = Apollo.MutationResult<StartAdherenceOutreachMutation>;
export type StartAdherenceOutreachMutationOptions = Apollo.BaseMutationOptions<StartAdherenceOutreachMutation, StartAdherenceOutreachMutationVariables>;
export const UnclaimIntakeDocument = /*#__PURE__*/ gql`
    mutation unclaimIntake($uploadedDocumentId: ID!) {
  unclaimIntake(uploadedDocumentId: $uploadedDocumentId) {
    ok
  }
}
    `;
export type UnclaimIntakeMutationFn = Apollo.MutationFunction<UnclaimIntakeMutation, UnclaimIntakeMutationVariables>;

/**
 * __useUnclaimIntakeMutation__
 *
 * To run a mutation, you first call `useUnclaimIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnclaimIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unclaimIntakeMutation, { data, loading, error }] = useUnclaimIntakeMutation({
 *   variables: {
 *      uploadedDocumentId: // value for 'uploadedDocumentId'
 *   },
 * });
 */
export function useUnclaimIntakeMutation(baseOptions?: Apollo.MutationHookOptions<UnclaimIntakeMutation, UnclaimIntakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnclaimIntakeMutation, UnclaimIntakeMutationVariables>(UnclaimIntakeDocument, options);
      }
export type UnclaimIntakeMutationHookResult = ReturnType<typeof useUnclaimIntakeMutation>;
export type UnclaimIntakeMutationResult = Apollo.MutationResult<UnclaimIntakeMutation>;
export type UnclaimIntakeMutationOptions = Apollo.BaseMutationOptions<UnclaimIntakeMutation, UnclaimIntakeMutationVariables>;
export const UpdateAssessmentAnswersDocument = /*#__PURE__*/ gql`
    mutation updateAssessmentAnswers($input: updateAssessmentAnswersInput) {
  updateAssessmentAnswers(input: $input) {
    ok
  }
}
    `;
export type UpdateAssessmentAnswersMutationFn = Apollo.MutationFunction<UpdateAssessmentAnswersMutation, UpdateAssessmentAnswersMutationVariables>;

/**
 * __useUpdateAssessmentAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentAnswersMutation, { data, loading, error }] = useUpdateAssessmentAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentAnswersMutation, UpdateAssessmentAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentAnswersMutation, UpdateAssessmentAnswersMutationVariables>(UpdateAssessmentAnswersDocument, options);
      }
export type UpdateAssessmentAnswersMutationHookResult = ReturnType<typeof useUpdateAssessmentAnswersMutation>;
export type UpdateAssessmentAnswersMutationResult = Apollo.MutationResult<UpdateAssessmentAnswersMutation>;
export type UpdateAssessmentAnswersMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentAnswersMutation, UpdateAssessmentAnswersMutationVariables>;
export const UpdateCarrierDocument = /*#__PURE__*/ gql`
    mutation updateCarrier($input: CarrierInput!) {
  updateCarrier(input: $input) {
    id
    name
    medallionName
    parentCarrierId
    isInNetwork
  }
}
    `;
export type UpdateCarrierMutationFn = Apollo.MutationFunction<UpdateCarrierMutation, UpdateCarrierMutationVariables>;

/**
 * __useUpdateCarrierMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierMutation, { data, loading, error }] = useUpdateCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierMutation, UpdateCarrierMutationVariables>(UpdateCarrierDocument, options);
      }
export type UpdateCarrierMutationHookResult = ReturnType<typeof useUpdateCarrierMutation>;
export type UpdateCarrierMutationResult = Apollo.MutationResult<UpdateCarrierMutation>;
export type UpdateCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export const UpdateDocumentManualSyncedStatusDocument = /*#__PURE__*/ gql`
    mutation updateDocumentManualSyncedStatus($documentId: ID!, $synced: Boolean!) {
  updateDocumentManualSyncedStatus(documentId: $documentId, synced: $synced) {
    id
  }
}
    `;
export type UpdateDocumentManualSyncedStatusMutationFn = Apollo.MutationFunction<UpdateDocumentManualSyncedStatusMutation, UpdateDocumentManualSyncedStatusMutationVariables>;

/**
 * __useUpdateDocumentManualSyncedStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentManualSyncedStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentManualSyncedStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentManualSyncedStatusMutation, { data, loading, error }] = useUpdateDocumentManualSyncedStatusMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      synced: // value for 'synced'
 *   },
 * });
 */
export function useUpdateDocumentManualSyncedStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentManualSyncedStatusMutation, UpdateDocumentManualSyncedStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentManualSyncedStatusMutation, UpdateDocumentManualSyncedStatusMutationVariables>(UpdateDocumentManualSyncedStatusDocument, options);
      }
export type UpdateDocumentManualSyncedStatusMutationHookResult = ReturnType<typeof useUpdateDocumentManualSyncedStatusMutation>;
export type UpdateDocumentManualSyncedStatusMutationResult = Apollo.MutationResult<UpdateDocumentManualSyncedStatusMutation>;
export type UpdateDocumentManualSyncedStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentManualSyncedStatusMutation, UpdateDocumentManualSyncedStatusMutationVariables>;
export const UpdateDocumentUploadActionInternalDocument = /*#__PURE__*/ gql`
    mutation updateDocumentUploadActionInternal($id: ID, $actionStatus: ActionStatus, $terminationReason: String) {
  updateDocumentUploadActionInternal(
    id: $id
    actionStatus: $actionStatus
    terminationReason: $terminationReason
  ) {
    id
  }
}
    `;
export type UpdateDocumentUploadActionInternalMutationFn = Apollo.MutationFunction<UpdateDocumentUploadActionInternalMutation, UpdateDocumentUploadActionInternalMutationVariables>;

/**
 * __useUpdateDocumentUploadActionInternalMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentUploadActionInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentUploadActionInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentUploadActionInternalMutation, { data, loading, error }] = useUpdateDocumentUploadActionInternalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actionStatus: // value for 'actionStatus'
 *      terminationReason: // value for 'terminationReason'
 *   },
 * });
 */
export function useUpdateDocumentUploadActionInternalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentUploadActionInternalMutation, UpdateDocumentUploadActionInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentUploadActionInternalMutation, UpdateDocumentUploadActionInternalMutationVariables>(UpdateDocumentUploadActionInternalDocument, options);
      }
export type UpdateDocumentUploadActionInternalMutationHookResult = ReturnType<typeof useUpdateDocumentUploadActionInternalMutation>;
export type UpdateDocumentUploadActionInternalMutationResult = Apollo.MutationResult<UpdateDocumentUploadActionInternalMutation>;
export type UpdateDocumentUploadActionInternalMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentUploadActionInternalMutation, UpdateDocumentUploadActionInternalMutationVariables>;
export const UpdateDocumentUploadActionOpenSearchDocument = /*#__PURE__*/ gql`
    mutation updateDocumentUploadActionOpenSearch($sessionPatientId: ID, $actionStatus: ActionStatus) {
  updateDocumentUploadActionOpenSearch(
    sessionPatientId: $sessionPatientId
    actionStatus: $actionStatus
  ) {
    id
    actionStatus
  }
}
    `;
export type UpdateDocumentUploadActionOpenSearchMutationFn = Apollo.MutationFunction<UpdateDocumentUploadActionOpenSearchMutation, UpdateDocumentUploadActionOpenSearchMutationVariables>;

/**
 * __useUpdateDocumentUploadActionOpenSearchMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentUploadActionOpenSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentUploadActionOpenSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentUploadActionOpenSearchMutation, { data, loading, error }] = useUpdateDocumentUploadActionOpenSearchMutation({
 *   variables: {
 *      sessionPatientId: // value for 'sessionPatientId'
 *      actionStatus: // value for 'actionStatus'
 *   },
 * });
 */
export function useUpdateDocumentUploadActionOpenSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentUploadActionOpenSearchMutation, UpdateDocumentUploadActionOpenSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentUploadActionOpenSearchMutation, UpdateDocumentUploadActionOpenSearchMutationVariables>(UpdateDocumentUploadActionOpenSearchDocument, options);
      }
export type UpdateDocumentUploadActionOpenSearchMutationHookResult = ReturnType<typeof useUpdateDocumentUploadActionOpenSearchMutation>;
export type UpdateDocumentUploadActionOpenSearchMutationResult = Apollo.MutationResult<UpdateDocumentUploadActionOpenSearchMutation>;
export type UpdateDocumentUploadActionOpenSearchMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentUploadActionOpenSearchMutation, UpdateDocumentUploadActionOpenSearchMutationVariables>;
export const UpdateDocumentUploadDetailsDocument = /*#__PURE__*/ gql`
    mutation updateDocumentUploadDetails($documentId: ID, $notes: String) {
  updateDocumentUploadDetails(documentId: $documentId, notes: $notes) {
    id
    details {
      id
      notes
    }
  }
}
    `;
export type UpdateDocumentUploadDetailsMutationFn = Apollo.MutationFunction<UpdateDocumentUploadDetailsMutation, UpdateDocumentUploadDetailsMutationVariables>;

/**
 * __useUpdateDocumentUploadDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentUploadDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentUploadDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentUploadDetailsMutation, { data, loading, error }] = useUpdateDocumentUploadDetailsMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateDocumentUploadDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentUploadDetailsMutation, UpdateDocumentUploadDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentUploadDetailsMutation, UpdateDocumentUploadDetailsMutationVariables>(UpdateDocumentUploadDetailsDocument, options);
      }
export type UpdateDocumentUploadDetailsMutationHookResult = ReturnType<typeof useUpdateDocumentUploadDetailsMutation>;
export type UpdateDocumentUploadDetailsMutationResult = Apollo.MutationResult<UpdateDocumentUploadDetailsMutation>;
export type UpdateDocumentUploadDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentUploadDetailsMutation, UpdateDocumentUploadDetailsMutationVariables>;
export const UpdateDocumentUploadInternalDocument = /*#__PURE__*/ gql`
    mutation updateDocumentUploadInternal($input: DocumentUploadInternalInput) {
  updateDocumentUploadInternal(input: $input) {
    id
    ...FullPatient
  }
}
    ${FullPatientFragmentDoc}`;
export type UpdateDocumentUploadInternalMutationFn = Apollo.MutationFunction<UpdateDocumentUploadInternalMutation, UpdateDocumentUploadInternalMutationVariables>;

/**
 * __useUpdateDocumentUploadInternalMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentUploadInternalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentUploadInternalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentUploadInternalMutation, { data, loading, error }] = useUpdateDocumentUploadInternalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentUploadInternalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentUploadInternalMutation, UpdateDocumentUploadInternalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentUploadInternalMutation, UpdateDocumentUploadInternalMutationVariables>(UpdateDocumentUploadInternalDocument, options);
      }
export type UpdateDocumentUploadInternalMutationHookResult = ReturnType<typeof useUpdateDocumentUploadInternalMutation>;
export type UpdateDocumentUploadInternalMutationResult = Apollo.MutationResult<UpdateDocumentUploadInternalMutation>;
export type UpdateDocumentUploadInternalMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentUploadInternalMutation, UpdateDocumentUploadInternalMutationVariables>;
export const UpdateDocumentUploadDocument = /*#__PURE__*/ gql`
    mutation updateDocumentUpload($input: DocumentUploadInput) {
  updateDocumentUpload(input: $input) {
    id
  }
}
    `;
export type UpdateDocumentUploadMutationFn = Apollo.MutationFunction<UpdateDocumentUploadMutation, UpdateDocumentUploadMutationVariables>;

/**
 * __useUpdateDocumentUploadMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentUploadMutation, { data, loading, error }] = useUpdateDocumentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentUploadMutation, UpdateDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentUploadMutation, UpdateDocumentUploadMutationVariables>(UpdateDocumentUploadDocument, options);
      }
export type UpdateDocumentUploadMutationHookResult = ReturnType<typeof useUpdateDocumentUploadMutation>;
export type UpdateDocumentUploadMutationResult = Apollo.MutationResult<UpdateDocumentUploadMutation>;
export type UpdateDocumentUploadMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentUploadMutation, UpdateDocumentUploadMutationVariables>;
export const UpdateGoogleClickIdDocument = /*#__PURE__*/ gql`
    mutation updateGoogleClickId($googleClickId: String!) {
  updateGoogleClickId(googleClickId: $googleClickId) {
    id
  }
}
    `;
export type UpdateGoogleClickIdMutationFn = Apollo.MutationFunction<UpdateGoogleClickIdMutation, UpdateGoogleClickIdMutationVariables>;

/**
 * __useUpdateGoogleClickIdMutation__
 *
 * To run a mutation, you first call `useUpdateGoogleClickIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoogleClickIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoogleClickIdMutation, { data, loading, error }] = useUpdateGoogleClickIdMutation({
 *   variables: {
 *      googleClickId: // value for 'googleClickId'
 *   },
 * });
 */
export function useUpdateGoogleClickIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoogleClickIdMutation, UpdateGoogleClickIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoogleClickIdMutation, UpdateGoogleClickIdMutationVariables>(UpdateGoogleClickIdDocument, options);
      }
export type UpdateGoogleClickIdMutationHookResult = ReturnType<typeof useUpdateGoogleClickIdMutation>;
export type UpdateGoogleClickIdMutationResult = Apollo.MutationResult<UpdateGoogleClickIdMutation>;
export type UpdateGoogleClickIdMutationOptions = Apollo.BaseMutationOptions<UpdateGoogleClickIdMutation, UpdateGoogleClickIdMutationVariables>;
export const UpdateInsurancePayerPlanMapDocument = /*#__PURE__*/ gql`
    mutation updateInsurancePayerPlanMap($input: UpdateInsurancePayerPlanMapInput!) {
  updateInsurancePayerPlanMap(input: $input) {
    changeHealthcarePayerId
    changeHealthcarePayerName
    contractedInsuranceName
    id
    isPriority
    networkStatus
    payerName
    payerPlans
    processingPlanName
    stateCode
    subscriberIdPrefix
  }
}
    `;
export type UpdateInsurancePayerPlanMapMutationFn = Apollo.MutationFunction<UpdateInsurancePayerPlanMapMutation, UpdateInsurancePayerPlanMapMutationVariables>;

/**
 * __useUpdateInsurancePayerPlanMapMutation__
 *
 * To run a mutation, you first call `useUpdateInsurancePayerPlanMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsurancePayerPlanMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsurancePayerPlanMapMutation, { data, loading, error }] = useUpdateInsurancePayerPlanMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsurancePayerPlanMapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsurancePayerPlanMapMutation, UpdateInsurancePayerPlanMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsurancePayerPlanMapMutation, UpdateInsurancePayerPlanMapMutationVariables>(UpdateInsurancePayerPlanMapDocument, options);
      }
export type UpdateInsurancePayerPlanMapMutationHookResult = ReturnType<typeof useUpdateInsurancePayerPlanMapMutation>;
export type UpdateInsurancePayerPlanMapMutationResult = Apollo.MutationResult<UpdateInsurancePayerPlanMapMutation>;
export type UpdateInsurancePayerPlanMapMutationOptions = Apollo.BaseMutationOptions<UpdateInsurancePayerPlanMapMutation, UpdateInsurancePayerPlanMapMutationVariables>;
export const UpdatePatientConsentReferrerSharingDocument = /*#__PURE__*/ gql`
    mutation updatePatientConsentReferrerSharing($consentReferrerSharing: Boolean!) {
  updatePatientConsentReferrerSharing(
    consentReferrerSharing: $consentReferrerSharing
  ) {
    ok
  }
}
    `;
export type UpdatePatientConsentReferrerSharingMutationFn = Apollo.MutationFunction<UpdatePatientConsentReferrerSharingMutation, UpdatePatientConsentReferrerSharingMutationVariables>;

/**
 * __useUpdatePatientConsentReferrerSharingMutation__
 *
 * To run a mutation, you first call `useUpdatePatientConsentReferrerSharingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientConsentReferrerSharingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientConsentReferrerSharingMutation, { data, loading, error }] = useUpdatePatientConsentReferrerSharingMutation({
 *   variables: {
 *      consentReferrerSharing: // value for 'consentReferrerSharing'
 *   },
 * });
 */
export function useUpdatePatientConsentReferrerSharingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientConsentReferrerSharingMutation, UpdatePatientConsentReferrerSharingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientConsentReferrerSharingMutation, UpdatePatientConsentReferrerSharingMutationVariables>(UpdatePatientConsentReferrerSharingDocument, options);
      }
export type UpdatePatientConsentReferrerSharingMutationHookResult = ReturnType<typeof useUpdatePatientConsentReferrerSharingMutation>;
export type UpdatePatientConsentReferrerSharingMutationResult = Apollo.MutationResult<UpdatePatientConsentReferrerSharingMutation>;
export type UpdatePatientConsentReferrerSharingMutationOptions = Apollo.BaseMutationOptions<UpdatePatientConsentReferrerSharingMutation, UpdatePatientConsentReferrerSharingMutationVariables>;
export const UpdateProviderDocument = /*#__PURE__*/ gql`
    mutation updateProvider($input: ProviderInput!, $source: String) {
  updateProvider(input: $input, source: $source) {
    id
    calendarUrl
    firstName
    lastName
    healowCode
    primaryCredential
    isOnlineMatchingEnabled
    isOnlineSchedulingEnabled
    biography
    notes
    specialties {
      id
    }
    photo
    ageGroups {
      id
    }
    languages {
      id
    }
    treatmentMethods {
      id
    }
    providerInsuranceCarriers {
      insuranceCarrier {
        name
      }
      stateCode
    }
    isOpenToTransfers
    npDailyMax
  }
}
    `;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const UpdateReferenceInsurancePlanDocument = /*#__PURE__*/ gql`
    mutation updateReferenceInsurancePlan($input: ReferenceInsurancePlanInput!) {
  updateReferenceInsurancePlan(input: $input) {
    carrier
    plan
    inNetwork
    isReferralNeeded
    isOutOfStateNeeded
    notes
    insuranceCarrierId
  }
}
    `;
export type UpdateReferenceInsurancePlanMutationFn = Apollo.MutationFunction<UpdateReferenceInsurancePlanMutation, UpdateReferenceInsurancePlanMutationVariables>;

/**
 * __useUpdateReferenceInsurancePlanMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceInsurancePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceInsurancePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferenceInsurancePlanMutation, { data, loading, error }] = useUpdateReferenceInsurancePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReferenceInsurancePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReferenceInsurancePlanMutation, UpdateReferenceInsurancePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReferenceInsurancePlanMutation, UpdateReferenceInsurancePlanMutationVariables>(UpdateReferenceInsurancePlanDocument, options);
      }
export type UpdateReferenceInsurancePlanMutationHookResult = ReturnType<typeof useUpdateReferenceInsurancePlanMutation>;
export type UpdateReferenceInsurancePlanMutationResult = Apollo.MutationResult<UpdateReferenceInsurancePlanMutation>;
export type UpdateReferenceInsurancePlanMutationOptions = Apollo.BaseMutationOptions<UpdateReferenceInsurancePlanMutation, UpdateReferenceInsurancePlanMutationVariables>;
export const UpdatePatientDemographicsDocument = /*#__PURE__*/ gql`
    mutation updatePatientDemographics($input: PatientInput) {
  updatePatientDemographics(input: $input) {
    id
    shortCode
  }
}
    `;
export type UpdatePatientDemographicsMutationFn = Apollo.MutationFunction<UpdatePatientDemographicsMutation, UpdatePatientDemographicsMutationVariables>;

/**
 * __useUpdatePatientDemographicsMutation__
 *
 * To run a mutation, you first call `useUpdatePatientDemographicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientDemographicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientDemographicsMutation, { data, loading, error }] = useUpdatePatientDemographicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientDemographicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientDemographicsMutation, UpdatePatientDemographicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientDemographicsMutation, UpdatePatientDemographicsMutationVariables>(UpdatePatientDemographicsDocument, options);
      }
export type UpdatePatientDemographicsMutationHookResult = ReturnType<typeof useUpdatePatientDemographicsMutation>;
export type UpdatePatientDemographicsMutationResult = Apollo.MutationResult<UpdatePatientDemographicsMutation>;
export type UpdatePatientDemographicsMutationOptions = Apollo.BaseMutationOptions<UpdatePatientDemographicsMutation, UpdatePatientDemographicsMutationVariables>;
export const UpdateSettingsDocument = /*#__PURE__*/ gql`
    mutation updateSettings($input: [SettingInput!]!) {
  updateSettings(input: $input) {
    id
    category
    key
    value
  }
}
    `;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const UpdateValidatedScaleDocument = /*#__PURE__*/ gql`
    mutation updateValidatedScale($input: ValidatedScaleInput) {
  updateValidatedScale(input: $input) {
    id
  }
}
    `;
export type UpdateValidatedScaleMutationFn = Apollo.MutationFunction<UpdateValidatedScaleMutation, UpdateValidatedScaleMutationVariables>;

/**
 * __useUpdateValidatedScaleMutation__
 *
 * To run a mutation, you first call `useUpdateValidatedScaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateValidatedScaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateValidatedScaleMutation, { data, loading, error }] = useUpdateValidatedScaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateValidatedScaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateValidatedScaleMutation, UpdateValidatedScaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateValidatedScaleMutation, UpdateValidatedScaleMutationVariables>(UpdateValidatedScaleDocument, options);
      }
export type UpdateValidatedScaleMutationHookResult = ReturnType<typeof useUpdateValidatedScaleMutation>;
export type UpdateValidatedScaleMutationResult = Apollo.MutationResult<UpdateValidatedScaleMutation>;
export type UpdateValidatedScaleMutationOptions = Apollo.BaseMutationOptions<UpdateValidatedScaleMutation, UpdateValidatedScaleMutationVariables>;
export const UpdateDocumentDocument = /*#__PURE__*/ gql`
    mutation updateDocument($input: DocumentInput!) {
  updateDocument(input: $input) {
    id
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const WriteBackDemographicsDocument = /*#__PURE__*/ gql`
    mutation writeBackDemographics($input: WriteBackDemographicsInput) {
  writeBackDemographics(input: $input) {
    id
    ...PatientDemographics
    lastEntry {
      firstName
      lastName
      birthDate
      phone
      addressStreet1
      addressStreet2
      addressCity
      addressState
      addressZipCode
      email
    }
    matchesLastEntry
  }
}
    ${PatientDemographicsFragmentDoc}`;
export type WriteBackDemographicsMutationFn = Apollo.MutationFunction<WriteBackDemographicsMutation, WriteBackDemographicsMutationVariables>;

/**
 * __useWriteBackDemographicsMutation__
 *
 * To run a mutation, you first call `useWriteBackDemographicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteBackDemographicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeBackDemographicsMutation, { data, loading, error }] = useWriteBackDemographicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteBackDemographicsMutation(baseOptions?: Apollo.MutationHookOptions<WriteBackDemographicsMutation, WriteBackDemographicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteBackDemographicsMutation, WriteBackDemographicsMutationVariables>(WriteBackDemographicsDocument, options);
      }
export type WriteBackDemographicsMutationHookResult = ReturnType<typeof useWriteBackDemographicsMutation>;
export type WriteBackDemographicsMutationResult = Apollo.MutationResult<WriteBackDemographicsMutation>;
export type WriteBackDemographicsMutationOptions = Apollo.BaseMutationOptions<WriteBackDemographicsMutation, WriteBackDemographicsMutationVariables>;